/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Coworking Space CRM API
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export interface ErrorResponse {
  error: string;
}

export interface SimpleSuccess {
  success: boolean;
}

export type LeadSource = (typeof LeadSource)[keyof typeof LeadSource];

export const LeadSource = {
  organic_website: "organic_website",
  organic_whatsapp: "organic_whatsapp",
  meta_ads: "meta_ads",
  google_ads: "google_ads",
  ads_website: "ads_website",
  blog: "blog",
  walk_in: "walk_in",
  referral: "referral",
  call: "call",
  other: "other",
} as const;

export type SpaceType = (typeof SpaceType)[keyof typeof SpaceType];

export const SpaceType = {
  private_cabin: "private_cabin",
  day_pass: "day_pass",
  five_days_pass: "five_days_pass",
  seven_days_pass: "seven_days_pass",
  workstation: "workstation",
  meeting_room: "meeting_room",
  podcast_room: "podcast_room",
  conference_room: "conference_room",
  virtual_office: "virtual_office",
} as const;

export type LeadStage = (typeof LeadStage)[keyof typeof LeadStage];

export const LeadStage = {
  not_contacted: "not_contacted",
  contacted: "contacted",
  proposal_sent: "proposal_sent",
  tour_scheduled: "tour_scheduled",
  tour_done: "tour_done",
  follow_up: "follow_up",
  closed_won: "closed_won",
  closed_loss: "closed_loss",
} as const;

export type CallStatus = (typeof CallStatus)[keyof typeof CallStatus];

export const CallStatus = {
  not_started: "not_started",
  not_reachable: "not_reachable",
  not_answered: "not_answered",
  connected: "connected",
  disconnected: "disconnected",
  not_answered_1: "not_answered_1",
  not_answered_2: "not_answered_2",
  not_answered_3: "not_answered_3",
  follow_up: "follow_up",
  follow_up_1: "follow_up_1",
  follow_up_2: "follow_up_2",
  follow_up_3: "follow_up_3",
} as const;

export type Urgency = (typeof Urgency)[keyof typeof Urgency];

export const Urgency = {
  low: "low",
  medium: "medium",
  high: "high",
  immediate: "immediate",
} as const;

export type SpaceOperatingModel =
  (typeof SpaceOperatingModel)[keyof typeof SpaceOperatingModel];

export const SpaceOperatingModel = {
  COCO: "COCO",
  FOFO: "FOFO",
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserRole = {
  super_admin: "super_admin",
  admin: "admin",
  centralised_team: "centralised_team",
  agent: "agent",
  ops_lead: "ops_lead",
  front_desk: "front_desk",
  housekeeping: "housekeeping",
  bde: "bde",
} as const;

export interface User {
  id: number;
  name: string;
  whatsappNumber: string;
  role: UserRole;
  /** @nullable */
  spaceId: number | null;
  /** @nullable */
  biometricId?: string | null;
  /** @nullable */
  biometricSpaceId?: number | null;
  /** Team enable/disable (migration 0109). false = the member cannot log in and any live session is rejected. */
  active: boolean;
  /** Phase 57 D9 (57-ROLE-MAPPING.md, option-b). Per-user vendor-bill approval delegation, NOT derived from role — governs approval only below spaces.billApprovalThreshold; super_admin can always approve regardless of this flag. Settable only by an admin via PATCH /users/{id}.
   */
  canApproveBills: boolean;
}

export interface SetUserActiveBody {
  active: boolean;
}

/**
 * D-09 — operator-customizable invoice/receipt header + footer + notes
 */
export interface InvoiceTemplateConfig {
  logoUrl?: string | null;
  /** Display override for spaces.name (shared business name) */
  issuerName?: string | null;
  /** Display override for spaces.gstin */
  gstin?: string | null;
  registeredAddress?: string | null;
  contactInfo?: string | null;
  /** How the (post-payment) invoice was settled — Cash / UPI / Bank Transfer / Card / Cheque */
  paymentMode?: string | null;
  /** Shared numbered commercial terms (also shown on the receipt) */
  terms?: string[] | null;
  footer?: string | null;
  notes?: string | null;
}

/**
 * 0072 — operator-editable Order Receipt content (per space). All fields optional; the receipt route falls back to built-in Hoblix defaults.
 */
export interface ReceiptConfig {
  issuerName?: string | null;
  logoUrl?: string | null;
  gstin?: string | null;
  address?: string | null;
  upi?: string | null;
  bankAccountName?: string | null;
  bankAccountNumber?: string | null;
  bankIfsc?: string | null;
  bankName?: string | null;
  bankBranch?: string | null;
  terms?: string[] | null;
  notes?: string | null;
  /**
   * Continuous order-receipt serial starts at this number and never resets. Default 1.
   * @minimum 1
   */
  orderReceiptStartNumber?: number | null;
}

/**
 * Phase A — per-resource-type default dimensions in feet. Keys are resource_type strings (Workstation, Private_Cabin, …).
 */
export type SpaceResourceDefaults = {
  [key: string]: {
    widthFt: number;
    lengthFt: number;
  };
} | null;

export interface Space {
  id: number;
  name: string;
  city: string;
  operatingModel: SpaceOperatingModel;
  /** D-25 issuer GSTIN */
  gstin?: string | null;
  /** D-25 invoice header address */
  registeredAddress?: string | null;
  /** D-25 issuer state code, e.g. '07' for Delhi */
  stateCode?: string | null;
  invoiceTemplateConfig?: InvoiceTemplateConfig | null;
  /** Phase A — per-resource-type default dimensions in feet. Keys are resource_type strings (Workstation, Private_Cabin, …). */
  resourceDefaults?: SpaceResourceDefaults;
}

export interface UpdateSpaceBody {
  /** D-25 issuer GSTIN */
  gstin?: string | null;
  /** D-25 invoice header address */
  registeredAddress?: string | null;
  /** D-25 issuer state code, e.g. '07' for Delhi */
  stateCode?: string | null;
  invoiceTemplateConfig?: InvoiceTemplateConfig | null;
}

export interface RequestOtpBody {
  whatsappNumber: string;
}

export interface RequestOtpResponse {
  sent: boolean;
  hint: string;
}

export interface VerifyOtpBody {
  whatsappNumber: string;
  otp: string;
}

export interface AuthSession {
  token: string;
  user: User;
}

export type LeadPriority = (typeof LeadPriority)[keyof typeof LeadPriority];

export const LeadPriority = {
  low: "low",
  medium: "medium",
  high: "high",
  urgent: "urgent",
} as const;

/**
 * @nullable
 */
export type LeadObjectionType =
  | (typeof LeadObjectionType)[keyof typeof LeadObjectionType]
  | null;

export const LeadObjectionType = {
  location: "location",
  price: "price",
  other: "other",
} as const;

export interface Lead {
  id: number;
  mobileNumber: string;
  customerName: string;
  /** @nullable */
  email: string | null;
  source: LeadSource;
  leadStatus: string;
  priorityScore: number;
  priority: LeadPriority;
  numberVerified: boolean;
  spaceType: SpaceType;
  seatRangeMin: number;
  seatRangeMax: number;
  urgency: Urgency;
  location: string;
  /** @nullable */
  natureOfBusiness?: string | null;
  /** @nullable */
  objectionType?: LeadObjectionType;
  /** @nullable */
  objectionReason?: string | null;
  /** @nullable */
  expectedLocation?: string | null;
  /** @nullable */
  expectedPrice?: string | null;
  stage: LeadStage;
  followUpCount: number;
  /** @nullable */
  nextFollowUpDate: string | null;
  /** @nullable */
  followUp1Date: string | null;
  /** @nullable */
  followUp1Slot: string | null;
  /** @nullable */
  followUp2Date: string | null;
  /** @nullable */
  followUp2Slot: string | null;
  /** @nullable */
  followUp3Date: string | null;
  /** @nullable */
  followUp3Slot: string | null;
  callStatus: CallStatus;
  /** @nullable */
  campaignId: string | null;
  /** @nullable */
  callbackScheduledDate: string | null;
  /** @nullable */
  callbackScheduledSlot: string | null;
  /** @nullable */
  tourScheduledDate: string | null;
  /** @nullable */
  tourScheduledSlot: string | null;
  /** @nullable */
  tour1Date: string | null;
  /** @nullable */
  tour1Slot: string | null;
  /** @nullable */
  tour2Date: string | null;
  /** @nullable */
  tour2Slot: string | null;
  /** @nullable */
  tour3Date: string | null;
  /** @nullable */
  tour3Slot: string | null;
  spaceId: number;
  space: Space;
  /** @nullable */
  assignedToId: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface LeadActivity {
  id: number;
  leadId: number;
  actor: string;
  action: string;
  /** @nullable */
  details: string | null;
  createdAt: string;
}

export type LeadDetail = Lead & {
  activity: LeadActivity[];
};

/**
 * @nullable
 */
export type CreateLeadBodyObjectionType =
  | (typeof CreateLeadBodyObjectionType)[keyof typeof CreateLeadBodyObjectionType]
  | null;

export const CreateLeadBodyObjectionType = {
  location: "location",
  price: "price",
  other: "other",
} as const;

export interface CreateLeadBody {
  mobileNumber: string;
  customerName: string;
  /** @nullable */
  email?: string | null;
  source: LeadSource;
  leadStatus?: string;
  numberVerified?: boolean;
  spaceType: SpaceType;
  seatRangeMin: number;
  seatRangeMax: number;
  urgency: Urgency;
  location: string;
  /** @nullable */
  natureOfBusiness?: string | null;
  /** @nullable */
  objectionType?: CreateLeadBodyObjectionType;
  /** @nullable */
  objectionReason?: string | null;
  /** @nullable */
  expectedLocation?: string | null;
  /** @nullable */
  expectedPrice?: string | null;
  stage?: LeadStage;
  callStatus?: CallStatus;
  /** @nullable */
  campaignId?: string | null;
  followUpCount?: number;
  /** @nullable */
  nextFollowUpDate?: string | null;
  /** @nullable */
  followUp1Date?: string | null;
  /** @nullable */
  followUp1Slot?: string | null;
  /** @nullable */
  followUp2Date?: string | null;
  /** @nullable */
  followUp2Slot?: string | null;
  /** @nullable */
  followUp3Date?: string | null;
  /** @nullable */
  followUp3Slot?: string | null;
  /** @nullable */
  callbackScheduledDate?: string | null;
  /** @nullable */
  callbackScheduledSlot?: string | null;
  /** @nullable */
  tourScheduledDate?: string | null;
  /** @nullable */
  tourScheduledSlot?: string | null;
  /** @nullable */
  tour1Date?: string | null;
  /** @nullable */
  tour1Slot?: string | null;
  /** @nullable */
  tour2Date?: string | null;
  /** @nullable */
  tour2Slot?: string | null;
  /** @nullable */
  tour3Date?: string | null;
  /** @nullable */
  tour3Slot?: string | null;
  spaceId: number;
}

/**
 * @nullable
 */
export type UpdateLeadBodyObjectionType =
  | (typeof UpdateLeadBodyObjectionType)[keyof typeof UpdateLeadBodyObjectionType]
  | null;

export const UpdateLeadBodyObjectionType = {
  location: "location",
  price: "price",
  other: "other",
} as const;

export interface UpdateLeadBody {
  mobileNumber?: string;
  customerName?: string;
  /** @nullable */
  email?: string | null;
  source?: LeadSource;
  leadStatus?: string;
  numberVerified?: boolean;
  spaceType?: SpaceType;
  seatRangeMin?: number;
  seatRangeMax?: number;
  urgency?: Urgency;
  location?: string;
  /** @nullable */
  natureOfBusiness?: string | null;
  /** @nullable */
  objectionType?: UpdateLeadBodyObjectionType;
  /** @nullable */
  objectionReason?: string | null;
  /** @nullable */
  expectedLocation?: string | null;
  /** @nullable */
  expectedPrice?: string | null;
  stage?: LeadStage;
  callStatus?: CallStatus;
  /** @nullable */
  campaignId?: string | null;
  followUpCount?: number;
  /** @nullable */
  nextFollowUpDate?: string | null;
  /** @nullable */
  followUp1Date?: string | null;
  /** @nullable */
  followUp1Slot?: string | null;
  /** @nullable */
  followUp2Date?: string | null;
  /** @nullable */
  followUp2Slot?: string | null;
  /** @nullable */
  followUp3Date?: string | null;
  /** @nullable */
  followUp3Slot?: string | null;
  /** @nullable */
  callbackScheduledDate?: string | null;
  /** @nullable */
  callbackScheduledSlot?: string | null;
  /** @nullable */
  tourScheduledDate?: string | null;
  /** @nullable */
  tourScheduledSlot?: string | null;
  /** @nullable */
  tour1Date?: string | null;
  /** @nullable */
  tour1Slot?: string | null;
  /** @nullable */
  tour2Date?: string | null;
  /** @nullable */
  tour2Slot?: string | null;
  /** @nullable */
  tour3Date?: string | null;
  /** @nullable */
  tour3Slot?: string | null;
  spaceId?: number;
}

export type PublicCreateLeadBody = CreateLeadBody & {
  /**
   * Stable identifier from your system; enables idempotent upserts on PATCH.
   * @nullable
   */
  externalId?: string | null;
  /**
   * WhatsApp number of the agent/admin to assign. Resolved server-side.
   * @nullable
   */
  assignedToWhatsappNumber?: string | null;
};

export type PublicUpdateLeadBody = UpdateLeadBody & {
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  assignedToWhatsappNumber?: string | null;
};

export interface PublicCreateLeadResponse {
  id: number;
  /** @nullable */
  externalId?: string | null;
  priorityScore: number;
  priority: string;
}

export interface PublicUpsertLeadResponse {
  id: number;
  /** @nullable */
  externalId?: string | null;
  priorityScore: number;
  priority: string;
  /** True when this PATCH created a new lead via externalId upsert. */
  created?: boolean;
}

export interface LeadStageCount {
  stage: LeadStage;
  count: number;
}

export interface LeadSourceCount {
  source: LeadSource;
  count: number;
}

export interface FunnelStep {
  label: string;
  count: number;
  /** @nullable */
  conversionFromTotal: number | null;
}

export interface PeriodSummary {
  from: string;
  to: string;
  leadsReceived: number;
  contacted: number;
  tourScheduled: number;
  tourDone: number;
  closedWon: number;
  closedLost: number;
  funnel: FunnelStep[];
}

export interface LeadsSummary {
  total: number;
  openLeads: number;
  wonLeads: number;
  lostLeads: number;
  followUpsDueToday: number;
  callbacksDueToday: number;
  byStage: LeadStageCount[];
  bySource: LeadSourceCount[];
  period: PeriodSummary;
}

export interface LeadsListResponse {
  items: Lead[];
  total: number;
  page: number;
  pageSize: number;
}

export type StockInTransactionType =
  (typeof StockInTransactionType)[keyof typeof StockInTransactionType];

export const StockInTransactionType = {
  Purchase: "Purchase",
  Quick_Commerce_Purchase: "Quick_Commerce_Purchase",
  Direct_Purchase: "Direct_Purchase",
  Opening_Stock: "Opening_Stock",
  Member_Return: "Member_Return",
  Transfer_In: "Transfer_In",
  Sample: "Sample",
  Replacement: "Replacement",
  Daily_Purchase: "Daily_Purchase",
  Order_Delivery: "Order_Delivery",
} as const;

export type QualityStatus = (typeof QualityStatus)[keyof typeof QualityStatus];

export const QualityStatus = {
  Passed: "Passed",
  Passed_With_Notes: "Passed_With_Notes",
  Partial_Acceptance: "Partial_Acceptance",
  Rejected: "Rejected",
} as const;

export type SubstitutionReason =
  (typeof SubstitutionReason)[keyof typeof SubstitutionReason];

export const SubstitutionReason = {
  Primary_Out_Of_Stock: "Primary_Out_Of_Stock",
  Primary_Unavailable: "Primary_Unavailable",
  Better_Price_Found: "Better_Price_Found",
  Faster_Delivery: "Faster_Delivery",
  Quality_Concern: "Quality_Concern",
  Vendor_Closed: "Vendor_Closed",
  Surge_Pricing: "Surge_Pricing",
  App_Error: "App_Error",
  Other: "Other",
} as const;

export interface StockInLineItem {
  id: number;
  spaceId: number;
  stockInId: number;
  itemId: number;
  variantId?: number | null;
  quantityReceived: number;
  /** How much of quantityReceived is still in stock at entry time (back-dated receipts). NULL = add full quantityReceived; 0 = ledger-only. */
  quantityRemaining?: number | null;
  quantityOrdered?: number | null;
  quantityVariance?: number | null;
  unitPriceActual: number;
  gstAmount?: number | null;
  lineTotal?: number | null;
  batchNumber?: string | null;
  expiryDate?: string | null;
  storageLocation?: string | null;
  createdAt: string;
}

export interface StockInCharge {
  id: number;
  spaceId: number;
  stockInId: number;
  label: string;
  amount: number;
  gstRate?: number | null;
  gstAmount?: number | null;
  createdAt: string;
}

export type StockInUnlinkedItemsItem = {
  itemId?: number;
  itemName?: string | null;
  itemBrand?: string | null;
  /** Rich specs joined from inventory_items.specs JSONB (Flavour · Volume · Weight · Pack, etc., excluding Brand). Falls back to legacy brand_agnostic_specs when JSONB is empty. */
  itemSpecs?: string | null;
  variantId?: number | null;
  quantityReceived?: number;
  lineValue?: number;
};

export interface StockIn {
  id: number;
  spaceId: number;
  transactionDate: string;
  transactionType: StockInTransactionType;
  referenceNumber?: string | null;
  receivedByUserId?: number | null;
  receivedAt?: string | null;
  vendorId?: number | null;
  purchaseOrderId?: string | null;
  invoiceNumber?: string | null;
  invoiceDate?: string | null;
  invoicePdfUrl?: string | null;
  qualityStatus?: QualityStatus | null;
  qualityNotes?: string | null;
  acceptedQuantity?: number | null;
  rejectedQuantity?: number | null;
  rejectionReason?: string | null;
  subtotal?: number | null;
  totalGst?: number | null;
  deliveryCharges?: number | null;
  otherCharges?: number | null;
  discount?: number | null;
  grandTotal?: number | null;
  urgencyReason?: string | null;
  estimatedAmount?: number | null;
  orderId?: string | null;
  productSubtotal?: number | null;
  deliveryCharge?: number | null;
  handlingFee?: number | null;
  surgeFee?: number | null;
  tip?: number | null;
  discountApplied?: number | null;
  gstAmount?: number | null;
  finalPaidAmount?: number | null;
  paymentMode?: string | null;
  invoiceScreenshotUrl?: string | null;
  varianceVsEstimate?: number | null;
  surgeFlag?: string | null;
  dealFlag?: string | null;
  substitutionFlag?: string | null;
  originalVendorId?: number | null;
  substitutionReason?: SubstitutionReason | null;
  originalAttemptTime?: string | null;
  /** Internal-refill source (Phase 2.1 polish B). NULL for external receipts. */
  fromLocation?: string | null;
  /** Internal-refill destination (Phase 2.1 polish B). NULL for external receipts. */
  toLocation?: string | null;
  /** Local shop name for Daily Pickups (Phase 2.1 polish D). Free text, no FK. */
  vendorNameFreeText?: string | null;
  /** Whether input GST credit was claimed on this receipt. Phase 2.1 polish E. */
  gstInputClaimed?: boolean;
  /** Sticky flag: did the operator type unit prices as GST-inclusive on this receipt? Data-entry ergonomics only — the stored numbers (unit_price_actual = pre-GST base, gst_amount = split-out tax) are unchanged. */
  priceInclusiveGst?: boolean;
  createdAt: string;
  updatedAt: string;
  /** Count of line items on this receipt. Populated in list responses only. */
  lineItemCount?: number | null;
  /** Derived receipt lifecycle: 'Stocked' when fully complete (Save Stock-In criteria met), else 'Draft'. Computed in list responses; not stored. */
  stockStatus?: string | null;
  /** Parent PO's human-readable order_id (e.g. LEGACY-41, ORD-260530-001) when linked. Null for free-form receipts. Populated in list responses only. */
  parentOrderRef?: string | null;
  /** SUM(line_total) of receipt line items whose (item_id, variant_id) matches a cart line on the parent PO. */
  linkedAmount?: number | null;
  /** SUM(line_total) of receipt line items that DON'T match any cart line — substitutions, off-cart additions, or item_id mismatches. */
  unlinkedAmount?: number | null;
  /** Receipt line items that don't match any cart line. */
  unlinkedItems?: StockInUnlinkedItemsItem[] | null;
  /** Phase 22 — FK to stock_in_orders.id. Populated only for Order_Delivery receipts; NULL for all standalone receipts. */
  stockInOrderId?: number | null;
  lineItems?: StockInLineItem[] | null;
  charges?: StockInCharge[] | null;
}

export interface StockInListResponse {
  items: StockIn[];
  total: number;
  page: number;
  pageSize: number;
}

export type StockOutConsumptionType =
  (typeof StockOutConsumptionType)[keyof typeof StockOutConsumptionType];

export const StockOutConsumptionType = {
  Member_Free_Quota: "Member_Free_Quota",
  Member_Paid_Use: "Member_Paid_Use",
  Member_Discount_Sale: "Member_Discount_Sale",
  Member_Comp_By_Manager: "Member_Comp_By_Manager",
  Plan_Quota_Usage: "Plan_Quota_Usage",
  Member_Return: "Member_Return",
  Staff_Use: "Staff_Use",
  Wastage: "Wastage",
  Damaged: "Damaged",
  Expired: "Expired",
  Sample_Out: "Sample_Out",
  Transfer_Out: "Transfer_Out",
  Internal_Refill: "Internal_Refill",
} as const;

export type ChargingDecision =
  (typeof ChargingDecision)[keyof typeof ChargingDecision];

export const ChargingDecision = {
  Free: "Free",
  Free_Within_Quota: "Free_Within_Quota",
  Charge_Overage: "Charge_Overage",
  Charge_Full_Price: "Charge_Full_Price",
  Discount_Applied: "Discount_Applied",
  Comp_By_Manager: "Comp_By_Manager",
} as const;

export interface StockOut {
  id: number;
  spaceId: number;
  transactionDate: string;
  consumptionType: StockOutConsumptionType;
  issuedByUserId?: number | null;
  issuedFrom?: string | null;
  /** Destination for Internal_Refill (e.g. Office_Floor). Phase 2.1 polish F. */
  toLocation?: string | null;
  itemId: number;
  variantId?: number | null;
  quantityIssued: number;
  batchNumber?: string | null;
  storageLocation?: string | null;
  /** Deprecated alias for accountId (Phase 23-08 renamed the column). */
  memberId?: number | null;
  /** Billing party that consumed the item (post-Phase 23-08). */
  accountId?: number | null;
  /** Specific person on the account that consumed the item. */
  contactId?: number | null;
  memberPlan?: string | null;
  cabinNumber?: string | null;
  chargingDecision?: ChargingDecision | null;
  amountCharged?: number | null;
  gstOnCharge?: number | null;
  totalToMember?: number | null;
  paymentMethod?: string | null;
  paymentStatus?: string | null;
  invoiceReference?: string | null;
  paymentProofUrl?: string | null;
  /** UUID linking sibling rows from one multi-item Pay-Per-Use submission. */
  cartId?: string | null;
  memberChargeId?: number | null;
  memberEntitlementId?: number | null;
  reason?: string | null;
  approvedByUserId?: number | null;
  eventId?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface StockOutListResponse {
  items: StockOut[];
  total: number;
  page: number;
  pageSize: number;
}

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus];

export const InvoiceStatus = {
  Billed: "Billed",
  Paid: "Paid",
  Partial: "Partial",
  Overdue: "Overdue",
  Skipped: "Skipped",
} as const;

/**
 * D-18 — Invoice vs Receipt; drives R-/I- prefix in formatDocumentNumber()
 */
export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

export const DocumentType = {
  Invoice: "Invoice",
  Receipt: "Receipt",
} as const;

export interface Invoice {
  id: number;
  spaceId: number;
  memberId: number;
  /** R-NN/MM-YY or I-NN/MM-YY format (D-18 / D-24) */
  invoiceNumber: string;
  invoiceDate: string;
  dueDate: string;
  billingCycleStart: string;
  billingCycleEnd: string;
  subtotal: number;
  cgstTotal?: number;
  sgstTotal?: number;
  igstTotal?: number;
  total: number;
  /** D-22 partial-payment ledger */
  amountPaid: number;
  status: InvoiceStatus;
  /** D-18 */
  documentType: DocumentType;
  pdfUrl?: string | null;
  whatsappMessageSid?: string | null;
  sentAt?: string | null;
  paymentMethod?: string | null;
  transactionRef?: string | null;
  paidAt?: string | null;
  issuerGstin?: string | null;
  issuerStateCode?: string | null;
  memberState?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InvoiceListResponse {
  items: Invoice[];
  total: number;
  page: number;
  pageSize: number;
}

export type MemberChargeStatus =
  (typeof MemberChargeStatus)[keyof typeof MemberChargeStatus];

export const MemberChargeStatus = {
  Pending: "Pending",
  Disputed: "Disputed",
  Billed: "Billed",
  Paid: "Paid",
  Waived: "Waived",
} as const;

export interface MemberCharge {
  id: number;
  spaceId: number;
  memberId: number;
  transactionDate: string;
  sourceType: string;
  sourceReference?: string | null;
  description: string;
  quantity: number;
  unitPrice: number;
  subtotal: number;
  gstRate?: number | null;
  gstAmount?: number | null;
  total: number;
  billingCycle: string;
  status: MemberChargeStatus;
  invoiceReference?: string | null;
  createdAt: string;
  updatedAt: string;
  receiptNumber?: string | null;
  receiptPdfUrl?: string | null;
  receiptSentAt?: string | null;
  invoiceNumber?: string | null;
  invoicePdfUrl?: string | null;
  paymentMode?: string | null;
  paidAt?: string | null;
  paymentProofUrl?: string | null;
}

export interface MemberChargeListResponse {
  items: MemberCharge[];
  total: number;
  page: number;
  pageSize: number;
}

export type OrderReceiptRegisterItemStatus =
  (typeof OrderReceiptRegisterItemStatus)[keyof typeof OrderReceiptRegisterItemStatus];

export const OrderReceiptRegisterItemStatus = {
  Unpaid: "Unpaid",
  Partial: "Partial",
  Paid: "Paid",
} as const;

/**
 * One issued order receipt (a billing period that has a receipt number), keyed to the account.
 */
export interface OrderReceiptRegisterItem {
  /** membership_payment_periods.id — drives the receipt + mark-paid actions */
  periodId: number;
  accountId: number;
  accountName: string;
  planName?: string | null;
  receiptNumber: string;
  periodStart: string;
  periodEnd: string;
  amount: number;
  amountPaid: number;
  balance: number;
  status: OrderReceiptRegisterItemStatus;
  reminderDate?: string | null;
  receiptPdfUrl?: string | null;
  receiptSentAt?: string | null;
}

/**
 * Totals across the full filtered set (not just the current page).
 */
export interface OrderReceiptRegisterSummary {
  totalBilled: number;
  totalReceived: number;
  totalOutstanding: number;
  /** Total of receipts FULLY paid (status Paid) during the current IST calendar month, by payment date. Ignores the status/overdue chip; respects search. */
  paidThisMonth: number;
  count: number;
}

export interface OrderReceiptRegisterResponse {
  items: OrderReceiptRegisterItem[];
  total: number;
  page: number;
  pageSize: number;
  summary: OrderReceiptRegisterSummary;
}

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export const AuditAction = {
  create: "create",
  update: "update",
  delete: "delete",
  restore: "restore",
} as const;

export type InventoryAuditLogBefore = { [key: string]: unknown } | null;

export type InventoryAuditLogAfter = { [key: string]: unknown } | null;

export interface InventoryAuditLog {
  id: number;
  spaceId: number;
  tableName: string;
  recordId: number;
  action: AuditAction;
  actorUserId?: number | null;
  before?: InventoryAuditLogBefore;
  after?: InventoryAuditLogAfter;
  at: string;
}

export interface InventoryAuditLogListResponse {
  items: InventoryAuditLog[];
  total: number;
  page: number;
  pageSize: number;
}

export interface TodayTasks {
  followUps: Lead[];
  callbacks: Lead[];
  tours: Lead[];
}

export type CompleteTaskBodyTaskType =
  (typeof CompleteTaskBodyTaskType)[keyof typeof CompleteTaskBodyTaskType];

export const CompleteTaskBodyTaskType = {
  follow_up: "follow_up",
  callback: "callback",
} as const;

export interface CompleteTaskBody {
  taskType: CompleteTaskBodyTaskType;
  stage?: LeadStage;
  /** @nullable */
  note?: string | null;
}

export type RescheduleTaskBodyTaskType =
  (typeof RescheduleTaskBodyTaskType)[keyof typeof RescheduleTaskBodyTaskType];

export const RescheduleTaskBodyTaskType = {
  follow_up: "follow_up",
  callback: "callback",
} as const;

export interface RescheduleTaskBody {
  taskType: RescheduleTaskBodyTaskType;
  newTime: string;
  /** @nullable */
  note?: string | null;
}

export type BulkLeadActionBodyAction =
  (typeof BulkLeadActionBodyAction)[keyof typeof BulkLeadActionBodyAction];

export const BulkLeadActionBodyAction = {
  set_stage: "set_stage",
  set_lead_status: "set_lead_status",
  send_brochure: "send_brochure",
  send_whatsapp_template: "send_whatsapp_template",
  reassign_space: "reassign_space",
} as const;

export interface BulkLeadActionBody {
  leadIds: number[];
  action: BulkLeadActionBodyAction;
  stage?: LeadStage;
  leadStatus?: string;
  templateName?: string;
  /** Target space id for the reassign_space action (admin only). */
  targetSpaceId?: number;
}

export type BulkLeadActionResultSkippedItem = {
  leadId: number;
  reason: string;
};

export type BulkLeadActionResultFailuresItem = {
  leadId: number;
  reason: string;
};

export interface BulkLeadActionResult {
  succeeded: number;
  failed: number;
  skippedIds: number[];
  /** Skipped/failed leads with a machine-readable reason for each. Reasons include: not_found, no_access, already_in_target_space, missing_target_space, missing_stage, missing_lead_status, missing_email, brochure_send_failed:<error>, whatsapp_send_failed:<error>, exception:<Name>. */
  skipped?: BulkLeadActionResultSkippedItem[];
  failures?: BulkLeadActionResultFailuresItem[];
}

export interface ScoreRule {
  id: number;
  field: string;
  value: string;
  points: number;
  /** @nullable */
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ScoreRuleBody {
  field: string;
  value: string;
  points: number;
  /** @nullable */
  description?: string | null;
}

export interface RecalculateResult {
  updated: number;
}

export interface ApiKey {
  id: number;
  userId: number;
  label: string;
  prefix: string;
  /** @nullable */
  revokedAt: string | null;
  /** @nullable */
  lastUsedAt: string | null;
  createdAt: string;
}

export interface InviteUserBody {
  /** @minLength 1 */
  name: string;
  /**
   * @minLength 6
   * @maxLength 20
   */
  whatsappNumber: string;
  role: UserRole;
  /** @nullable */
  spaceId?: number | null;
  /** @nullable */
  biometricId?: string | null;
  /** @nullable */
  biometricSpaceId?: number | null;
}

export interface UpdateUserBody {
  /** @minLength 1 */
  name?: string;
  /** The member's WhatsApp login number. Must be unique across users. */
  whatsappNumber?: string;
  role?: UserRole;
  /** @nullable */
  spaceId?: number | null;
  /** @nullable */
  biometricId?: string | null;
  /** @nullable */
  biometricSpaceId?: number | null;
  /** Phase 57 D9 (57-ROLE-MAPPING.md, option-b). Grants/revokes this user's below-threshold vendor-bill approval right. Only reachable through requireAdmin (the same gate this endpoint already enforces) — granting approval rights is an admin act.
   */
  canApproveBills?: boolean;
}

export interface CreateApiKeyBody {
  label: string;
  /**
   * Optional target user (super_admin only). Defaults to caller.
   * @nullable
   */
  userId?: number | null;
}

export interface CreateApiKeyResult {
  apiKey: ApiKey;
  plaintextKey: string;
}

export interface LeadImport {
  id: number;
  filename: string;
  /** @nullable */
  uploadedById: number | null;
  uploadedByName: string;
  totalRows: number;
  succeededRows: number;
  failedRows: number;
  createdAt: string;
}

export interface LeadImportRowError {
  row: number;
  message: string;
}

export type LeadImportDetail = LeadImport & {
  errors: LeadImportRowError[];
};

export interface AuthEvent {
  id: number;
  whatsappNumber: string;
  /** request_otp or verify_otp */
  eventType: string;
  /** sent | delivery_failed | provider_not_configured | rate_limited | unknown_number | verified | invalid_code | invalid_format | expired | too_many_attempts | user_not_found | no_active_code | race_lost */
  outcome: string;
  isFailure: boolean;
  /** @nullable */
  error: string | null;
  createdAt: string;
}

export interface AuthEventFailureSummary {
  whatsappNumber: string;
  failedAttempts: number;
  lastAt: string;
}

export interface AuthEventsResponse {
  sinceHours: number;
  events: AuthEvent[];
  failuresByNumber: AuthEventFailureSummary[];
}

export interface UploadLeadsCsvBody {
  filename?: string;
  /** Raw CSV file contents (header row required). */
  csv: string;
}

export interface InventoryItemImport {
  id: number;
  /** @nullable */
  spaceId: number | null;
  filename: string;
  /** @nullable */
  uploadedById: number | null;
  uploadedByName: string;
  totalRows: number;
  succeededRows: number;
  failedRows: number;
  createdAt: string;
}

export interface InventoryItemImportRowError {
  row: number;
  message: string;
}

export type InventoryItemImportDetail = InventoryItemImport & {
  errors: InventoryItemImportRowError[];
};

export interface UploadInventoryItemsCsvBody {
  filename?: string;
  /** Raw CSV file contents (header row required). */
  csv: string;
}

export type BulkUpdateInventoryItemStockBodyUpdatesItem = {
  /** Item lookup key (e.g. ITM-0011). Either itemCode or
itemId is required; itemCode wins when both are set.
 */
  itemCode?: string;
  itemId?: number;
  /** ABSOLUTE on-hand quantity (not a delta). */
  currentStock: number;
};

export interface BulkUpdateInventoryItemStockBody {
  /**
   * @minItems 1
   * @maxItems 5000
   */
  updates: BulkUpdateInventoryItemStockBodyUpdatesItem[];
}

export type BulkUpdateInventoryItemStockResultErrorsItem = {
  /** 1-based row index in the submitted updates array. */
  row: number;
  itemCode?: string | null;
  itemId?: number | null;
  message: string;
};

export interface BulkUpdateInventoryItemStockResult {
  totalRows: number;
  succeededRows: number;
  failedRows: number;
  errors: BulkUpdateInventoryItemStockResultErrorsItem[];
}

export type ChargingModel = (typeof ChargingModel)[keyof typeof ChargingModel];

export const ChargingModel = {
  Complimentary_Unlimited: "Complimentary_Unlimited",
  Complimentary_With_Limit: "Complimentary_With_Limit",
  Pay_Per_Use: "Pay_Per_Use",
  Plan_Inclusive_Quota: "Plan_Inclusive_Quota",
  AddOn_Optional: "AddOn_Optional",
  Internal_Use: "Internal_Use",
} as const;

export type ReplenishmentType =
  (typeof ReplenishmentType)[keyof typeof ReplenishmentType];

export const ReplenishmentType = {
  Daily: "Daily",
  Frequency: "Frequency",
  Threshold: "Threshold",
  On_Demand: "On_Demand",
} as const;

export type StockFrequency =
  (typeof StockFrequency)[keyof typeof StockFrequency];

export const StockFrequency = {
  Daily: "Daily",
  Weekly: "Weekly",
  Monthly: "Monthly",
  On_Demand: "On_Demand",
} as const;

export type VendorStatus = (typeof VendorStatus)[keyof typeof VendorStatus];

export const VendorStatus = {
  prospect: "prospect",
  onboarding: "onboarding",
  active: "active",
  on_hold: "on_hold",
  blacklisted: "blacklisted",
  archived: "archived",
} as const;

export type VendorType = (typeof VendorType)[keyof typeof VendorType];

export const VendorType = {
  Regular: "Regular",
  Quick_Commerce: "Quick_Commerce",
  One_Time: "One_Time",
  Service: "Service",
  Online_Marketplace: "Online_Marketplace",
} as const;

export type BusinessType = (typeof BusinessType)[keyof typeof BusinessType];

export const BusinessType = {
  Proprietorship: "Proprietorship",
  Partnership: "Partnership",
  Pvt_Ltd: "Pvt_Ltd",
  LLP: "LLP",
  Individual: "Individual",
} as const;

export type ItemStatus = (typeof ItemStatus)[keyof typeof ItemStatus];

export const ItemStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
  Seasonal: "Seasonal",
} as const;

export type MemberStatus = (typeof MemberStatus)[keyof typeof MemberStatus];

export const MemberStatus = {
  Active: "Active",
  Paused: "Paused",
  Churned: "Churned",
} as const;

/**
 * Period type for plan_entitlements quota math. Phase 10 added per_visit, per_booking, per_hour
to support non-recurring passes and per-booking rooms.

 */
export type QuotaPeriod = (typeof QuotaPeriod)[keyof typeof QuotaPeriod];

export const QuotaPeriod = {
  per_day: "per_day",
  per_month: "per_month",
  per_lifetime: "per_lifetime",
  per_membership: "per_membership",
  per_visit: "per_visit",
  per_booking: "per_booking",
  per_hour: "per_hour",
} as const;

export type BillingCycle = (typeof BillingCycle)[keyof typeof BillingCycle];

export const BillingCycle = {
  daily: "daily",
  monthly: "monthly",
  quarterly: "quarterly",
  semiannual: "semiannual",
  annual: "annual",
} as const;

export type InventoryCategoryStatus =
  (typeof InventoryCategoryStatus)[keyof typeof InventoryCategoryStatus];

export const InventoryCategoryStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InventoryCategory {
  id: number;
  spaceId: number;
  name: string;
  /** Charging model for this category. (name × charging_model) is the row identity. Phase 2.1 polish C. */
  chargingModel: ChargingModel;
  budgetMonthly?: number | null;
  primaryResponsibleStaff?: string | null;
  status: InventoryCategoryStatus;
  /** Whether items in this category can be marked as recipe/prepared items. */
  allowsRecipe: boolean;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type CreateInventoryCategoryBodyStatus =
  (typeof CreateInventoryCategoryBodyStatus)[keyof typeof CreateInventoryCategoryBodyStatus];

export const CreateInventoryCategoryBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateInventoryCategoryBody {
  spaceId?: number | null;
  name: string;
  /** Charging model for this category. Phase 2.1 polish C. */
  chargingModel: ChargingModel;
  budgetMonthly?: number | null;
  primaryResponsibleStaff?: string | null;
  status?: CreateInventoryCategoryBodyStatus;
  /** Enable recipe items for this category. Defaults to false on create when omitted. */
  allowsRecipe?: boolean | null;
  notes?: string | null;
}

export type UpdateInventoryCategoryBodyStatus =
  (typeof UpdateInventoryCategoryBodyStatus)[keyof typeof UpdateInventoryCategoryBodyStatus];

export const UpdateInventoryCategoryBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateInventoryCategoryBody {
  name?: string;
  /** Charging model for this category (optional on update). Phase 2.1 polish C. */
  chargingModel?: ChargingModel;
  budgetMonthly?: number | null;
  primaryResponsibleStaff?: string | null;
  status?: UpdateInventoryCategoryBodyStatus;
  /** Enable recipe items for this category. Defaults to false on create when omitted. */
  allowsRecipe?: boolean | null;
  notes?: string | null;
}

export interface InventoryVendor {
  id: number;
  spaceId: number;
  vendorName: string;
  businessType: BusinessType;
  vendorType: VendorType;
  gstin?: string | null;
  pan?: string | null;
  msmeUdyam?: string | null;
  fssaiLicense?: string | null;
  tradeLicense?: string | null;
  officeAddress?: string | null;
  billingAddress?: string | null;
  pickupAddress?: string | null;
  pinCode?: string | null;
  city?: string | null;
  state?: string | null;
  bankName?: string | null;
  accountHolder?: string | null;
  accountNumber?: string | null;
  ifsc?: string | null;
  upiId?: string | null;
  cancelledChequeOnFile: boolean;
  defaultPaymentTerms?: string | null;
  creditLimit?: number | null;
  tdsApplicable: boolean;
  tdsRate?: number | null;
  preferredPaymentMode?: string | null;
  categoriesSupplied?: string | null;
  serviceArea?: string | null;
  standardLeadTimeDays?: number | null;
  minOrderValue?: number | null;
  returnPolicy?: string | null;
  emergencyContactAvailable: boolean;
  operatingHours?: string | null;
  status: VendorStatus;
  /** All space ids this vendor serves (computed from vendor_spaces junction). Phase 2.1 D-11. */
  spaces: number[];
  /** The primary space id (junction row with is_primary=true). Equals spaceId column. Phase 2.1 D-12. */
  primarySpaceId: number;
  createdAt: string;
  updatedAt: string;
}

export type VendorContactRole =
  (typeof VendorContactRole)[keyof typeof VendorContactRole];

export const VendorContactRole = {
  primary: "primary",
  secondary: "secondary",
  escalation: "escalation",
  other: "other",
} as const;

export interface VendorContact {
  id: number;
  spaceId: number;
  vendorId: number;
  role: VendorContactRole;
  name: string;
  designation?: string | null;
  mobile?: string | null;
  whatsapp?: string | null;
  email?: string | null;
  isPrimary: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export type VendorDocumentDocType =
  (typeof VendorDocumentDocType)[keyof typeof VendorDocumentDocType];

export const VendorDocumentDocType = {
  gst_certificate: "gst_certificate",
  pan: "pan",
  msme_udyam: "msme_udyam",
  fssai: "fssai",
  cancelled_cheque: "cancelled_cheque",
  agreement: "agreement",
  nda: "nda",
  other: "other",
} as const;

export interface VendorDocument {
  id: number;
  spaceId: number;
  vendorId: number;
  docType: VendorDocumentDocType;
  label?: string | null;
  url: string;
  uploadedAt?: string | null;
  expiresAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type InventoryVendorDetail = InventoryVendor & {
  contacts: VendorContact[];
  documents: VendorDocument[];
};

export type CreateVendorContactBodyRole =
  (typeof CreateVendorContactBodyRole)[keyof typeof CreateVendorContactBodyRole];

export const CreateVendorContactBodyRole = {
  primary: "primary",
  secondary: "secondary",
  escalation: "escalation",
  other: "other",
} as const;

export interface CreateVendorContactBody {
  role: CreateVendorContactBodyRole;
  name: string;
  designation?: string | null;
  mobile?: string | null;
  whatsapp?: string | null;
  email?: string | null;
  isPrimary?: boolean | null;
  sortOrder?: number | null;
}

export interface CreateInventoryVendorBody {
  spaceId?: number | null;
  vendorName: string;
  businessType: BusinessType;
  vendorType: VendorType;
  gstin?: string | null;
  pan?: string | null;
  msmeUdyam?: string | null;
  fssaiLicense?: string | null;
  tradeLicense?: string | null;
  officeAddress?: string | null;
  billingAddress?: string | null;
  pickupAddress?: string | null;
  pinCode?: string | null;
  city?: string | null;
  state?: string | null;
  bankName?: string | null;
  accountHolder?: string | null;
  accountNumber?: string | null;
  ifsc?: string | null;
  upiId?: string | null;
  cancelledChequeOnFile?: boolean | null;
  defaultPaymentTerms?: string | null;
  creditLimit?: number | null;
  tdsApplicable?: boolean | null;
  tdsRate?: number | null;
  preferredPaymentMode?: string | null;
  categoriesSupplied?: string | null;
  serviceArea?: string | null;
  standardLeadTimeDays?: number | null;
  minOrderValue?: number | null;
  returnPolicy?: string | null;
  emergencyContactAvailable?: boolean | null;
  operatingHours?: string | null;
  status?: VendorStatus;
  /**
   * Space ids this vendor serves (1 or more). Phase 2.1 D-14.
   * @minItems 1
   */
  spaceIds: number[];
  /** Must be one of spaceIds — server enforces. Phase 2.1 D-14. */
  primarySpaceId: number;
  contacts?: CreateVendorContactBody[] | null;
}

export interface UpdateInventoryVendorBody {
  vendorName?: string;
  businessType?: BusinessType;
  vendorType?: VendorType;
  gstin?: string | null;
  pan?: string | null;
  msmeUdyam?: string | null;
  fssaiLicense?: string | null;
  tradeLicense?: string | null;
  officeAddress?: string | null;
  billingAddress?: string | null;
  pickupAddress?: string | null;
  pinCode?: string | null;
  city?: string | null;
  state?: string | null;
  bankName?: string | null;
  accountHolder?: string | null;
  accountNumber?: string | null;
  ifsc?: string | null;
  upiId?: string | null;
  cancelledChequeOnFile?: boolean | null;
  defaultPaymentTerms?: string | null;
  creditLimit?: number | null;
  tdsApplicable?: boolean | null;
  tdsRate?: number | null;
  preferredPaymentMode?: string | null;
  categoriesSupplied?: string | null;
  serviceArea?: string | null;
  standardLeadTimeDays?: number | null;
  minOrderValue?: number | null;
  returnPolicy?: string | null;
  emergencyContactAvailable?: boolean | null;
  operatingHours?: string | null;
  status?: VendorStatus;
  /**
   * Space ids this vendor serves (optional on update; min 1 if provided). Phase 2.1 D-14.
   * @minItems 1
   */
  spaceIds?: number[];
  /** Must be one of spaceIds — server enforces (optional on update). Phase 2.1 D-14. */
  primarySpaceId?: number;
}

export type CreateVendorDocumentBodyDocType =
  (typeof CreateVendorDocumentBodyDocType)[keyof typeof CreateVendorDocumentBodyDocType];

export const CreateVendorDocumentBodyDocType = {
  gst_certificate: "gst_certificate",
  pan: "pan",
  msme_udyam: "msme_udyam",
  fssai: "fssai",
  cancelled_cheque: "cancelled_cheque",
  agreement: "agreement",
  nda: "nda",
  other: "other",
} as const;

export interface CreateVendorDocumentBody {
  docType: CreateVendorDocumentBodyDocType;
  label?: string | null;
  url: string;
  uploadedAt?: string | null;
  expiresAt?: string | null;
}

export type InventoryItemUnitOfMeasurement =
  (typeof InventoryItemUnitOfMeasurement)[keyof typeof InventoryItemUnitOfMeasurement];

export const InventoryItemUnitOfMeasurement = {
  piece: "piece",
  box: "box",
  gram: "gram",
  kg: "kg",
  ml: "ml",
  litre: "litre",
  ream: "ream",
  pack: "pack",
} as const;

/**
 * (2026-05-18) Distinguishes physical goods (Product — shakes, biscuits,
pens) from services (Service — print, scan, photocopy). Orthogonal to
isRecipe — a Service can be a recipe (Print → paper + ink) or
standalone, and a Product can also be a recipe (Maggi → noodles + milk).
Defaults to Product when not specified.

 */
export type InventoryItemItemKind =
  (typeof InventoryItemItemKind)[keyof typeof InventoryItemItemKind];

export const InventoryItemItemKind = {
  Product: "Product",
  Service: "Service",
} as const;

export type InventoryItemSpecsItem = {
  label: string;
  value: string;
};

/**
 * 2026-05-20. Unit for the stock-out basis when it is Weight (gram/kilogram) or Volume (ml/litre). Null otherwise.
 */
export type InventoryItemStockOutUnit =
  | (typeof InventoryItemStockOutUnit)[keyof typeof InventoryItemStockOutUnit]
  | null;

export const InventoryItemStockOutUnit = {
  gram: "gram",
  kilogram: "kilogram",
  ml: "ml",
  litre: "litre",
} as const;

/**
 * CONTEXT D-05 — preserved nullable for future stock-out-time picker (NOT dropped in 0019).
 */
export type InventoryItemPaymentCollection =
  | (typeof InventoryItemPaymentCollection)[keyof typeof InventoryItemPaymentCollection]
  | null;

export const InventoryItemPaymentCollection = {
  immediate: "immediate",
  monthly_invoice: "monthly_invoice",
} as const;

export type InventoryItemStorageLocation =
  | (typeof InventoryItemStorageLocation)[keyof typeof InventoryItemStorageLocation]
  | null;

export const InventoryItemStorageLocation = {
  Pantry: "Pantry",
  Store_Room: "Store_Room",
  IT_Rack: "IT_Rack",
  Cabin_Store: "Cabin_Store",
} as const;

export interface InventoryItem {
  id: number;
  spaceId: number;
  categoryId: number;
  /** 2026-05-21. When set, this item is a variant of the given parent item (own code/stock/price, inherits parent spec keys). */
  parentItemId?: number | null;
  name: string;
  brand?: string | null;
  itemCode?: string | null;
  brandAgnosticSpecs: string;
  hsnSacCode: string;
  unitOfMeasurement: InventoryItemUnitOfMeasurement;
  packSize?: number | null;
  /** (2026-05-18) Distinguishes physical goods (Product — shakes, biscuits,
pens) from services (Service — print, scan, photocopy). Orthogonal to
isRecipe — a Service can be a recipe (Print → paper + ink) or
standalone, and a Product can also be a recipe (Maggi → noodles + milk).
Defaults to Product when not specified.
 */
  itemKind?: InventoryItemItemKind;
  /**
   * 2026-05-19. 1-3 public image URLs (uploaded via POST /uploads/item-photo). Nullable on read for backward compat; Create requires 1-3.
   * @maxItems 3
   */
  photoUrls?: string[] | null;
  /** Phase 55 RECIPE-SPEC-01. Ordered free-form preparation steps for a recipe item (Cheese Maggi: 'Boil water', 'Add noodles', 'Add cheese slice', …). Array position IS the step order. Nullable — non-recipe items and recipe items without steps entered are null/absent. */
  preparationSteps?: string[] | null;
  /** 2026-05-19. Ordered list of flat attributes for a single SKU (Brand, Weight, Flavour, Composition, etc.). Defaults to []. Distinct from inventory_item_variants which is reserved for true multi-SKU products. */
  specs?: InventoryItemSpecsItem[];
  /** 2026-05-20. Basis on which stock-out / refill is measured (informational preference; no auto-conversion yet). */
  stockOutBasis?: string | null;
  /** 2026-05-20. Unit for the stock-out basis when it is Weight (gram/kilogram) or Volume (ml/litre). Null otherwise. */
  stockOutUnit?: InventoryItemStockOutUnit;
  /** 2026-05-20. Quantity value for the stock-out basis when Weight/Volume (e.g. 0.5). Drizzle numeric — string-encoded. */
  stockOutQty?: string | null;
  chargingModel: ChargingModel;
  sellingPrice?: number | null;
  memberDiscountPrice?: number | null;
  gstRateOnSale?: number | null;
  /** CONTEXT D-05 — preserved nullable for future stock-out-time picker (NOT dropped in 0019). */
  paymentCollection?: InventoryItemPaymentCollection;
  requiresPosEntry: boolean;
  overageRate?: number | null;
  inventoryTracked: boolean;
  currentStock: number;
  storageLocation?: InventoryItemStorageLocation;
  /** Phase 58 Plan 02/13 (migration 0126). The stock_locations row a sale of this item defaults to consuming from — stock-out forms pre-fill this rather than requiring a pick on every sale. Null falls back to Unassigned. */
  defaultSaleLocationId?: number | null;
  shelfLifeDays?: number | null;
  batchTracked: boolean;
  stockInFrequency: StockFrequency;
  stockOutFrequency: StockFrequency;
  reorderLevel?: number | null;
  reorderQuantity?: number | null;
  safetyStock?: number | null;
  maxStockLevel?: number | null;
  orderFrequencyDays?: number | null;
  standardOrderQty?: number | null;
  dailyQuantity?: number | null;
  status: ItemStatus;
  notes?: string | null;
  lastPurchasedDate?: string | null;
  lastPurchasedPrice?: number | null;
  /** Sum of variant.currentStock when item has variants; null otherwise. (VAR-05) */
  variantStockTotal?: string | null;
  /** True when item has at least one recipe component row. (CRM-05) */
  hasRecipe?: boolean;
  /** RECIPE-COST-01. Sum of tracked components' qtyPerServe * lastPurchasedPrice. Null when item is not a recipe, OR any tracked component has no purchase history yet. */
  recipeCostTotal?: string | null;
  /** 2026-05-19. Quantity from the most recent stock_in_line_items row. Operator hint for Reorder Quantity. */
  lastStockInQty?: string | null;
  /** 2026-05-19. Sum of stock_out quantityIssued in the last 30 days. Operator hint for Reorder Quantity (head-count-driven usage). */
  lastMonthUsage?: string | null;
  /** Maximum Retail Price (India). Display + soft-validation; may be null. */
  mrp?: number | null;
  createdAt: string;
  updatedAt: string;
}

export type CreateInventoryItemBodyUnitOfMeasurement =
  (typeof CreateInventoryItemBodyUnitOfMeasurement)[keyof typeof CreateInventoryItemBodyUnitOfMeasurement];

export const CreateInventoryItemBodyUnitOfMeasurement = {
  piece: "piece",
  box: "box",
  gram: "gram",
  kg: "kg",
  ml: "ml",
  litre: "litre",
  ream: "ream",
  pack: "pack",
} as const;

/**
 * (2026-05-18) Distinguishes physical goods (Product — shakes, biscuits,
pens) from services (Service — print, scan, photocopy). Orthogonal to
isRecipe — a Service can be a recipe (Print → paper + ink) or
standalone, and a Product can also be a recipe (Maggi → noodles + milk).
Defaults to Product when not specified.

 */
export type CreateInventoryItemBodyItemKind =
  (typeof CreateInventoryItemBodyItemKind)[keyof typeof CreateInventoryItemBodyItemKind];

export const CreateInventoryItemBodyItemKind = {
  Product: "Product",
  Service: "Service",
} as const;

export type CreateInventoryItemBodySpecsItem = {
  /** @minLength 1 */
  label: string;
  /** @minLength 1 */
  value: string;
};

/**
 * 2026-05-20. Unit when basis is Weight or Volume.
 */
export type CreateInventoryItemBodyStockOutUnit =
  | (typeof CreateInventoryItemBodyStockOutUnit)[keyof typeof CreateInventoryItemBodyStockOutUnit]
  | null;

export const CreateInventoryItemBodyStockOutUnit = {
  gram: "gram",
  kilogram: "kilogram",
  ml: "ml",
  litre: "litre",
} as const;

export type CreateInventoryItemBodyPaymentCollection =
  | (typeof CreateInventoryItemBodyPaymentCollection)[keyof typeof CreateInventoryItemBodyPaymentCollection]
  | null;

export const CreateInventoryItemBodyPaymentCollection = {
  immediate: "immediate",
  monthly_invoice: "monthly_invoice",
} as const;

export type CreateInventoryItemBodyStorageLocation =
  | (typeof CreateInventoryItemBodyStorageLocation)[keyof typeof CreateInventoryItemBodyStorageLocation]
  | null;

export const CreateInventoryItemBodyStorageLocation = {
  Pantry: "Pantry",
  Store_Room: "Store_Room",
  IT_Rack: "IT_Rack",
  Cabin_Store: "Cabin_Store",
} as const;

export type CreateItemVariantInputStatus =
  | (typeof CreateItemVariantInputStatus)[keyof typeof CreateItemVariantInputStatus]
  | null;

export const CreateItemVariantInputStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

/**
 * Variant row to insert at item-create time. Either attributeValueId OR attributeValueText must be set (or both null for a placeholder row that the server will reject via superRefine).
 */
export interface CreateItemVariantInput {
  attributeKeyId?: number | null;
  /** Existing attribute value FK. If null, set attributeValueText for inline create. */
  attributeValueId?: number | null;
  /** Text of new attribute value to create inline. Server creates the value row then links the variant. */
  attributeValueText?: string | null;
  itemCode?: string | null;
  displayName?: string | null;
  currentStock: number;
  /** Per-variant price override. NULL = inherit parent item.sellingPrice. */
  sellingPrice?: number | null;
  status?: CreateItemVariantInputStatus;
}

/**
 * Defaults to 'tracked' if omitted.
 */
export type CreateItemRecipeInputComponentsItemConsumptionMode =
  | (typeof CreateItemRecipeInputComponentsItemConsumptionMode)[keyof typeof CreateItemRecipeInputComponentsItemConsumptionMode]
  | null;

export const CreateItemRecipeInputComponentsItemConsumptionMode = {
  tracked: "tracked",
  estimated: "estimated",
} as const;

export type CreateItemRecipeInputComponentsItem = {
  componentItemId: number;
  qtyPerServe: number;
  /** Defaults to 'tracked' if omitted. */
  consumptionMode?: CreateItemRecipeInputComponentsItemConsumptionMode;
  notes?: string | null;
};

/**
 * Recipe components inserted at item-create time. Server enforces depth-1 invariant + category gating in Zod superRefine.
 */
export interface CreateItemRecipeInput {
  components: CreateItemRecipeInputComponentsItem[];
}

/**
 * Nested per-plan quota row for Complimentary_With_Limit items. POST /api/inventory/items with
chargingModel=Complimentary_With_Limit MUST include planQuotas[] with at least one element.
Each element writes one plan_entitlements row in the same atomic transaction.

 */
export interface CreateItemPlanQuotaInput {
  /** FK to inventory_plans.id */
  planId: number;
  /** Free units allowed per period (e.g., 50 prints per month). Maps to plan_entitlements.quota_quantity numeric(12,2). */
  quotaQuantity: number;
  quotaPeriod: QuotaPeriod;
  /** Per-unit price charged after free quota exhausted. Maps to plan_entitlements.overage_rate. */
  overageRate?: number | null;
}

export interface CreateInventoryItemBody {
  spaceId?: number | null;
  categoryId: number;
  /** 2026-05-21. When set, this item is a variant of the given parent item (own code/stock/price, inherits parent spec keys). */
  parentItemId?: number | null;
  name: string;
  brand?: string | null;
  itemCode?: string | null;
  brandAgnosticSpecs: string;
  hsnSacCode: string;
  unitOfMeasurement: CreateInventoryItemBodyUnitOfMeasurement;
  packSize?: number | null;
  /** (2026-05-18) Distinguishes physical goods (Product — shakes, biscuits,
pens) from services (Service — print, scan, photocopy). Orthogonal to
isRecipe — a Service can be a recipe (Print → paper + ink) or
standalone, and a Product can also be a recipe (Maggi → noodles + milk).
Defaults to Product when not specified.
 */
  itemKind?: CreateInventoryItemBodyItemKind;
  /**
   * 2026-05-19 hot-fix. REQUIRED on Create: 1-3 public image URLs (uploaded via POST /uploads/item-photo).
   * @minItems 1
   * @maxItems 3
   */
  photoUrls?: string[];
  /** Phase 55 RECIPE-SPEC-01. Optional ordered preparation steps for recipe items. Array position IS the step order. Optional even for recipe items (may be filled in later). */
  preparationSteps?: string[] | null;
  /** 2026-05-19. Optional flat attributes for the single SKU. Defaults to []. */
  specs?: CreateInventoryItemBodySpecsItem[] | null;
  /** 2026-05-20. Basis on which stock-out / refill is measured. */
  stockOutBasis?: string | null;
  /** 2026-05-20. Unit when basis is Weight or Volume. */
  stockOutUnit?: CreateInventoryItemBodyStockOutUnit;
  /** 2026-05-20. Quantity value when basis is Weight/Volume (e.g. 0.5). */
  stockOutQty?: number | null;
  chargingModel: ChargingModel;
  sellingPrice?: number | null;
  memberDiscountPrice?: number | null;
  gstRateOnSale?: number | null;
  paymentCollection?: CreateInventoryItemBodyPaymentCollection;
  requiresPosEntry?: boolean | null;
  overageRate?: number | null;
  inventoryTracked?: boolean | null;
  /** Initial stock on hand at create time, or absolute current stock on update
(operator request 2026-05-18). Optional — defaults to 0 on create; omitted
on update means no change. Useful when adding an item the operator already
has in inventory; avoids a separate Stock_In transaction. Captured in the
item-create / item-update audit log entry.
 */
  currentStock?: number | null;
  storageLocation?: CreateInventoryItemBodyStorageLocation;
  shelfLifeDays?: number | null;
  batchTracked?: boolean | null;
  stockInFrequency: StockFrequency;
  stockOutFrequency: StockFrequency;
  reorderLevel?: number | null;
  reorderQuantity?: number | null;
  safetyStock?: number | null;
  maxStockLevel?: number | null;
  orderFrequencyDays?: number | null;
  standardOrderQty?: number | null;
  dailyQuantity?: number | null;
  status?: ItemStatus;
  notes?: string | null;
  mrp?: number | null;
  /** Optional nested variant rows inserted in the same transaction as the item. */
  variants?: CreateItemVariantInput[] | null;
  /** Optional nested recipe components inserted in the same transaction. */
  recipe?: CreateItemRecipeInput | null;
  /** Per-plan quota rows for Complimentary_With_Limit items (Phase 10). Required when
chargingModel = Complimentary_With_Limit; ignored otherwise. Each element creates one
plan_entitlements row in the same atomic transaction as the inventory_items INSERT.
 */
  planQuotas?: CreateItemPlanQuotaInput[] | null;
}

export type UpdateInventoryItemBodyUnitOfMeasurement =
  (typeof UpdateInventoryItemBodyUnitOfMeasurement)[keyof typeof UpdateInventoryItemBodyUnitOfMeasurement];

export const UpdateInventoryItemBodyUnitOfMeasurement = {
  piece: "piece",
  box: "box",
  gram: "gram",
  kg: "kg",
  ml: "ml",
  litre: "litre",
  ream: "ream",
  pack: "pack",
} as const;

/**
 * (2026-05-18) Distinguishes physical goods (Product — shakes, biscuits,
pens) from services (Service — print, scan, photocopy). Orthogonal to
isRecipe — a Service can be a recipe (Print → paper + ink) or
standalone, and a Product can also be a recipe (Maggi → noodles + milk).
Defaults to Product when not specified.

 */
export type UpdateInventoryItemBodyItemKind =
  (typeof UpdateInventoryItemBodyItemKind)[keyof typeof UpdateInventoryItemBodyItemKind];

export const UpdateInventoryItemBodyItemKind = {
  Product: "Product",
  Service: "Service",
} as const;

export type UpdateInventoryItemBodySpecsItem = {
  /** @minLength 1 */
  label: string;
  /** @minLength 1 */
  value: string;
};

/**
 * 2026-05-20. Unit when basis is Weight or Volume. Omit to leave untouched.
 */
export type UpdateInventoryItemBodyStockOutUnit =
  | (typeof UpdateInventoryItemBodyStockOutUnit)[keyof typeof UpdateInventoryItemBodyStockOutUnit]
  | null;

export const UpdateInventoryItemBodyStockOutUnit = {
  gram: "gram",
  kilogram: "kilogram",
  ml: "ml",
  litre: "litre",
} as const;

/**
 * CONTEXT D-05 — preserved nullable for future stock-out-time picker.
 */
export type UpdateInventoryItemBodyPaymentCollection =
  | (typeof UpdateInventoryItemBodyPaymentCollection)[keyof typeof UpdateInventoryItemBodyPaymentCollection]
  | null;

export const UpdateInventoryItemBodyPaymentCollection = {
  immediate: "immediate",
  monthly_invoice: "monthly_invoice",
} as const;

export type UpdateInventoryItemBodyStorageLocation =
  | (typeof UpdateInventoryItemBodyStorageLocation)[keyof typeof UpdateInventoryItemBodyStorageLocation]
  | null;

export const UpdateInventoryItemBodyStorageLocation = {
  Pantry: "Pantry",
  Store_Room: "Store_Room",
  IT_Rack: "IT_Rack",
  Cabin_Store: "Cabin_Store",
} as const;

export interface UpdateInventoryItemBody {
  categoryId?: number;
  /** 2026-05-21. When set, this item is a variant of the given parent item (own code/stock/price, inherits parent spec keys). */
  parentItemId?: number | null;
  name?: string;
  brand?: string | null;
  itemCode?: string | null;
  brandAgnosticSpecs?: string;
  hsnSacCode?: string;
  unitOfMeasurement?: UpdateInventoryItemBodyUnitOfMeasurement;
  packSize?: number | null;
  /** (2026-05-18) Distinguishes physical goods (Product — shakes, biscuits,
pens) from services (Service — print, scan, photocopy). Orthogonal to
isRecipe — a Service can be a recipe (Print → paper + ink) or
standalone, and a Product can also be a recipe (Maggi → noodles + milk).
Defaults to Product when not specified.
 */
  itemKind?: UpdateInventoryItemBodyItemKind;
  /**
   * 2026-05-19 hot-fix. When set on Update, must be 1-3 URLs. Omit to leave existing photos untouched.
   * @minItems 1
   * @maxItems 3
   */
  photoUrls?: string[] | null;
  /** Phase 55 RECIPE-SPEC-01. When set, replaces the full preparation-steps array. Omit to leave untouched. Send [] to clear. */
  preparationSteps?: string[] | null;
  /** 2026-05-19. When set, replaces the full specs array. Omit to leave untouched. Send [] to clear. */
  specs?: UpdateInventoryItemBodySpecsItem[] | null;
  /** 2026-05-20. Basis on which stock-out / refill is measured. Omit to leave untouched. */
  stockOutBasis?: string | null;
  /** 2026-05-20. Unit when basis is Weight or Volume. Omit to leave untouched. */
  stockOutUnit?: UpdateInventoryItemBodyStockOutUnit;
  /** 2026-05-20. Quantity value when basis is Weight/Volume. Omit to leave untouched. */
  stockOutQty?: number | null;
  chargingModel?: ChargingModel;
  sellingPrice?: number | null;
  memberDiscountPrice?: number | null;
  gstRateOnSale?: number | null;
  /** CONTEXT D-05 — preserved nullable for future stock-out-time picker. */
  paymentCollection?: UpdateInventoryItemBodyPaymentCollection;
  requiresPosEntry?: boolean | null;
  overageRate?: number | null;
  inventoryTracked?: boolean | null;
  /** Initial stock on hand at create time, or absolute current stock on update
(operator request 2026-05-18). Optional — defaults to 0 on create; omitted
on update means no change. Useful when adding an item the operator already
has in inventory; avoids a separate Stock_In transaction. Captured in the
item-create / item-update audit log entry.
 */
  currentStock?: number | null;
  storageLocation?: UpdateInventoryItemBodyStorageLocation;
  shelfLifeDays?: number | null;
  batchTracked?: boolean | null;
  stockInFrequency?: StockFrequency;
  stockOutFrequency?: StockFrequency;
  reorderLevel?: number | null;
  reorderQuantity?: number | null;
  safetyStock?: number | null;
  maxStockLevel?: number | null;
  orderFrequencyDays?: number | null;
  standardOrderQty?: number | null;
  dailyQuantity?: number | null;
  status?: ItemStatus;
  notes?: string | null;
  mrp?: number | null;
  /** Per-plan quota rows for Complimentary_With_Limit items (Phase 10). When provided on PATCH,
handler diffs against existing plan_entitlements rows (INSERT new / UPDATE matching / DELETE removed)
in the same atomic transaction as the inventory_items UPDATE.
 */
  planQuotas?: CreateItemPlanQuotaInput[] | null;
}

export type VendorItemPricingBulkDiscountTier1 = {
  [key: string]: unknown;
} | null;

export type VendorItemPricingBulkDiscountTier2 = {
  [key: string]: unknown;
} | null;

export type VendorItemPricingStatus =
  (typeof VendorItemPricingStatus)[keyof typeof VendorItemPricingStatus];

export const VendorItemPricingStatus = {
  Active: "Active",
  Expired: "Expired",
  Discontinued: "Discontinued",
} as const;

export interface VendorItemPricing {
  id: number;
  spaceId: number;
  itemId: number;
  vendorId: number;
  vendorSku?: string | null;
  unitPrice: number;
  gstRate: number;
  priceInclusiveOfGst: boolean;
  effectiveUnitPrice: number;
  minOrderQty?: number | null;
  bulkDiscountTier1?: VendorItemPricingBulkDiscountTier1;
  bulkDiscountTier2?: VendorItemPricingBulkDiscountTier2;
  deliveryCharge?: number | null;
  deliveryTimeDays: number;
  priceValidFrom: string;
  priceValidTill: string;
  paymentTermsOverride?: string | null;
  isPreferredForItem: boolean;
  isVariablePrice: boolean;
  lastKnownPrice?: number | null;
  lastKnownDate?: string | null;
  /** Variant-specific price; null = item-level price applies to all variants. */
  variantId?: number | null;
  status: VendorItemPricingStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateVendorItemPricingBodyBulkDiscountTier1 = {
  [key: string]: unknown;
} | null;

export type CreateVendorItemPricingBodyBulkDiscountTier2 = {
  [key: string]: unknown;
} | null;

export type CreateVendorItemPricingBodyStatus =
  | (typeof CreateVendorItemPricingBodyStatus)[keyof typeof CreateVendorItemPricingBodyStatus]
  | null;

export const CreateVendorItemPricingBodyStatus = {
  Active: "Active",
  Expired: "Expired",
  Discontinued: "Discontinued",
} as const;

export interface CreateVendorItemPricingBody {
  spaceId?: number | null;
  itemId: number;
  vendorId: number;
  vendorSku?: string | null;
  unitPrice: number;
  gstRate: number;
  priceInclusiveOfGst?: boolean | null;
  minOrderQty?: number | null;
  bulkDiscountTier1?: CreateVendorItemPricingBodyBulkDiscountTier1;
  bulkDiscountTier2?: CreateVendorItemPricingBodyBulkDiscountTier2;
  deliveryCharge?: number | null;
  deliveryTimeDays: number;
  priceValidFrom: string;
  priceValidTill: string;
  paymentTermsOverride?: string | null;
  isPreferredForItem?: boolean | null;
  isVariablePrice?: boolean | null;
  /** Variant-specific price; null = item-level price applies to all variants. */
  variantId?: number | null;
  status?: CreateVendorItemPricingBodyStatus;
}

export type UpdateVendorItemPricingBodyBulkDiscountTier1 = {
  [key: string]: unknown;
} | null;

export type UpdateVendorItemPricingBodyBulkDiscountTier2 = {
  [key: string]: unknown;
} | null;

export type UpdateVendorItemPricingBodyStatus =
  | (typeof UpdateVendorItemPricingBodyStatus)[keyof typeof UpdateVendorItemPricingBodyStatus]
  | null;

export const UpdateVendorItemPricingBodyStatus = {
  Active: "Active",
  Expired: "Expired",
  Discontinued: "Discontinued",
} as const;

export interface UpdateVendorItemPricingBody {
  vendorSku?: string | null;
  unitPrice?: number;
  gstRate?: number;
  priceInclusiveOfGst?: boolean | null;
  minOrderQty?: number | null;
  bulkDiscountTier1?: UpdateVendorItemPricingBodyBulkDiscountTier1;
  bulkDiscountTier2?: UpdateVendorItemPricingBodyBulkDiscountTier2;
  deliveryCharge?: number | null;
  deliveryTimeDays?: number;
  priceValidFrom?: string;
  priceValidTill?: string;
  paymentTermsOverride?: string | null;
  isPreferredForItem?: boolean | null;
  isVariablePrice?: boolean | null;
  /** Variant-specific price; null = item-level price applies to all variants. */
  variantId?: number | null;
  status?: UpdateVendorItemPricingBodyStatus;
}

export interface VendorItemPricingHistory {
  id: number;
  spaceId: number;
  pricingId: number;
  oldPrice: number;
  newPrice: number;
  changeDate: string;
  reason?: string | null;
  changedById?: number | null;
  createdAt: string;
}

/**
 * Plan cadence. Recurring plans (Workstation, Private_Cabin) bill on monthly cycles;
Non_Recurring plans (Day_Pass, Five_Days_Pass, One_Week_Pass, Meeting/Conference/Event/Shooting)
charge per-visit or per-booking.

 */
export type InventoryPlanCadence =
  (typeof InventoryPlanCadence)[keyof typeof InventoryPlanCadence];

export const InventoryPlanCadence = {
  Recurring: "Recurring",
  Non_Recurring: "Non_Recurring",
} as const;

/**
 * Phase 21 ↔ Phase 23 link — declares the space-resource type this plan consumes.
The Convert-Lead Sheet and Booking flow filter the seat picker by this value.
NULL for plans with no space hold (Event, Shooting).

 */
export type InventoryPlanResourceType =
  | (typeof InventoryPlanResourceType)[keyof typeof InventoryPlanResourceType]
  | null;

export const InventoryPlanResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
} as const;

/**
 * Migration 0117 — unit the plan is sold/measured in. Minute (Meeting/Conference
"podcast" rooms), Hour (Event/Shooting), Day (day passes), Month (recurring).
Informational/config only in v1 — does NOT drive booking billing (that stays on
resource_pricing.paymentUnit). NULL = unspecified.

 */
export type InventoryPlanUnitType =
  | (typeof InventoryPlanUnitType)[keyof typeof InventoryPlanUnitType]
  | null;

export const InventoryPlanUnitType = {
  Minute: "Minute",
  Hour: "Hour",
  Day: "Day",
  Month: "Month",
} as const;

export type InventoryPlanStatus =
  (typeof InventoryPlanStatus)[keyof typeof InventoryPlanStatus];

export const InventoryPlanStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InventoryPlan {
  id: number;
  spaceId: number;
  planName: string;
  planTier?: number | null;
  monthlyPrice: number;
  billingCycle: BillingCycle;
  description?: string | null;
  /** Plan cadence. Recurring plans (Workstation, Private_Cabin) bill on monthly cycles;
Non_Recurring plans (Day_Pass, Five_Days_Pass, One_Week_Pass, Meeting/Conference/Event/Shooting)
charge per-visit or per-booking.
 */
  cadence: InventoryPlanCadence;
  /** For Non_Recurring fixed-window passes: number of days the pass remains valid from first use
(Day_Pass=1, Five_Days_Pass=5, One_Week_Pass=7). NULL for Recurring plans and per-booking
Non_Recurring plans.
 */
  validityDays?: number | null;
  /** Phase 21 ↔ Phase 23 link — declares the space-resource type this plan consumes.
The Convert-Lead Sheet and Booking flow filter the seat picker by this value.
NULL for plans with no space hold (Event, Shooting).
 */
  resourceType?: InventoryPlanResourceType;
  /** Migration 0117 — unit the plan is sold/measured in. Minute (Meeting/Conference
"podcast" rooms), Hour (Event/Shooting), Day (day passes), Month (recurring).
Informational/config only in v1 — does NOT drive booking billing (that stays on
resource_pricing.paymentUnit). NULL = unspecified.
 */
  unitType?: InventoryPlanUnitType;
  /** Migration 0117 — minimum commitment expressed in unitType units (e.g. 30 with
unit Minute, 1 with unit Day). Informational only.
 */
  minCommitmentValue?: number | null;
  status: InventoryPlanStatus;
  /** D-14 cadence months (1=monthly, 3=quarterly, 6=six-month) */
  durationMonths?: number | null;
  /** D-14 — collect 1mo deposit on member create */
  securityDepositRequired?: boolean;
  /** 0059 — one-time onboarding charge; default 0 */
  setupFees?: number | null;
  /** 0059 — text FK to inventory_hsn_codes (Phase 11) for GST mapping */
  hsnCode?: string | null;
  /** 0059 — false (default) = customer self-avails; true = submit a request the operator manually approves */
  requiresApproval?: boolean | null;
  /** D-14 — applied to monthlyPrice */
  discountPct?: number | null;
  /** D-23 — flat late fee */
  lateFeeAmount?: number | null;
  /** D-23 — days after due date before late fee fires */
  lateFeeAfterDays?: number | null;
  /** Per-plan tax rate override (percent). NULL inherits space default (18% baseline). */
  taxRatePct?: number | null;
  /** Freeform list of amenities dedicated to this plan (e.g., Standing Desk, Ergonomic Chair). */
  dedicatedAmenities?: string[] | null;
  /** Freeform list of amenities accessible to this plan (e.g., High-Speed WiFi). */
  commonAmenities?: string[] | null;
  /** Soft warning at Convert Lead when this plan typically requires business registration. */
  requiresBusinessRegistration?: boolean;
  /** Soft warning at Convert Lead when this plan typically requires GST registration. */
  requiresGstRegistration?: boolean;
  /** 0065 — plan bundles business registration assistance as a service */
  businessRegistrationIncluded?: boolean;
  /** 0065 — plan bundles GST registration assistance as a service */
  gstRegistrationIncluded?: boolean;
  /** 0066 — cost charged for Business Registration service */
  businessRegistrationCost?: number | null;
  /** 0066 — Day | Month | Annual */
  businessRegistrationCostPeriod?: string | null;
  /** 0066 — cost charged for GST Registration service */
  gstRegistrationCost?: number | null;
  /** 0066 — Day | Month | Annual */
  gstRegistrationCostPeriod?: string | null;
  /** 0062 — operator handles mail for members of this plan */
  mailingServiceAllowed?: boolean;
  /** 0062 — informational flag; members can book conference rooms */
  conferenceRoomAccessAllowed?: boolean;
  /** 0062 — included printing */
  complimentaryPrintAccess?: boolean;
  /** 0062 — included stationery */
  complimentaryStationary?: boolean;
  /** 0063 — informational flag; members can book meeting rooms */
  meetingRoomAccessAllowed?: boolean;
  /** 0063 — per-month conference room hours included with plan (NULL = unlimited / unspecified) */
  conferenceRoomHoursPerMonth?: number | null;
  /** 0063 — per-month meeting room hours included with plan */
  meetingRoomHoursPerMonth?: number | null;
  /** 0063 — per-month complimentary print pages allowance */
  printPagesPerMonth?: number | null;
  /** 0063 — per-month complimentary stationery items allowance */
  stationaryItemsPerMonth?: number | null;
  /** 0064 — Conference Room dynamic quota: numeric value (paired with unit + period) */
  conferenceRoomQuotaValue?: number | null;
  /** 0064 — Minutes | Hours | Days | Months */
  conferenceRoomQuotaUnit?: string | null;
  /** 0064 — Day | Month */
  conferenceRoomQuotaPeriod?: string | null;
  meetingRoomQuotaValue?: number | null;
  meetingRoomQuotaUnit?: string | null;
  meetingRoomQuotaPeriod?: string | null;
  /** 0064 — Black print complimentary pages / period */
  blackPrintPages?: number | null;
  /** 0064 — Price per page for B&W overage */
  blackPrintOverageRate?: number | null;
  /** 0064 — Colour print complimentary pages / period */
  colorPrintPages?: number | null;
  /** 0064 — Price per page for Colour overage */
  colorPrintOverageRate?: number | null;
  /** 0067 — Black/White print sub-toggle */
  blackPrintEnabled?: boolean;
  /** 0067 — Colour print sub-toggle */
  colorPrintEnabled?: boolean;
  /** When true (AND status=Active), plan appears in GET /public/plans response. */
  showOnWebsite?: boolean;
  /** Informational only (no hard gate in v1) — surfaces as warning in Convert Lead Sheet. */
  minimumCommitmentMonths?: number | null;
  /** Plan-level deposit amount (paired with securityDepositRequired bool). Period overrides replace this when set. */
  securityDepositAmount?: number | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Plan cadence. Recurring plans (Workstation, Private_Cabin) bill on monthly cycles;
Non_Recurring plans (Day_Pass, Five_Days_Pass, One_Week_Pass, Meeting/Conference/Event/Shooting)
charge per-visit or per-booking.

 */
export type CreateInventoryPlanBodyCadence =
  (typeof CreateInventoryPlanBodyCadence)[keyof typeof CreateInventoryPlanBodyCadence];

export const CreateInventoryPlanBodyCadence = {
  Recurring: "Recurring",
  Non_Recurring: "Non_Recurring",
} as const;

/**
 * Phase 21 ↔ Phase 23 link — space-resource type this plan consumes; NULL for Event/Shooting
 */
export type CreateInventoryPlanBodyResourceType =
  | (typeof CreateInventoryPlanBodyResourceType)[keyof typeof CreateInventoryPlanBodyResourceType]
  | null;

export const CreateInventoryPlanBodyResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
} as const;

/**
 * Migration 0117 — unit the plan is sold/measured in (Minute/Hour/Day/Month). Informational/config only.
 */
export type CreateInventoryPlanBodyUnitType =
  | (typeof CreateInventoryPlanBodyUnitType)[keyof typeof CreateInventoryPlanBodyUnitType]
  | null;

export const CreateInventoryPlanBodyUnitType = {
  Minute: "Minute",
  Hour: "Hour",
  Day: "Day",
  Month: "Month",
} as const;

export type CreateInventoryPlanBodyStatus =
  | (typeof CreateInventoryPlanBodyStatus)[keyof typeof CreateInventoryPlanBodyStatus]
  | null;

export const CreateInventoryPlanBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateInventoryPlanBody {
  spaceId?: number | null;
  planName: string;
  planTier?: number | null;
  monthlyPrice: number;
  billingCycle?: BillingCycle;
  description?: string | null;
  /** Plan cadence. Recurring plans (Workstation, Private_Cabin) bill on monthly cycles;
Non_Recurring plans (Day_Pass, Five_Days_Pass, One_Week_Pass, Meeting/Conference/Event/Shooting)
charge per-visit or per-booking.
 */
  cadence: CreateInventoryPlanBodyCadence;
  /** For Non_Recurring fixed-window passes: number of days the pass remains valid from first use
(Day_Pass=1, Five_Days_Pass=5, One_Week_Pass=7). NULL for Recurring plans and per-booking
Non_Recurring plans.
 */
  validityDays?: number | null;
  /** Phase 21 ↔ Phase 23 link — space-resource type this plan consumes; NULL for Event/Shooting */
  resourceType?: CreateInventoryPlanBodyResourceType;
  /** Migration 0117 — unit the plan is sold/measured in (Minute/Hour/Day/Month). Informational/config only. */
  unitType?: CreateInventoryPlanBodyUnitType;
  /** Migration 0117 — minimum commitment in unitType units. Informational only. */
  minCommitmentValue?: number | null;
  status?: CreateInventoryPlanBodyStatus;
  /** D-14 cadence months (1=monthly, 3=quarterly, 6=six-month) */
  durationMonths?: number | null;
  /** D-14 — collect 1mo deposit on member create */
  securityDepositRequired?: boolean | null;
  /** 0059 — one-time onboarding charge; default 0 */
  setupFees?: number | null;
  /** 0059 — text FK to inventory_hsn_codes (Phase 11) for GST mapping */
  hsnCode?: string | null;
  /** 0059 — false (default) = customer self-avails; true = submit a request the operator manually approves */
  requiresApproval?: boolean | null;
  /** D-14 — applied to monthlyPrice */
  discountPct?: number | null;
  /** D-23 — flat late fee */
  lateFeeAmount?: number | null;
  /** D-23 — days after due date before late fee fires */
  lateFeeAfterDays?: number | null;
  /** Per-plan tax rate override (percent). NULL inherits space default (18% baseline). */
  taxRatePct?: number | null;
  /** Freeform list of amenities dedicated to this plan (e.g., Standing Desk, Ergonomic Chair). */
  dedicatedAmenities?: string[] | null;
  /** Freeform list of amenities accessible to this plan (e.g., High-Speed WiFi). */
  commonAmenities?: string[] | null;
  /** Soft warning at Convert Lead when this plan typically requires business registration. */
  requiresBusinessRegistration?: boolean | null;
  /** Soft warning at Convert Lead when this plan typically requires GST registration. */
  requiresGstRegistration?: boolean | null;
  /** 0065 — plan bundles business registration assistance as a service */
  businessRegistrationIncluded?: boolean | null;
  /** 0065 — plan bundles GST registration assistance as a service */
  gstRegistrationIncluded?: boolean | null;
  /** 0066 — cost charged for Business Registration service */
  businessRegistrationCost?: number | null;
  /** 0066 — Day | Month | Annual */
  businessRegistrationCostPeriod?: string | null;
  /** 0066 — cost charged for GST Registration service */
  gstRegistrationCost?: number | null;
  /** 0066 — Day | Month | Annual */
  gstRegistrationCostPeriod?: string | null;
  /** 0062 — operator handles mail for members of this plan */
  mailingServiceAllowed?: boolean | null;
  /** 0062 — informational flag; members can book conference rooms */
  conferenceRoomAccessAllowed?: boolean | null;
  /** 0062 — included printing */
  complimentaryPrintAccess?: boolean | null;
  /** 0062 — included stationery */
  complimentaryStationary?: boolean | null;
  /** 0063 — informational flag; members can book meeting rooms */
  meetingRoomAccessAllowed?: boolean | null;
  /** 0063 — per-month conference room hours included with plan */
  conferenceRoomHoursPerMonth?: number | null;
  /** 0063 — per-month meeting room hours included with plan */
  meetingRoomHoursPerMonth?: number | null;
  /** 0063 — per-month complimentary print pages allowance */
  printPagesPerMonth?: number | null;
  /** 0063 — per-month complimentary stationery items allowance */
  stationaryItemsPerMonth?: number | null;
  /** 0064 — Conference Room dynamic quota: numeric value (paired with unit + period) */
  conferenceRoomQuotaValue?: number | null;
  /** 0064 — Minutes | Hours | Days | Months */
  conferenceRoomQuotaUnit?: string | null;
  /** 0064 — Day | Month */
  conferenceRoomQuotaPeriod?: string | null;
  meetingRoomQuotaValue?: number | null;
  meetingRoomQuotaUnit?: string | null;
  meetingRoomQuotaPeriod?: string | null;
  /** 0064 — Black print complimentary pages / period */
  blackPrintPages?: number | null;
  /** 0064 — Price per page for B&W overage */
  blackPrintOverageRate?: number | null;
  /** 0064 — Colour print complimentary pages / period */
  colorPrintPages?: number | null;
  /** 0064 — Price per page for Colour overage */
  colorPrintOverageRate?: number | null;
  /** 0067 — Black/White print sub-toggle */
  blackPrintEnabled?: boolean;
  /** 0067 — Colour print sub-toggle */
  colorPrintEnabled?: boolean;
  /** When true (AND status=Active), plan appears in GET /public/plans response. */
  showOnWebsite?: boolean | null;
  /** Informational only (no hard gate in v1) — surfaces as warning in Convert Lead Sheet. */
  minimumCommitmentMonths?: number | null;
  /** Plan-level deposit amount (paired with securityDepositRequired bool). Period overrides replace this when set. */
  securityDepositAmount?: number | null;
}

export interface ChangeInventoryPlanPriceBody {
  /** New monthly price. Must be >= the plan's current monthly_price. */
  newPrice: number;
  /** Optional note explaining the change (stored on the history row). */
  reason?: string | null;
}

export interface InventoryPlanPriceHistoryEntry {
  id: number;
  spaceId: number;
  planId: number;
  oldPrice: number;
  newPrice: number;
  changeDate: string;
  reason?: string | null;
  changedById?: number | null;
  /** Display name of the user who made the change (joined from users). */
  changedByName?: string | null;
  createdAt: string;
}

/**
 * Plan cadence. Optional on PATCH — only sent when operator explicitly switches the plan's cadence.

 */
export type UpdateInventoryPlanBodyCadence =
  (typeof UpdateInventoryPlanBodyCadence)[keyof typeof UpdateInventoryPlanBodyCadence];

export const UpdateInventoryPlanBodyCadence = {
  Recurring: "Recurring",
  Non_Recurring: "Non_Recurring",
} as const;

/**
 * Phase 21 ↔ Phase 23 link — space-resource type this plan consumes; NULL for Event/Shooting
 */
export type UpdateInventoryPlanBodyResourceType =
  | (typeof UpdateInventoryPlanBodyResourceType)[keyof typeof UpdateInventoryPlanBodyResourceType]
  | null;

export const UpdateInventoryPlanBodyResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
} as const;

/**
 * Migration 0117 — unit the plan is sold/measured in (Minute/Hour/Day/Month). Informational/config only.
 */
export type UpdateInventoryPlanBodyUnitType =
  | (typeof UpdateInventoryPlanBodyUnitType)[keyof typeof UpdateInventoryPlanBodyUnitType]
  | null;

export const UpdateInventoryPlanBodyUnitType = {
  Minute: "Minute",
  Hour: "Hour",
  Day: "Day",
  Month: "Month",
} as const;

export type UpdateInventoryPlanBodyStatus =
  | (typeof UpdateInventoryPlanBodyStatus)[keyof typeof UpdateInventoryPlanBodyStatus]
  | null;

export const UpdateInventoryPlanBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateInventoryPlanBody {
  planName?: string;
  planTier?: number | null;
  monthlyPrice?: number;
  billingCycle?: BillingCycle;
  description?: string | null;
  /** Plan cadence. Optional on PATCH — only sent when operator explicitly switches the plan's cadence.
   */
  cadence?: UpdateInventoryPlanBodyCadence;
  /** For Non_Recurring fixed-window passes: number of days the pass remains valid from first use.
NULL for Recurring plans and per-booking Non_Recurring plans.
 */
  validityDays?: number | null;
  /** Phase 21 ↔ Phase 23 link — space-resource type this plan consumes; NULL for Event/Shooting */
  resourceType?: UpdateInventoryPlanBodyResourceType;
  /** Migration 0117 — unit the plan is sold/measured in (Minute/Hour/Day/Month). Informational/config only. */
  unitType?: UpdateInventoryPlanBodyUnitType;
  /** Migration 0117 — minimum commitment in unitType units. Informational only. */
  minCommitmentValue?: number | null;
  status?: UpdateInventoryPlanBodyStatus;
  /** D-14 cadence months (1=monthly, 3=quarterly, 6=six-month) */
  durationMonths?: number | null;
  /** D-14 — collect 1mo deposit on member create */
  securityDepositRequired?: boolean | null;
  /** 0059 — one-time onboarding charge; default 0 */
  setupFees?: number | null;
  /** 0059 — text FK to inventory_hsn_codes (Phase 11) for GST mapping */
  hsnCode?: string | null;
  /** 0059 — false (default) = customer self-avails; true = submit a request the operator manually approves */
  requiresApproval?: boolean | null;
  /** D-14 — applied to monthlyPrice */
  discountPct?: number | null;
  /** D-23 — flat late fee */
  lateFeeAmount?: number | null;
  /** D-23 — days after due date before late fee fires */
  lateFeeAfterDays?: number | null;
  /** Per-plan tax rate override (percent). NULL inherits space default (18% baseline). */
  taxRatePct?: number | null;
  /** Freeform list of amenities dedicated to this plan (e.g., Standing Desk, Ergonomic Chair). */
  dedicatedAmenities?: string[] | null;
  /** Freeform list of amenities accessible to this plan (e.g., High-Speed WiFi). */
  commonAmenities?: string[] | null;
  /** Soft warning at Convert Lead when this plan typically requires business registration. */
  requiresBusinessRegistration?: boolean | null;
  /** Soft warning at Convert Lead when this plan typically requires GST registration. */
  requiresGstRegistration?: boolean | null;
  /** 0065 — plan bundles business registration assistance as a service */
  businessRegistrationIncluded?: boolean | null;
  /** 0065 — plan bundles GST registration assistance as a service */
  gstRegistrationIncluded?: boolean | null;
  /** 0066 — cost charged for Business Registration service */
  businessRegistrationCost?: number | null;
  /** 0066 — Day | Month | Annual */
  businessRegistrationCostPeriod?: string | null;
  /** 0066 — cost charged for GST Registration service */
  gstRegistrationCost?: number | null;
  /** 0066 — Day | Month | Annual */
  gstRegistrationCostPeriod?: string | null;
  /** 0062 — operator handles mail for members of this plan */
  mailingServiceAllowed?: boolean | null;
  /** 0062 — informational flag; members can book conference rooms */
  conferenceRoomAccessAllowed?: boolean | null;
  /** 0062 — included printing */
  complimentaryPrintAccess?: boolean | null;
  /** 0062 — included stationery */
  complimentaryStationary?: boolean | null;
  /** 0063 — informational flag; members can book meeting rooms */
  meetingRoomAccessAllowed?: boolean | null;
  /** 0063 — per-month conference room hours included with plan */
  conferenceRoomHoursPerMonth?: number | null;
  /** 0063 — per-month meeting room hours included with plan */
  meetingRoomHoursPerMonth?: number | null;
  /** 0063 — per-month complimentary print pages allowance */
  printPagesPerMonth?: number | null;
  /** 0063 — per-month complimentary stationery items allowance */
  stationaryItemsPerMonth?: number | null;
  /** 0064 — Conference Room dynamic quota: numeric value (paired with unit + period) */
  conferenceRoomQuotaValue?: number | null;
  /** 0064 — Minutes | Hours | Days | Months */
  conferenceRoomQuotaUnit?: string | null;
  /** 0064 — Day | Month */
  conferenceRoomQuotaPeriod?: string | null;
  meetingRoomQuotaValue?: number | null;
  meetingRoomQuotaUnit?: string | null;
  meetingRoomQuotaPeriod?: string | null;
  /** 0064 — Black print complimentary pages / period */
  blackPrintPages?: number | null;
  /** 0064 — Price per page for B&W overage */
  blackPrintOverageRate?: number | null;
  /** 0064 — Colour print complimentary pages / period */
  colorPrintPages?: number | null;
  /** 0064 — Price per page for Colour overage */
  colorPrintOverageRate?: number | null;
  /** 0067 — Black/White print sub-toggle */
  blackPrintEnabled?: boolean;
  /** 0067 — Colour print sub-toggle */
  colorPrintEnabled?: boolean;
  /** When true (AND status=Active), plan appears in GET /public/plans response. */
  showOnWebsite?: boolean | null;
  /** Informational only (no hard gate in v1) — surfaces as warning in Convert Lead Sheet. */
  minimumCommitmentMonths?: number | null;
  /** Plan-level deposit amount (paired with securityDepositRequired bool). Period overrides replace this when set. */
  securityDepositAmount?: number | null;
}

export interface PlanEntitlement {
  id: number;
  spaceId: number;
  planId: number;
  itemId: number;
  quotaQuantity: number;
  quotaPeriod: QuotaPeriod;
  overageRate?: number | null;
  carryForward: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePlanEntitlementBody {
  spaceId?: number | null;
  planId: number;
  itemId: number;
  quotaQuantity: number;
  quotaPeriod: QuotaPeriod;
  overageRate?: number | null;
  carryForward?: boolean | null;
}

export interface UpdatePlanEntitlementBody {
  quotaQuantity?: number;
  quotaPeriod?: QuotaPeriod;
  overageRate?: number | null;
  carryForward?: boolean | null;
}

export type AccountKind = (typeof AccountKind)[keyof typeof AccountKind];

export const AccountKind = {
  member: "member",
  walk_in: "walk_in",
} as const;

export type AccountType = (typeof AccountType)[keyof typeof AccountType];

export const AccountType = {
  individual: "individual",
  company: "company",
} as const;

/**
 * Sub-type for company accounts; NULL for individual
 */
export type AccountCompanyType =
  | (typeof AccountCompanyType)[keyof typeof AccountCompanyType]
  | null;

export const AccountCompanyType = {
  Private_Limited: "Private_Limited",
  Public_Limited: "Public_Limited",
  LLP: "LLP",
  Partnership: "Partnership",
  Sole_Proprietorship: "Sole_Proprietorship",
  One_Person_Company: "One_Person_Company",
  Other: "Other",
} as const;

export type AccountGstTreatment =
  (typeof AccountGstTreatment)[keyof typeof AccountGstTreatment];

export const AccountGstTreatment = {
  registered_b2b: "registered_b2b",
  unregistered_b2c: "unregistered_b2c",
} as const;

export type AccountPriceModeDefault =
  (typeof AccountPriceModeDefault)[keyof typeof AccountPriceModeDefault];

export const AccountPriceModeDefault = {
  exclusive: "exclusive",
  inclusive: "inclusive",
} as const;

export type AccountStatus = (typeof AccountStatus)[keyof typeof AccountStatus];

export const AccountStatus = {
  active: "active",
  merged: "merged",
} as const;

export interface Account {
  id: number;
  spaceId: number;
  /** True for the internal Hoblix house account */
  isInternal?: boolean;
  kind: AccountKind;
  type: AccountType;
  /** Sub-type for company accounts; NULL for individual */
  companyType?: AccountCompanyType;
  legalName: string;
  gstTreatment: AccountGstTreatment;
  gstin?: string | null;
  /** State code e.g. '07' Delhi, '06' Haryana */
  placeOfSupply: string;
  billingAddress?: string | null;
  /** 6-digit Indian pincode (drives city/state autofetch in the UI) */
  pincode?: string | null;
  city?: string | null;
  /** Full state name (place_of_supply still holds the 2-digit GST code) */
  state?: string | null;
  billingEmail?: string | null;
  billingPhone?: string | null;
  priceModeDefault: AccountPriceModeDefault;
  status: AccountStatus;
  mergedIntoId?: number | null;
  convertedFromLeadId?: number | null;
  createdAt: string;
  updatedAt: string;
}

export type CreateAccountBodyKind =
  (typeof CreateAccountBodyKind)[keyof typeof CreateAccountBodyKind];

export const CreateAccountBodyKind = {
  member: "member",
  walk_in: "walk_in",
} as const;

export type CreateAccountBodyType =
  (typeof CreateAccountBodyType)[keyof typeof CreateAccountBodyType];

export const CreateAccountBodyType = {
  individual: "individual",
  company: "company",
} as const;

/**
 * Sub-type for company accounts; NULL for individual
 */
export type CreateAccountBodyCompanyType =
  | (typeof CreateAccountBodyCompanyType)[keyof typeof CreateAccountBodyCompanyType]
  | null;

export const CreateAccountBodyCompanyType = {
  Private_Limited: "Private_Limited",
  Public_Limited: "Public_Limited",
  LLP: "LLP",
  Partnership: "Partnership",
  Sole_Proprietorship: "Sole_Proprietorship",
  One_Person_Company: "One_Person_Company",
  Other: "Other",
} as const;

export type CreateAccountBodyGstTreatment =
  (typeof CreateAccountBodyGstTreatment)[keyof typeof CreateAccountBodyGstTreatment];

export const CreateAccountBodyGstTreatment = {
  registered_b2b: "registered_b2b",
  unregistered_b2c: "unregistered_b2c",
} as const;

export type CreateAccountBodyPriceModeDefault =
  (typeof CreateAccountBodyPriceModeDefault)[keyof typeof CreateAccountBodyPriceModeDefault];

export const CreateAccountBodyPriceModeDefault = {
  exclusive: "exclusive",
  inclusive: "inclusive",
} as const;

export interface CreateAccountBody {
  /** @minLength 1 */
  legalName: string;
  kind: CreateAccountBodyKind;
  type?: CreateAccountBodyType;
  /** Set true to create the internal Hoblix house account */
  isInternal?: boolean;
  /** Sub-type for company accounts; NULL for individual */
  companyType?: CreateAccountBodyCompanyType;
  gstTreatment: CreateAccountBodyGstTreatment;
  /** Required iff gstTreatment=registered_b2b — superRefine on server */
  gstin?: string | null;
  /** State code e.g. '07' Delhi, '06' Haryana */
  placeOfSupply: string;
  billingAddress?: string | null;
  pincode?: string | null;
  city?: string | null;
  state?: string | null;
  billingEmail?: string | null;
  billingPhone?: string | null;
  priceModeDefault?: CreateAccountBodyPriceModeDefault;
  convertedFromLeadId?: number | null;
}

export type UpdateAccountBodyKind =
  (typeof UpdateAccountBodyKind)[keyof typeof UpdateAccountBodyKind];

export const UpdateAccountBodyKind = {
  member: "member",
  walk_in: "walk_in",
} as const;

export type UpdateAccountBodyType =
  (typeof UpdateAccountBodyType)[keyof typeof UpdateAccountBodyType];

export const UpdateAccountBodyType = {
  individual: "individual",
  company: "company",
} as const;

/**
 * Sub-type for company accounts; NULL for individual
 */
export type UpdateAccountBodyCompanyType =
  | (typeof UpdateAccountBodyCompanyType)[keyof typeof UpdateAccountBodyCompanyType]
  | null;

export const UpdateAccountBodyCompanyType = {
  Private_Limited: "Private_Limited",
  Public_Limited: "Public_Limited",
  LLP: "LLP",
  Partnership: "Partnership",
  Sole_Proprietorship: "Sole_Proprietorship",
  One_Person_Company: "One_Person_Company",
  Other: "Other",
} as const;

export type UpdateAccountBodyGstTreatment =
  (typeof UpdateAccountBodyGstTreatment)[keyof typeof UpdateAccountBodyGstTreatment];

export const UpdateAccountBodyGstTreatment = {
  registered_b2b: "registered_b2b",
  unregistered_b2c: "unregistered_b2c",
} as const;

export type UpdateAccountBodyPriceModeDefault =
  (typeof UpdateAccountBodyPriceModeDefault)[keyof typeof UpdateAccountBodyPriceModeDefault];

export const UpdateAccountBodyPriceModeDefault = {
  exclusive: "exclusive",
  inclusive: "inclusive",
} as const;

/**
 * PATCH partial-update — all fields optional
 */
export interface UpdateAccountBody {
  /** @minLength 1 */
  legalName?: string;
  kind?: UpdateAccountBodyKind;
  type?: UpdateAccountBodyType;
  /** Sub-type for company accounts; NULL for individual */
  companyType?: UpdateAccountBodyCompanyType;
  gstTreatment?: UpdateAccountBodyGstTreatment;
  gstin?: string | null;
  placeOfSupply?: string;
  billingAddress?: string | null;
  pincode?: string | null;
  city?: string | null;
  state?: string | null;
  billingEmail?: string | null;
  billingPhone?: string | null;
  priceModeDefault?: UpdateAccountBodyPriceModeDefault;
  convertedFromLeadId?: number | null;
}

export type ContactRolesItem =
  (typeof ContactRolesItem)[keyof typeof ContactRolesItem];

export const ContactRolesItem = {
  primary: "primary",
  billing: "billing",
  user: "user",
} as const;

export type ContactIdProofType =
  | (typeof ContactIdProofType)[keyof typeof ContactIdProofType]
  | null;

export const ContactIdProofType = {
  PAN: "PAN",
  DL: "DL",
  Passport: "Passport",
  Aadhaar: "Aadhaar",
} as const;

export type ContactStatus = (typeof ContactStatus)[keyof typeof ContactStatus];

export const ContactStatus = {
  active: "active",
  exited: "exited",
} as const;

export interface Contact {
  id: number;
  spaceId: number;
  accountId: number;
  fullName: string;
  phone: string;
  email?: string | null;
  roles: ContactRolesItem[];
  idProofType?: ContactIdProofType;
  idProofRef?: string | null;
  /** Biometric enrollment ID granting entry and conference-room access */
  biometricId?: string | null;
  /** Full UPI VPA, operator-typed. Used to match Pine Labs POS payments to this member (58-SOURCE-DATA.md §2). */
  upiVpa?: string | null;
  /** Derived server-side from upiVpa via maskVpa() — never typed directly. The masked form ('79**********@ybl') a Pine Labs export will carry for this member. */
  readonly upiVpaMasked?: string | null;
  photoUrl?: string | null;
  status: ContactStatus;
  dateOfBirth?: string | null;
  joinedAt?: string | null;
  exitedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type ContactWithAccountRolesItem =
  (typeof ContactWithAccountRolesItem)[keyof typeof ContactWithAccountRolesItem];

export const ContactWithAccountRolesItem = {
  primary: "primary",
  billing: "billing",
  user: "user",
} as const;

export type ContactWithAccountStatus =
  (typeof ContactWithAccountStatus)[keyof typeof ContactWithAccountStatus];

export const ContactWithAccountStatus = {
  active: "active",
  exited: "exited",
} as const;

export type ContactWithAccountAccountType =
  (typeof ContactWithAccountAccountType)[keyof typeof ContactWithAccountAccountType];

export const ContactWithAccountAccountType = {
  individual: "individual",
  company: "company",
} as const;

export interface ContactWithAccount {
  id: number;
  spaceId: number;
  accountId: number;
  fullName: string;
  phone: string;
  email?: string | null;
  roles: ContactWithAccountRolesItem[];
  status: ContactWithAccountStatus;
  createdAt: string;
  updatedAt: string;
  /** Joined from the parent account row for picker UIs */
  accountLegalName: string;
  accountBillingPhone?: string | null;
  accountType?: ContactWithAccountAccountType;
}

export type ContactDirectoryRowRolesItem =
  (typeof ContactDirectoryRowRolesItem)[keyof typeof ContactDirectoryRowRolesItem];

export const ContactDirectoryRowRolesItem = {
  primary: "primary",
  billing: "billing",
  user: "user",
} as const;

export type ContactDirectoryRowStatus =
  (typeof ContactDirectoryRowStatus)[keyof typeof ContactDirectoryRowStatus];

export const ContactDirectoryRowStatus = {
  active: "active",
  exited: "exited",
} as const;

export type ContactDirectoryRowAccountType =
  (typeof ContactDirectoryRowAccountType)[keyof typeof ContactDirectoryRowAccountType];

export const ContactDirectoryRowAccountType = {
  individual: "individual",
  company: "company",
} as const;

/**
 * Phase 37 Member directory row — superset of the base contact fields, additive/ignored by existing callers (stock-out picker, contact-combobox).
 */
export interface ContactDirectoryRow {
  id: number;
  spaceId?: number;
  accountId: number;
  fullName: string;
  phone: string;
  email?: string | null;
  roles: ContactDirectoryRowRolesItem[];
  status: ContactDirectoryRowStatus;
  accountLegalName: string;
  accountType?: ContactDirectoryRowAccountType;
  /** Derived from EXISTS(memberships WHERE contactId=X AND status='active') — NOT contacts.status */
  hasActiveMembership: boolean;
  /** Condensed per-deal plan labels, e.g. ["Cabin","Workstation"] or ["Cabin","+2"] */
  planChips: string[];
  planCount: number;
  /** MAX(attendance_sessions.entryAt) for this contact; drives default recent-activity sort */
  lastActivityAt?: string | null;
}

export type ContactDetailRolesItem =
  (typeof ContactDetailRolesItem)[keyof typeof ContactDetailRolesItem];

export const ContactDetailRolesItem = {
  primary: "primary",
  billing: "billing",
  user: "user",
} as const;

export type ContactDetailStatus =
  (typeof ContactDetailStatus)[keyof typeof ContactDetailStatus];

export const ContactDetailStatus = {
  active: "active",
  exited: "exited",
} as const;

export type ContactDetailIdProofType =
  | (typeof ContactDetailIdProofType)[keyof typeof ContactDetailIdProofType]
  | null;

export const ContactDetailIdProofType = {
  PAN: "PAN",
  DL: "DL",
  Passport: "Passport",
  Aadhaar: "Aadhaar",
} as const;

export type ContactDetailAccountType =
  (typeof ContactDetailAccountType)[keyof typeof ContactDetailAccountType];

export const ContactDetailAccountType = {
  individual: "individual",
  company: "company",
} as const;

export type ContactDetailAccountGstTreatment =
  (typeof ContactDetailAccountGstTreatment)[keyof typeof ContactDetailAccountGstTreatment];

export const ContactDetailAccountGstTreatment = {
  registered_b2b: "registered_b2b",
  unregistered_b2c: "unregistered_b2c",
} as const;

/**
 * Phase 37 Member detail profile — ContactWithAccount base fields plus biometric/ID-proof fields and account GST context.
 */
export interface ContactDetail {
  id: number;
  spaceId?: number;
  accountId: number;
  fullName: string;
  phone: string;
  email?: string | null;
  roles: ContactDetailRolesItem[];
  status: ContactDetailStatus;
  createdAt?: string;
  updatedAt?: string;
  /** Biometric enrollment ID granting entry and conference-room access */
  biometricId?: string | null;
  /** Full UPI VPA, operator-typed. Used to match Pine Labs POS payments to this member (58-SOURCE-DATA.md §2). */
  upiVpa?: string | null;
  /** Derived server-side from upiVpa via maskVpa() — never typed directly. The masked form ('79**********@ybl') a Pine Labs export will carry for this member. */
  readonly upiVpaMasked?: string | null;
  photoUrl?: string | null;
  dateOfBirth?: string | null;
  idProofType?: ContactDetailIdProofType;
  accountLegalName: string;
  accountBillingPhone?: string | null;
  accountType?: ContactDetailAccountType;
  accountGstTreatment?: ContactDetailAccountGstTreatment;
  accountGstin?: string | null;
  /** State code e.g. '07' Delhi, '06' Haryana */
  accountPlaceOfSupply?: string;
}

export type ContactTransactionRowSource =
  (typeof ContactTransactionRowSource)[keyof typeof ContactTransactionRowSource];

export const ContactTransactionRowSource = {
  stock_out: "stock_out",
  assignment: "assignment",
  plan_period: "plan_period",
  member_charge: "member_charge",
} as const;

/**
 * One transaction/charge row attributed to a specific contact (Phase 37 Member Transactions section).
 */
export interface ContactTransactionRow {
  id: number;
  category: string;
  date?: string | null;
  description: string;
  amount?: number | null;
  gstAmount?: number | null;
  status?: string | null;
  receiptNumber?: string | null;
  invoiceNumber?: string | null;
  /** Linked member_charges.id for stock_out/assignment rows; null for plan_period rows and non-billable (Free/Comp) stock-outs. */
  memberChargeId?: number | null;
  source: ContactTransactionRowSource;
  /** stock_out.cart_id — only set on source: 'stock_out' rows. Multi-item Pay-Per-Use submissions stamp every sibling row with the same value so the Member profile can group them into one 'Cart of N items' parent row (mirroring the Account view). */
  cartId?: string | null;
  /** True for FIX-2 rollup rows (Phase 40) — account-level Pending charges (contact_id IS NULL) surfaced on the Billing contact's profile. Not in required[] — absent/false for every pre-existing row source. */
  accountLevel?: boolean;
}

/**
 * Category-bucketed transaction rows for a single contact, assembled server-side from stock_out/resource_assignments/membership_payment_periods (never a naive member_charges filter).
 */
export interface ContactTransactions {
  plan: ContactTransactionRow[];
  booking: ContactTransactionRow[];
  conferenceRoom: ContactTransactionRow[];
  fnb: ContactTransactionRow[];
  prints: ContactTransactionRow[];
  stationery: ContactTransactionRow[];
  addOns: ContactTransactionRow[];
  /** Phase 40 FIX-2 — account-level Pending non-Plan member_charges (contact_id IS NULL) rolled up onto the account's single designated Billing contact. Empty for every other contact and for accounts with zero billing contacts. */
  accountLevel: ContactTransactionRow[];
}

export interface ContactStatsHeatmapCell {
  date: string;
  count: number;
}

/**
 * Phase 38 — aggregated stat-tile + heatmap data for a single contact's member profile, computed server-side without N+1.
 */
export interface ContactStats {
  lifetimePaid: number;
  invoicesSettled: number;
  pendingDues: number;
  oldestDueDate?: string | null;
  totalVisits: number;
  avgPerMonth: number;
  avgPerWeek: number;
  joinedAt?: string | null;
  memberSinceLabel: string;
  memberDurationLabel: string;
  thisMonthVisits: number;
  dayStreak: number;
  heatmap: ContactStatsHeatmapCell[];
}

/**
 * Phase 38 — re-parent a contact (and their active memberships) to a different account in one audited transaction. History (issued invoices/receipts, past attendance) stays on the old account.
 */
export interface ReassignContactBody {
  targetAccountId: number;
  /** Required when the moved contact currently holds the primary or billing role on the old account. */
  replacementPrimaryContactId?: number | null;
  /** May equal replacementPrimaryContactId. */
  replacementBillingContactId?: number | null;
}

export interface ReassignContactResult {
  contactId: number;
  oldAccountId: number;
  newAccountId: number;
  movedMembershipIds: number[];
  movedDepositIds: number[];
}

export type CreateContactBodyRolesItem =
  (typeof CreateContactBodyRolesItem)[keyof typeof CreateContactBodyRolesItem];

export const CreateContactBodyRolesItem = {
  primary: "primary",
  billing: "billing",
  user: "user",
} as const;

export type CreateContactBodyIdProofType =
  | (typeof CreateContactBodyIdProofType)[keyof typeof CreateContactBodyIdProofType]
  | null;

export const CreateContactBodyIdProofType = {
  PAN: "PAN",
  DL: "DL",
  Passport: "Passport",
  Aadhaar: "Aadhaar",
} as const;

export interface CreateContactBody {
  /** @minLength 1 */
  fullName: string;
  /** @minLength 1 */
  phone: string;
  email?: string | null;
  /** @minItems 1 */
  roles: CreateContactBodyRolesItem[];
  idProofType?: CreateContactBodyIdProofType;
  /** Masked last-4 of the proof number */
  idProofRef?: string | null;
  /** Biometric enrollment ID granting entry and conference-room access */
  biometricId?: string | null;
  /** Full UPI VPA, operator-typed. Used to match Pine Labs POS payments to this member (58-SOURCE-DATA.md §2). */
  upiVpa?: string | null;
  /** Derived server-side from upiVpa via maskVpa() — never typed directly. The masked form ('79**********@ybl') a Pine Labs export will carry for this member. */
  readonly upiVpaMasked?: string | null;
  photoUrl?: string | null;
  dateOfBirth?: string | null;
  joinedAt?: string | null;
  exitedAt?: string | null;
}

export type UpdateContactBodyRolesItem =
  (typeof UpdateContactBodyRolesItem)[keyof typeof UpdateContactBodyRolesItem];

export const UpdateContactBodyRolesItem = {
  primary: "primary",
  billing: "billing",
  user: "user",
} as const;

export type UpdateContactBodyIdProofType =
  | (typeof UpdateContactBodyIdProofType)[keyof typeof UpdateContactBodyIdProofType]
  | null;

export const UpdateContactBodyIdProofType = {
  PAN: "PAN",
  DL: "DL",
  Passport: "Passport",
  Aadhaar: "Aadhaar",
} as const;

export type UpdateContactBodyStatus =
  (typeof UpdateContactBodyStatus)[keyof typeof UpdateContactBodyStatus];

export const UpdateContactBodyStatus = {
  active: "active",
  exited: "exited",
} as const;

/**
 * PATCH partial-update — all fields optional
 */
export interface UpdateContactBody {
  /** @minLength 1 */
  fullName?: string;
  /** @minLength 1 */
  phone?: string;
  email?: string | null;
  /** @minItems 1 */
  roles?: UpdateContactBodyRolesItem[];
  idProofType?: UpdateContactBodyIdProofType;
  idProofRef?: string | null;
  /** Biometric enrollment ID granting entry and conference-room access */
  biometricId?: string | null;
  /** Full UPI VPA, operator-typed. Used to match Pine Labs POS payments to this member (58-SOURCE-DATA.md §2). */
  upiVpa?: string | null;
  /** Derived server-side from upiVpa via maskVpa() — never typed directly. The masked form ('79**********@ybl') a Pine Labs export will carry for this member. */
  readonly upiVpaMasked?: string | null;
  photoUrl?: string | null;
  dateOfBirth?: string | null;
  joinedAt?: string | null;
  exitedAt?: string | null;
  status?: UpdateContactBodyStatus;
}

export type MembershipStatus =
  (typeof MembershipStatus)[keyof typeof MembershipStatus];

export const MembershipStatus = {
  active: "active",
  exited: "exited",
} as const;

export type MembershipCycleMode =
  | (typeof MembershipCycleMode)[keyof typeof MembershipCycleMode]
  | null;

export const MembershipCycleMode = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Yearly: "Yearly",
} as const;

export type MembershipPaymentMode =
  | (typeof MembershipPaymentMode)[keyof typeof MembershipPaymentMode]
  | null;

export const MembershipPaymentMode = {
  Cash: "Cash",
  UPI: "UPI",
  Bank_Transfer: "Bank_Transfer",
  Card: "Card",
  Cheque: "Cheque",
} as const;

export interface Membership {
  id: number;
  spaceId: number;
  accountId: number;
  contactId: number;
  planId: number;
  seatOrCabinRef?: string | null;
  accessHours?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  /** Sunday access add-on purchased on this line. */
  sundayAccess?: boolean;
  /** Sunday fee PER UNIT PER MONTH, frozen at sale. NULL when off. */
  sundayAccessRate?: number | null;
  status: MembershipStatus;
  billingCycleDay?: number | null;
  cycleMode?: MembershipCycleMode;
  /** Phase 27 — FK to inventory_plan_periods.id captured at membership creation
if a matching matrix row exists. NULL otherwise. Read-only.
 */
  matrixRowId?: number | null;
  /** Phase 27 — frozen-at-creation discounted rupee figure. Source-of-truth
for billing-scheduler. Operator edits to the matrix row's discount_pct
never re-evaluate this. Read-only.
 */
  frozenDiscountedPrice?: number | null;
  /** 0068 — units in this line (e.g. 2 cabins). Scheduler bills quantity × per-unit price. */
  quantity?: number;
  /** 0068 — committed deal length in months (NULL for non-recurring). */
  durationMonths?: number | null;
  /** 0068 — per-unit plan price snapshot at creation. */
  unitPrice?: number | null;
  /** 0068 — per-line discount % captured in the deal builder. */
  lineDiscountPct?: number;
  paymentMode?: MembershipPaymentMode;
  /** 0068 — whether the deal builder applied GST to this line. */
  gstApplicable?: boolean;
  /** 0068 — groups memberships created together in one batch. */
  quoteGroupId?: string | null;
  /** 0068 — FK to the proforma estimate for the batch. */
  proformaQuoteId?: number | null;
  createdAt: string;
  updatedAt: string;
  /** Phase 28 — explicit operator-set held deposit (P1: never recomputed by any
pricing/discount/term/bill-date op). NULL = derive from proforma/plan baseline.
 */
  securityDepositHeld?: number | null;
}

export type CreateMembershipBodyCycleMode =
  | (typeof CreateMembershipBodyCycleMode)[keyof typeof CreateMembershipBodyCycleMode]
  | null;

export const CreateMembershipBodyCycleMode = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Yearly: "Yearly",
} as const;

export interface CreateMembershipBody {
  contactId: number;
  planId: number;
  seatOrCabinRef?: string | null;
  accessHours?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  /**
   * @minimum 1
   * @maximum 31
   */
  billingCycleDay?: number | null;
  cycleMode?: CreateMembershipBodyCycleMode;
  /**
   * Phase 27 — optional seats dimension for matrix lookup at creation.
Defaults to 1 server-side. Does NOT set matrixRowId — server derives
it from (planId, parsed cycle from cadence default, seats) lookup.

   * @minimum 1
   */
  seats?: number;
}

export type MembershipBatchLineCycleMode =
  | (typeof MembershipBatchLineCycleMode)[keyof typeof MembershipBatchLineCycleMode]
  | null;

export const MembershipBatchLineCycleMode = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Yearly: "Yearly",
  One_Time: "One_Time",
} as const;

export interface MembershipBatchLine {
  planId: number;
  /** @minimum 1 */
  quantity: number;
  /**
   * Committed months for recurring lines. Ignored for non-recurring.
   * @minimum 1
   */
  durationMonths?: number | null;
  cycleMode?: MembershipBatchLineCycleMode;
  /**
   * @minimum 0
   * @maximum 100
   */
  lineDiscountPct?: number;
  seatOrCabinRef?: string | null;
  accessHours?: string | null;
  /** Sunday access add-on. Priced per space type from sunday_access_rates (Private_Cabin 2000/mo, Workstation 1000/mo), multiplied by quantity, taxed like rent and NOT reduced by additionalDiscountPct. */
  sundayAccess?: boolean;
  /** Per-line deposit waive. When false, this space type's security deposit is 0. Falls back to body-level when omitted. */
  securityDepositApplicable?: boolean | null;
  /**
   * Per-line deposit override (total for the line). Omit to use the derived amount.
   * @minimum 0
   */
  securityDepositHeld?: number | null;
  /** Per-line start date override. When set, this membership row's start_date overrides body.startDate. The body-level lock-in policy (start + 6 months) still applies, computed off this date. */
  startDate?: string | null;
  /** Per-line end date. Defines the fixed window for a One_Time (billed-in-full) line; the membership's end_date is set from this. Omit for open-ended recurring lines. */
  endDate?: string | null;
  /**
   * Per-line billing day override (1..31; short months collapse to that month's last day). When set, this membership row's billing_cycle_day overrides body.billingCycleDay.
   * @minimum 1
   * @maximum 31
   */
  billingCycleDay?: number | null;
}

export type CreateMembershipBatchBodyPaymentMode =
  (typeof CreateMembershipBatchBodyPaymentMode)[keyof typeof CreateMembershipBatchBodyPaymentMode];

export const CreateMembershipBatchBodyPaymentMode = {
  Cash: "Cash",
  UPI: "UPI",
  Bank_Transfer: "Bank_Transfer",
  Card: "Card",
  Cheque: "Cheque",
} as const;

export interface CreateMembershipBatchBody {
  /** Member/contact the whole batch is attached to (must belong to the account). */
  contactId: number;
  startDate?: string | null;
  /** When set, the plan has ended on this date — memberships are created as 'exited'. */
  endDate?: string | null;
  /**
   * @minimum 1
   * @maximum 31
   */
  billingCycleDay?: number | null;
  paymentMode?: CreateMembershipBatchBodyPaymentMode;
  /**
   * @minimum 0
   * @maximum 100
   */
  additionalDiscountPct?: number;
  gstApplicable?: boolean;
  /** When false, the refundable security deposit is waived (0) on the estimate — e.g. backdated plans. */
  securityDepositApplicable?: boolean;
  /** When true, also persist a proforma ESTIMATE (informational, not a tax invoice). */
  createProforma?: boolean;
  /**
   * Override the derived deposit amount. Omit to use the derived value.
   * @minimum 0
   */
  securityDepositHeld?: number | null;
  /** @minItems 1 */
  lines: MembershipBatchLine[];
}

export interface MembershipQuoteLine {
  id: number;
  quoteId: number;
  membershipId?: number | null;
  planId: number;
  description: string;
  quantity: number;
  durationMonths?: number | null;
  unitPrice: number;
  lineDiscountPct?: number;
  proratedFirstAmount?: number;
  taxableAmount: number;
  gstRate?: number;
  cgstRate?: number;
  cgstAmount?: number;
  sgstRate?: number;
  sgstAmount?: number;
  igstRate?: number;
  igstAmount?: number;
  securityDeposit?: number;
  lineTotal: number;
}

export type PlanSchedulePeriodStatus =
  (typeof PlanSchedulePeriodStatus)[keyof typeof PlanSchedulePeriodStatus];

export const PlanSchedulePeriodStatus = {
  Unpaid: "Unpaid",
  Partial: "Partial",
  Paid: "Paid",
} as const;

export interface PlanSchedulePeriod {
  id: number;
  membershipId: number;
  accountId: number;
  /** Deal grouping key — multiple memberships created in one Add Plan submission share this so the Transactions tab can merge their periods into a single row. */
  quoteGroupId?: string | null;
  planName?: string | null;
  resourceType?: string | null;
  contactName?: string | null;
  /** The membership's assigned contact, if any — lets the member profile filter an account's plan-schedule down to this member's own periods. */
  contactId?: number | null;
  quantity?: number;
  cycleMode?: string | null;
  cycleLabel?: string;
  periodIndex: number;
  periodStart: string;
  periodEnd: string;
  amount: number;
  amountPaid: number;
  status: PlanSchedulePeriodStatus;
  /** True when GST actually applies to this period (membership opted in
AND the plan declares a non-zero tax rate). A Tax Invoice is only
valid when true; otherwise only the order receipt applies.
 */
  gstApplicable: boolean;
  paidAt?: string | null;
  paymentMode?: string | null;
  paymentProofUrl?: string | null;
  reminderDate?: string | null;
  receiptNumber?: string | null;
  receiptPdfUrl?: string | null;
  receiptSentAt?: string | null;
  /** Phase 28 — true when an operator pinned this period's amount via Edit amount.
   */
  amountOverridden?: boolean;
  /** Refundable security deposit billed on this period (the membership's FIRST period only, else 0).
Not part of `amount`/`amountPaid` — the Plan tab adds it so Pending matches the receipt.
 */
  depositDue?: number;
  /** Deposit received against this period (sum of payment rows' deposit_amount). */
  depositReceived?: number;
}

export interface PlanScheduleSummary {
  /** Days since the earliest recurring plan start date */
  daysCompleted: number;
  /** Distinct resource types across the account's recurring plans */
  spaceTypeCount: number;
  /** Active contacts on the account */
  teamMembers: number;
  /** Net change in active contacts vs the previous month */
  teamMembersGrowth: number;
  /** Total plan revenue / team members */
  perHeadRevenue: number;
  /** Start date of the next unpaid/upcoming billing period */
  nextPaymentDate?: string | null;
}

export interface PlanPayment {
  id: number;
  periodId: number;
  membershipId?: number;
  planName?: string | null;
  periodStart?: string;
  periodEnd?: string;
  amount: number;
  paymentMode?: string | null;
  paidAt: string;
  proofUrl?: string | null;
  /** Start of the period following the one this payment covers */
  nextPaymentDate?: string | null;
  createdAt?: string;
}

export interface PlanScheduleDeposit {
  membershipId: number;
  /** Deal-grouping key — multi-space-type submissions share this so the UI collapses sibling deposit rows. */
  quoteGroupId?: string | null;
  amount: number;
  /** Membership startDate — the date the deposit was collected at booking. */
  collectedDate: string;
  planName?: string | null;
  resourceType?: string | null;
}

export interface PlanScheduleResponse {
  periods: PlanSchedulePeriod[];
  payments: PlanPayment[];
  /** One-time security-deposit collection events. The Transactions tab renders these as 'Security deposit collected' rows at the top of the Plan schedule, dated to membership.startDate. Grouped client-side by quoteGroupId. */
  deposits?: PlanScheduleDeposit[];
  summary: PlanScheduleSummary;
}

export interface MarkPlanPeriodPaidBody {
  /** Defaults to true; pass false to revert to Unpaid. Ignored when amountPaid or bankAmount is provided. */
  paid?: boolean;
  /** Rent + GST portion paid so far (existing behavior). < period amount → Partial; >= amount → Paid; 0 → Unpaid. Use bankAmount instead when the bank credit also covers the security deposit. */
  amountPaid?: number;
  /** Full amount received in the bank (GST/IT compliance mode). The
server splits this into a rent portion (used as amountPaid) and a
deposit portion (linked to the membership's Held deposit if not
yet actualized). Order receipt PDF will show the full bankAmount;
tax invoice will show only the taxable rent portion.
 */
  bankAmount?: number;
  paymentMode?: string | null;
  /** Date/time of payment; defaults to now when paid */
  paymentDate?: string | null;
  /** Public URL of the uploaded proof of payment */
  paymentProofUrl?: string | null;
}

export interface UpdatePlanPeriodReminderBody {
  reminderDate?: string | null;
}

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const PaymentStatus = {
  Active: "Active",
  Void: "Void",
} as const;

/**
 * Exactly one of the four collectible target types this allocation line pays down. Category (Rent / Late_Fee / Meeting_Room / pay_per_use / …) is derived from the target, never stored here.
 */
export type PaymentAllocationTargetKind =
  (typeof PaymentAllocationTargetKind)[keyof typeof PaymentAllocationTargetKind];

export const PaymentAllocationTargetKind = {
  membership_payment_period: "membership_payment_period",
  member_charge: "member_charge",
  member_security_deposit: "member_security_deposit",
  stock_out: "stock_out",
} as const;

export interface PaymentAllocation {
  id: number;
  paymentId: number;
  /** Exactly one of the four collectible target types this allocation line pays down. Category (Rent / Late_Fee / Meeting_Room / pay_per_use / …) is derived from the target, never stored here. */
  targetKind: PaymentAllocationTargetKind;
  targetId: number;
  /** Display label for the target (plan name + period dates, charge description, deposit reference, or stock item name) so the ledger card renders without a second round-trip. */
  targetLabel?: string | null;
  amount: number;
  voidedAt?: string | null;
  /** Set when this allocation was reversed by a compensating allocation row. Reallocation is reverse-then-re-allocate, never an in-place update. */
  reversedByAllocationId?: number | null;
  createdAt: string;
}

export interface Payment {
  id: number;
  spaceId: number;
  accountId: number;
  /** Who physically handed the money over. The account owes and the account pays; this is optional attribution only — per-member attribution comes from the charges the payment settles. */
  contactId?: number | null;
  amount: number;
  paymentMode?: string | null;
  paidAt: string;
  proofUrl?: string | null;
  /** Non-cash funding source: this payment's value came from an Issued/Adjusted credit note, not a bank credit. */
  creditNoteId?: number | null;
  /** Non-cash funding source: this payment's value came from a Held security deposit, not a bank credit. */
  depositId?: number | null;
  status: PaymentStatus;
  voidedAt?: string | null;
  voidReason?: string | null;
  createdAt: string;
  allocations: PaymentAllocation[];
  /** Computed: amount minus the sum of this payment's active (non-voided) allocations. Positive = on-account credit available to apply via applyOnAccountCredit. */
  unallocatedAmount: number;
}

export type AllocatePaymentBodyAllocationsItemTargetKind =
  (typeof AllocatePaymentBodyAllocationsItemTargetKind)[keyof typeof AllocatePaymentBodyAllocationsItemTargetKind];

export const AllocatePaymentBodyAllocationsItemTargetKind = {
  membership_payment_period: "membership_payment_period",
  member_charge: "member_charge",
  member_security_deposit: "member_security_deposit",
  stock_out: "stock_out",
} as const;

export type AllocatePaymentBodyAllocationsItem = {
  targetKind: AllocatePaymentBodyAllocationsItemTargetKind;
  targetId: number;
  amount: number;
};

export interface AllocatePaymentBody {
  /** Who physically handed the money over. Optional — the account owes and the account pays. */
  contactId?: number | null;
  amount: number;
  paymentMode?: string | null;
  paidAt: string;
  proofUrl?: string | null;
  /** Non-cash funding source: this payment's value comes from an existing Issued/Adjusted credit note, not a bank credit. */
  creditNoteId?: number | null;
  /** Non-cash funding source: this payment's value comes from a Held security deposit, not a bank credit. */
  depositId?: number | null;
  /** May be empty — a zero-allocation payment is a valid booking advance (money received before any invoice or charge exists). The sum of allocation amounts MUST be <= amount; enforced server-side inside the same transaction that recomputes each target's paid state. */
  allocations: AllocatePaymentBodyAllocationsItem[];
}

export interface VoidPaymentBody {
  /** Why this payment is being voided (e.g. a bounced cheque, a data-entry error). Every active allocation is reversed by a compensating row in the same transaction. */
  reason: string;
}

export type ApplyOnAccountBodyAllocationsItemTargetKind =
  (typeof ApplyOnAccountBodyAllocationsItemTargetKind)[keyof typeof ApplyOnAccountBodyAllocationsItemTargetKind];

export const ApplyOnAccountBodyAllocationsItemTargetKind = {
  membership_payment_period: "membership_payment_period",
  member_charge: "member_charge",
  member_security_deposit: "member_security_deposit",
  stock_out: "stock_out",
} as const;

export type ApplyOnAccountBodyAllocationsItem = {
  targetKind: ApplyOnAccountBodyAllocationsItemTargetKind;
  targetId: number;
  amount: number;
};

export interface ApplyOnAccountBody {
  /** The payment whose unallocatedAmount is being spent. */
  paymentId: number;
  /**
   * New allocation lines against the payment's remaining on-account credit. Clamped server-side to both the target's remaining due and the payment's unallocatedAmount.
   * @minItems 1
   */
  allocations: ApplyOnAccountBodyAllocationsItem[];
}

/**
 * Delivery channel. Omit to just generate + return the PDF URL (view/download).
 */
export type GeneratePlanPeriodReceiptBodyChannel =
  (typeof GeneratePlanPeriodReceiptBodyChannel)[keyof typeof GeneratePlanPeriodReceiptBodyChannel];

export const GeneratePlanPeriodReceiptBodyChannel = {
  whatsapp: "whatsapp",
  email: "email",
} as const;

export interface GeneratePlanPeriodReceiptBody {
  /** Deprecated alias for channel=whatsapp. When true, deliver via WhatsApp. */
  send?: boolean;
  /** Delivery channel. Omit to just generate + return the PDF URL (view/download). */
  channel?: GeneratePlanPeriodReceiptBodyChannel;
  /** Operator-supplied order receipt number. When provided (non-empty), it OVERRIDES the auto-generated NN/MMYYYY number and is persisted on the period. Omit to keep the existing/auto number. */
  receiptNumber?: string;
}

/**
 * Simple receipt breakdown for an HTML preview
 */
export type PlanPeriodReceiptResponseBreakdown = {
  issuerName?: string;
  clientName?: string;
  planLabel?: string;
  periodStart?: string;
  periodEnd?: string;
  subtotal?: number;
  cgst?: number;
  sgst?: number;
  igst?: number;
  securityDeposit?: number;
  total?: number;
  received?: number;
  balance?: number;
  balanceDueDate?: string | null;
} | null;

export interface PlanPeriodReceiptResponse {
  pdfUrl?: string | null;
  receiptNumber?: string | null;
  sent: boolean;
  channel?: string | null;
  /** Simple receipt breakdown for an HTML preview */
  breakdown?: PlanPeriodReceiptResponseBreakdown;
}

export interface MembershipQuote {
  id: number;
  spaceId: number;
  accountId: number;
  contactId: number;
  quoteGroupId: string;
  quoteNumber: string;
  quoteDate: string;
  startDate?: string | null;
  billingCycleDay?: number | null;
  paymentMode?: string | null;
  additionalDiscountPct?: number;
  gstApplicable?: boolean;
  subtotal?: number;
  totalDiscount?: number;
  cgstTotal?: number;
  sgstTotal?: number;
  igstTotal?: number;
  securityDepositTotal?: number;
  grandTotal: number;
  issuerGstin?: string | null;
  issuerStateCode?: string | null;
  memberState?: string | null;
  status: string;
  receivedAmount?: number;
  pdfUrl?: string | null;
  receiptSentAt?: string | null;
  createdAt: string;
  lines?: MembershipQuoteLine[];
}

export interface SendProformaReceiptBody {
  /**
   * Advance/received amount; pending = grandTotal − received.
   * @minimum 0
   */
  receivedAmount?: number;
}

export interface SendProformaReceiptResponse {
  proforma: MembershipQuote;
  pdfUrl?: string | null;
  delivered: boolean;
  whatsappError?: string | null;
}

export interface OrderReceiptLine {
  description: string;
  detail?: string | null;
  unitPrice: number;
  quantity: number;
  durationMonths?: number | null;
  lineTotal: number;
}

export interface AccountOrderReceiptView {
  periodMonth: string;
  receiptNumber?: string | null;
  lines: OrderReceiptLine[];
  subtotal: number;
  cgstTotal?: number;
  sgstTotal?: number;
  igstTotal?: number;
  grandTotal: number;
  receivedAmount: number;
  pendingAmount: number;
  pdfUrl?: string | null;
  receiptSentAt?: string | null;
}

export interface AccountOrderReceipt {
  id: number;
  spaceId?: number;
  accountId: number;
  periodMonth: string;
  receiptNumber: string;
  receiptDate?: string;
  receivedAmount?: number;
  grandTotal: number;
  pdfUrl?: string | null;
  receiptSentAt?: string | null;
}

export interface SendOrderReceiptBody {
  /** @minimum 0 */
  receivedAmount?: number;
  /** When true, generate + upload the PDF but do not WhatsApp it (download flow). */
  skipWhatsapp?: boolean;
}

export interface SendOrderReceiptResponse {
  receipt: AccountOrderReceipt;
  pdfUrl?: string | null;
  delivered: boolean;
  whatsappError?: string | null;
}

export interface MembershipBatchResponse {
  quoteGroupId: string;
  memberships: Membership[];
  proforma?: MembershipQuote | null;
}

export type UpdateMembershipBodyCycleMode =
  | (typeof UpdateMembershipBodyCycleMode)[keyof typeof UpdateMembershipBodyCycleMode]
  | null;

export const UpdateMembershipBodyCycleMode = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Yearly: "Yearly",
} as const;

export type UpdateMembershipBodyStatus =
  (typeof UpdateMembershipBodyStatus)[keyof typeof UpdateMembershipBodyStatus];

export const UpdateMembershipBodyStatus = {
  active: "active",
  exited: "exited",
} as const;

/**
 * PATCH partial-update — all fields optional
 */
export interface UpdateMembershipBody {
  contactId?: number;
  planId?: number;
  seatOrCabinRef?: string | null;
  accessHours?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  /**
   * @minimum 1
   * @maximum 31
   */
  billingCycleDay?: number | null;
  cycleMode?: UpdateMembershipBodyCycleMode;
  /**
   * Committed term in months. A change is recorded in the period-change log.
   * @minimum 1
   */
  durationMonths?: number | null;
  /**
   * Per-plan additional discount %. Recomputes the frozen per-unit price (folded with the line discount), re-prices unpaid periods, and is recorded in the change log.
   * @minimum 0
   * @maximum 100
   */
  additionalDiscountPct?: number | null;
  status?: UpdateMembershipBodyStatus;
  /** Turn the Sunday access add-on on or off. Re-prices only UNPAID, non-overridden, non-receipted periods, so a paid or receipted period is never disturbed. Logged. The rate is re-frozen from the catalog when switched on. */
  sundayAccess?: boolean;
  /**
   * Set/change the held deposit amount. Logged. Never touches rent.
   * @minimum 0
   */
  securityDepositHeld?: number | null;
}

export type MembershipPeriodLogEntryField =
  (typeof MembershipPeriodLogEntryField)[keyof typeof MembershipPeriodLogEntryField];

export const MembershipPeriodLogEntryField = {
  period_months: "period_months",
  end_date: "end_date",
  additional_discount_pct: "additional_discount_pct",
  security_deposit_held: "security_deposit_held",
  period_amount_override: "period_amount_override",
  sunday_access: "sunday_access",
} as const;

export interface MembershipPeriodLogEntry {
  id: number;
  membershipId: number;
  field: MembershipPeriodLogEntryField;
  oldValue?: string | null;
  newValue?: string | null;
  changedBy?: number | null;
  changedAt: string;
}

export type DocumentTypeProperty =
  (typeof DocumentTypeProperty)[keyof typeof DocumentTypeProperty];

export const DocumentTypeProperty = {
  agreement: "agreement",
  kyc: "kyc",
  deposit_receipt: "deposit_receipt",
  handover: "handover",
  exit_settlement: "exit_settlement",
  company_registration: "company_registration",
  gst_certificate: "gst_certificate",
  gst_return: "gst_return",
} as const;

export interface Document {
  id: number;
  spaceId: number;
  accountId: number;
  contactId?: number | null;
  type: DocumentTypeProperty;
  /** Storage path key (not directly accessible); use signedUrl to view */
  fileUrl: string;
  /** Short-lived (1h) signed URL for viewing the file */
  signedUrl?: string | null;
  signedAt?: string | null;
  uploadedAt: string;
  uploadedBy?: number | null;
}

export type UploadDocumentBodyType =
  (typeof UploadDocumentBodyType)[keyof typeof UploadDocumentBodyType];

export const UploadDocumentBodyType = {
  agreement: "agreement",
  kyc: "kyc",
  deposit_receipt: "deposit_receipt",
  handover: "handover",
  exit_settlement: "exit_settlement",
  company_registration: "company_registration",
  gst_certificate: "gst_certificate",
  gst_return: "gst_return",
} as const;

/**
 * Multipart form-data fields for document upload
 */
export interface UploadDocumentBody {
  type: UploadDocumentBodyType;
  contactId?: number | null;
  signedAt?: string | null;
  /** Binary file content (multipart/form-data upload) */
  file?: string;
}

export interface MergeAccountsBody {
  /**
   * Account IDs to fold into the target — each must belong to the same space
   * @minItems 1
   */
  sourceAccountIds: number[];
}

export type InvoiceReadyStatusMissingItem =
  (typeof InvoiceReadyStatusMissingItem)[keyof typeof InvoiceReadyStatusMissingItem];

export const InvoiceReadyStatusMissingItem = {
  legal_name: "legal_name",
  gst_treatment: "gst_treatment",
  gstin: "gstin",
  place_of_supply: "place_of_supply",
  billing_contact: "billing_contact",
} as const;

export interface InvoiceReadyStatus {
  ready: boolean;
  missing: InvoiceReadyStatusMissingItem[];
}

/**
 * Defaults to 'individual'; flipped to 'company' by the operator toggle
 */
export type ConvertLeadToAccountBodyAccountType =
  | (typeof ConvertLeadToAccountBodyAccountType)[keyof typeof ConvertLeadToAccountBodyAccountType]
  | null;

export const ConvertLeadToAccountBodyAccountType = {
  individual: "individual",
  company: "company",
} as const;

/**
 * Sub-type for company accounts; NULL for individual
 */
export type ConvertLeadToAccountBodyCompanyType =
  | (typeof ConvertLeadToAccountBodyCompanyType)[keyof typeof ConvertLeadToAccountBodyCompanyType]
  | null;

export const ConvertLeadToAccountBodyCompanyType = {
  Private_Limited: "Private_Limited",
  Public_Limited: "Public_Limited",
  LLP: "LLP",
  Partnership: "Partnership",
  Sole_Proprietorship: "Sole_Proprietorship",
  One_Person_Company: "One_Person_Company",
  Other: "Other",
} as const;

export type ConvertLeadToAccountBodyGstTreatment =
  (typeof ConvertLeadToAccountBodyGstTreatment)[keyof typeof ConvertLeadToAccountBodyGstTreatment];

export const ConvertLeadToAccountBodyGstTreatment = {
  registered_b2b: "registered_b2b",
  unregistered_b2c: "unregistered_b2c",
} as const;

export type ConvertLeadToAccountBodyIdProofType =
  | (typeof ConvertLeadToAccountBodyIdProofType)[keyof typeof ConvertLeadToAccountBodyIdProofType]
  | null;

export const ConvertLeadToAccountBodyIdProofType = {
  Aadhaar: "Aadhaar",
  PAN: "PAN",
  Passport: "Passport",
  Driving_License: "Driving_License",
  Voter_ID: "Voter_ID",
} as const;

export type ConvertLeadToAccountBodyCycleMode =
  | (typeof ConvertLeadToAccountBodyCycleMode)[keyof typeof ConvertLeadToAccountBodyCycleMode]
  | null;

export const ConvertLeadToAccountBodyCycleMode = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Yearly: "Yearly",
} as const;

export interface ConvertLeadToAccountBody {
  /** @minLength 1 */
  legalName: string;
  /** Defaults to 'individual'; flipped to 'company' by the operator toggle */
  accountType?: ConvertLeadToAccountBodyAccountType;
  /** Sub-type for company accounts; NULL for individual */
  companyType?: ConvertLeadToAccountBodyCompanyType;
  gstTreatment: ConvertLeadToAccountBodyGstTreatment;
  gstin?: string | null;
  /** State code; server defaults '07' for walk_in if omitted */
  placeOfSupply: string;
  /** Street/area line — structured pincode/city/state are separate fields */
  billingAddress?: string | null;
  pincode?: string | null;
  city?: string | null;
  state?: string | null;
  billingEmail?: string | null;
  billingPhone?: string | null;
  /** Primary contact full name */
  fullName: string;
  /** Primary contact phone */
  phone: string;
  email?: string | null;
  idProofType?: ConvertLeadToAccountBodyIdProofType;
  idProofRef?: string | null;
  planId?: number | null;
  startDate?: string | null;
  billingCycleDay?: number | null;
  cycleMode?: ConvertLeadToAccountBodyCycleMode;
  /**
   * Phase 27 — optional seats dimension for matrix lookup at creation.
Defaults to 1 server-side. Does NOT set matrixRowId — server derives
it from (planId, parsed cycle from cadence default, seats) lookup.

   * @minimum 1
   */
  seats?: number;
}

export interface ConvertLeadToAccountResponse {
  accountId: number;
  primaryContactId: number;
  membershipId?: number | null;
}

export type MemberChargeSourceType =
  (typeof MemberChargeSourceType)[keyof typeof MemberChargeSourceType];

export const MemberChargeSourceType = {
  pay_per_use: "pay_per_use",
  overage: "overage",
  addon: "addon",
  other: "other",
  Plan_Rental: "Plan_Rental",
  Late_Fee: "Late_Fee",
  Hourly_Booking: "Hourly_Booking",
  Daily_Booking: "Daily_Booking",
} as const;

/**
 * VAL-04 / D-12 — Indian GST rate constrained to canonical bands.
 */
export type GstRate = (typeof GstRate)[keyof typeof GstRate];

export const GstRate = {
  NUMBER_0: 0,
  NUMBER_5: 5,
  NUMBER_12: 12,
  NUMBER_18: 18,
  NUMBER_28: 28,
} as const;

export type DepositStatus = (typeof DepositStatus)[keyof typeof DepositStatus];

export const DepositStatus = {
  Held: "Held",
  Released: "Released",
  Forfeited: "Forfeited",
} as const;

export type CycleMode = (typeof CycleMode)[keyof typeof CycleMode];

export const CycleMode = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
} as const;

/**
 * D-01 — Recurring (workstation/cabin) vs Non_Recurring (5 hourly/daily subtypes)
 */
export type MemberCategory =
  (typeof MemberCategory)[keyof typeof MemberCategory];

export const MemberCategory = {
  Recurring: "Recurring",
  Non_Recurring: "Non_Recurring",
} as const;

/**
 * D-01 — 7 canonical subtypes; DB CHECK enforces (Recurring -> workstation|cabin)
 */
export type MemberSubtype = (typeof MemberSubtype)[keyof typeof MemberSubtype];

export const MemberSubtype = {
  workstation: "workstation",
  cabin: "cabin",
  conference_room_hourly: "conference_room_hourly",
  meeting_room_hourly: "meeting_room_hourly",
  day_pass: "day_pass",
  event_hourly: "event_hourly",
  shooting_hourly: "shooting_hourly",
} as const;

/**
 * D-14 / D-21 — billing cadence per resource_pricing row
 */
export type ResourcePricingCadence =
  (typeof ResourcePricingCadence)[keyof typeof ResourcePricingCadence];

export const ResourcePricingCadence = {
  Monthly: "Monthly",
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Hourly: "Hourly",
  Daily: "Daily",
  Booking: "Booking",
} as const;

/**
 * D-21 — multiplication semantic for booking quantity
 */
export type ResourcePricingPaymentUnit =
  (typeof ResourcePricingPaymentUnit)[keyof typeof ResourcePricingPaymentUnit];

export const ResourcePricingPaymentUnit = {
  Hour: "Hour",
  Day: "Day",
  Booking: "Booking",
  Month: "Month",
  Quarter: "Quarter",
  Six_Month: "Six_Month",
} as const;

export type ResourcePricingStatus =
  (typeof ResourcePricingStatus)[keyof typeof ResourcePricingStatus];

export const ResourcePricingStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface BookingActionReason {
  /**
   * Required free-text reason; written to audit log via writeAuditLogTx
   * @minLength 5
   */
  reason: string;
}

export type AlertTier = (typeof AlertTier)[keyof typeof AlertTier];

export const AlertTier = {
  Healthy: "Healthy",
  Green: "Green",
  Red: "Red",
  Black: "Black",
} as const;

export interface InventorySpendKpiCategory {
  name: string;
  amount: number;
  priorAmount: number;
  changePct: number;
}

export interface InventorySpendKpiBucket {
  /** complimentary | pay-per-use | comp-with-limit | office-maintenance */
  id: string;
  displayName: string;
  color: string;
  description: string;
  totalSpend: number;
  priorSpend: number;
  changePct: number;
  shareOfTotal: number;
  /** Pay-Per-Use bucket only */
  ppuRevenue?: number | null;
  /** Pay-Per-Use bucket only — ppuRevenue / totalSpend * 100 */
  recoveredPct?: number | null;
  categories: InventorySpendKpiCategory[];
}

export interface InventorySpendKpiAttendance {
  /** Distinct contacts who checked in during the window. */
  uniqueMembers: number;
  /** Distinct (contact, session_date) combinations — the natural denominator for per-attendee cost. */
  memberDays: number;
  /** Raw attendance_sessions row count in the window. */
  totalSessions: number;
}

export interface InventorySpendKpi {
  /** mtd | 30d | 3m | 6m | 9m | 12m | ytd | custom */
  period: string;
  periodStart: string;
  periodEnd: string;
  priorStart: string;
  priorEnd: string;
  asOfDate: string;
  grandTotal: number;
  grandTotalChangePct: number;
  attendance: InventorySpendKpiAttendance;
  buckets: InventorySpendKpiBucket[];
}

export interface CreateStockInLineItem {
  itemId: number;
  variantId?: number | null;
  quantityReceived: number;
  /** How much of quantityReceived is still in stock at entry time (back-dated receipts). NULL = add full quantityReceived; 0 = ledger-only. */
  quantityRemaining?: number | null;
  quantityOrdered?: number | null;
  unitPriceActual: number;
  gstAmount?: number | null;
  lineTotal?: number | null;
  batchNumber?: string | null;
  expiryDate?: string | null;
  storageLocation?: string | null;
}

export interface CreateStockInCharge {
  /** @minLength 1 */
  label: string;
  amount: number;
  gstRate?: number | null;
  gstAmount?: number | null;
}

export interface CreateStockInBody {
  spaceId?: number | null;
  transactionDate: string;
  transactionType: StockInTransactionType;
  referenceNumber?: string | null;
  receivedByUserId?: number | null;
  receivedAt?: string | null;
  vendorId?: number | null;
  purchaseOrderId?: string | null;
  invoiceNumber?: string | null;
  invoiceDate?: string | null;
  invoicePdfUrl?: string | null;
  qualityStatus?: QualityStatus | null;
  qualityNotes?: string | null;
  acceptedQuantity?: number | null;
  rejectedQuantity?: number | null;
  rejectionReason?: string | null;
  subtotal?: number | null;
  totalGst?: number | null;
  deliveryCharges?: number | null;
  otherCharges?: number | null;
  discount?: number | null;
  grandTotal?: number | null;
  urgencyReason?: string | null;
  estimatedAmount?: number | null;
  orderId?: string | null;
  substitutionFlag?: string | null;
  originalVendorId?: number | null;
  substitutionReason?: SubstitutionReason | null;
  originalAttemptTime?: string | null;
  /** Internal-refill source (Transfer_In). NULL for external receipts. */
  fromLocation?: string | null;
  /** Internal-refill destination (Transfer_In). NULL for external receipts. */
  toLocation?: string | null;
  /** Local shop name for Daily Pickups (Phase 2.1 polish D). */
  vendorNameFreeText?: string | null;
  /** Cash | On_Account | UPI | Card | Net_Banking. Captured at create-time for Daily Pickups. */
  paymentMode?: string | null;
  /** Receipt photo URL — reused for Daily Pickups bill photo. */
  invoiceScreenshotUrl?: string | null;
  /** Cash amount paid at create-time (Daily Pickups). */
  finalPaidAmount?: number | null;
  /** Phase 2.1 polish E — Receipts form claims input GST credit? */
  gstInputClaimed?: boolean | null;
  /** Sticky data-entry flag: were unit prices typed as GST-inclusive? Persisted for form re-open only; stored numbers are unchanged. */
  priceInclusiveGst?: boolean | null;
  /** QC-04 admin override flag (allows past-cap QC POSTs) */
  adminOverride?: boolean | null;
  lineItems: CreateStockInLineItem[];
  charges?: CreateStockInCharge[] | null;
}

/**
 * Stage 2 reconciliation fields per D-23. 2026-05-21: lineItems may now be sent to
edit a Pending receipt — the server replaces the line rows and reconciles item
current_stock by the per-item quantity delta. Rejected (409) when the receipt is Paid.

 */
export interface UpdateStockInBody {
  transactionDate?: string | null;
  receivedAt?: string | null;
  invoiceDate?: string | null;
  vendorId?: number | null;
  invoiceNumber?: string | null;
  referenceNumber?: string | null;
  purchaseOrderId?: string | null;
  invoicePdfUrl?: string | null;
  subtotal?: number | null;
  totalGst?: number | null;
  grandTotal?: number | null;
  lineItems?: CreateStockInLineItem[] | null;
  charges?: CreateStockInCharge[] | null;
  productSubtotal?: number | null;
  deliveryCharge?: number | null;
  handlingFee?: number | null;
  surgeFee?: number | null;
  tip?: number | null;
  discountApplied?: number | null;
  gstAmount?: number | null;
  finalPaidAmount?: number | null;
  paymentMode?: string | null;
  invoiceScreenshotUrl?: string | null;
  varianceVsEstimate?: number | null;
  qualityStatus?: QualityStatus | null;
  qualityNotes?: string | null;
  fromLocation?: string | null;
  toLocation?: string | null;
  gstInputClaimed?: boolean | null;
  priceInclusiveGst?: boolean | null;
  adminOverride?: boolean | null;
}

export type UpdateStockOutBodyPaymentStatus =
  | (typeof UpdateStockOutBodyPaymentStatus)[keyof typeof UpdateStockOutBodyPaymentStatus]
  | null;

export const UpdateStockOutBodyPaymentStatus = {
  Paid: "Paid",
  Pending: "Pending",
} as const;

/**
 * Partial update for a stock-out row. Payment fields are always mutable
(Transactions tab settlement flow). Safe non-money fields
(transactionDate, reason) are also editable within a D+1 grace
window — server rejects with 409 `stock_out_edit_window_expired`
when transaction_date is older than 1 calendar day from now.
Money-affecting fields (quantity_issued, item_id, contact_id,
consumption_type) remain immutable — those still require the
DELETE + re-create flow, which properly reverses stock + charges.

 */
export interface UpdateStockOutBody {
  paymentStatus?: UpdateStockOutBodyPaymentStatus;
  /** Cash / UPI / Card / Bank_Transfer */
  paymentMethod?: string | null;
  /** External payment reference — UPI transaction id, card auth code, cheque number, etc. */
  invoiceReference?: string | null;
  /** Public URL of the Merchant Copy / payment screenshot uploaded via /api/uploads/payment-proof. */
  paymentProofUrl?: string | null;
  /** New transaction date. Editable within D+1 grace window — server 409s on stale rows. */
  transactionDate?: string | null;
  /** Operator notes / correction context. Free text. */
  reason?: string | null;
}

export type CreateStockOutBodyAppliedModifiersItem = {
  modifierId: number;
  /** @minimum 1 */
  count: number;
  /** RECIPE-COMPOSITION-03. Operator-picked component id when the modifier's logic_type='OR'. Required for OR modifiers (422 or_modifier_requires_component_choice if absent); forbidden for AND modifiers (422 and_modifier_forbids_component_choice); must be a member of the modifier's linked component set (422 chosen_component_not_in_modifier). */
  chosenComponentItemId?: number | null;
};

export interface CreateStockOutBody {
  spaceId?: number | null;
  transactionDate: string;
  consumptionType: StockOutConsumptionType;
  issuedByUserId?: number | null;
  issuedFrom?: string | null;
  /** Destination for Internal_Refill (e.g. Office_Floor). Phase 2.1 polish F. */
  toLocation?: string | null;
  itemId: number;
  /** Required when item has variants; null otherwise. */
  variantId?: number | null;
  /** RECIPE-MODIFIER-01/02. One entry per DISTINCT modifier chosen; count = how many times it was stacked (min 1). Replaces appliedModifierIds (which could not represent a count — duplicate ids collapse under SQL IN). RECIPE-COMPOSITION-03: for OR-logic modifiers, `chosenComponentItemId` is REQUIRED (operator picks one of the modifier's linked components at sale time); for AND-logic modifiers, `chosenComponentItemId` MUST be null/absent. */
  appliedModifiers?: CreateStockOutBodyAppliedModifiersItem[] | null;
  quantityIssued: number;
  batchNumber?: string | null;
  storageLocation?: string | null;
  /** Deprecated alias for accountId. Either is accepted by the server. */
  memberId?: number | null;
  /** Billing party that consumed the item. */
  accountId?: number | null;
  /** Specific person on the account that consumed the item. Tagged from the Pay-Per-Use form's contact picker. */
  contactId?: number | null;
  memberPlan?: string | null;
  cabinNumber?: string | null;
  chargingDecision?: ChargingDecision | null;
  amountCharged?: number | null;
  gstOnCharge?: number | null;
  totalToMember?: number | null;
  paymentMethod?: string | null;
  paymentStatus?: string | null;
  invoiceReference?: string | null;
  /** UUID generated by the form per multi-item submission. Stamp every line of one cart with the same value so the Transactions register can group them and mark-paid can update all siblings atomically. */
  cartId?: string | null;
  reason?: string | null;
  approvedByUserId?: number | null;
  eventId?: string | null;
  /** Required by API when chargingDecision is overridden (e.g., Comp_By_Manager) */
  overrideReason?: string | null;
}

export interface DailyOrderSchedule {
  id: number;
  spaceId: number;
  itemId: number;
  primaryVendorId: number;
  backupVendorId?: number | null;
  dailyQuantity: number;
  orderMethod: string;
  orderCutoffTime?: string | null;
  deliveryWindow?: string | null;
  weekendPattern: string;
  holidayHandling: string;
  lastConfirmedDate?: string | null;
  nextActionDue?: string | null;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDailyOrderScheduleBody {
  spaceId?: number | null;
  itemId: number;
  primaryVendorId: number;
  backupVendorId?: number | null;
  dailyQuantity: number;
  orderMethod: string;
  orderCutoffTime?: string | null;
  deliveryWindow?: string | null;
  weekendPattern?: string | null;
  holidayHandling?: string | null;
  nextActionDue?: string | null;
  status?: string | null;
}

export interface UpdateDailyOrderScheduleBody {
  primaryVendorId?: number | null;
  backupVendorId?: number | null;
  dailyQuantity?: number | null;
  orderMethod?: string | null;
  orderCutoffTime?: string | null;
  deliveryWindow?: string | null;
  weekendPattern?: string | null;
  holidayHandling?: string | null;
  lastConfirmedDate?: string | null;
  nextActionDue?: string | null;
  status?: string | null;
  /** Used by today panel "Skip" action */
  skipReason?: string | null;
}

export interface MemberEntitlement {
  id: number;
  spaceId: number;
  memberId: number;
  itemId: number;
  periodStart: string;
  periodEnd: string;
  periodLabel: string;
  quotaAllowed: number;
  quotaUsed: number;
  quotaRemaining: number;
  overageQuantity: number;
  overageCharges: number;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateMemberEntitlementBody {
  spaceId?: number | null;
  memberId: number;
  itemId: number;
  periodStart: string;
  periodEnd: string;
  periodLabel: string;
  quotaAllowed: number;
  quotaUsed?: number | null;
  quotaRemaining?: number | null;
  status?: string | null;
}

export interface UpdateMemberEntitlementBody {
  quotaAllowed?: number | null;
  quotaUsed?: number | null;
  quotaRemaining?: number | null;
  overageQuantity?: number | null;
  overageCharges?: number | null;
  status?: string | null;
}

export interface CreateMemberChargeBody {
  /** Defaults to the admin's own space when omitted. */
  spaceId?: number | null;
  accountId: number;
  sourceType: string;
  sourceReference?: string | null;
  description: string;
  quantity: number;
  unitPrice: number;
  subtotal: number;
  gstRate?: number | null;
  gstAmount?: number | null;
  total: number;
  billingCycle: string;
  /** Phase 40 — contact this charge is attributed to. Omit/null leaves the charge account-level (rolls up via FIX 2 onto the Billing contact). */
  contactId?: number | null;
}

export interface UpdateMemberChargeBody {
  description?: string | null;
  quantity?: number | null;
  unitPrice?: number | null;
  subtotal?: number | null;
  gstRate?: number | null;
  gstAmount?: number | null;
  total?: number | null;
  status?: MemberChargeStatus | null;
  paymentMode?: string | null;
  paidAt?: string | null;
  paymentProofUrl?: string | null;
}

/**
 * Delivery channel. Omit to just generate + return the PDF URL.
 */
export type GenerateMemberChargeReceiptBodyChannel =
  (typeof GenerateMemberChargeReceiptBodyChannel)[keyof typeof GenerateMemberChargeReceiptBodyChannel];

export const GenerateMemberChargeReceiptBodyChannel = {
  whatsapp: "whatsapp",
  email: "email",
} as const;

/**
 * Omit or 'receipt' for order receipt (Phase 30). 'invoice' generates the GST tax invoice (Phase 31, requires status=Paid).
 */
export type GenerateMemberChargeReceiptBodyDocumentType =
  (typeof GenerateMemberChargeReceiptBodyDocumentType)[keyof typeof GenerateMemberChargeReceiptBodyDocumentType];

export const GenerateMemberChargeReceiptBodyDocumentType = {
  receipt: "receipt",
  invoice: "invoice",
} as const;

export interface GenerateMemberChargeReceiptBody {
  /** Delivery channel. Omit to just generate + return the PDF URL. */
  channel?: GenerateMemberChargeReceiptBodyChannel;
  /** Omit or 'receipt' for order receipt (Phase 30). 'invoice' generates the GST tax invoice (Phase 31, requires status=Paid). */
  documentType?: GenerateMemberChargeReceiptBodyDocumentType;
}

export type MemberChargeReceiptResponseBreakdown = {
  issuerName?: string;
  clientName?: string;
  description?: string;
  subtotal?: number;
  cgst?: number;
  sgst?: number;
  igst?: number;
  total?: number;
} | null;

export interface MemberChargeReceiptResponse {
  pdfUrl?: string | null;
  receiptNumber?: string | null;
  sent: boolean;
  channel?: string | null;
  breakdown?: MemberChargeReceiptResponseBreakdown;
}

export interface OperationsAlert {
  itemId: number;
  itemName: string;
  categoryId?: number | null;
  categoryName?: string | null;
  currentStock: number;
  safetyStock?: number | null;
  reorderLevel?: number | null;
  adc?: number | null;
  leadTimeDays?: number | null;
  stockInFrequency?: string | null;
  unitOfMeasurement?: string | null;
  preferredVendorId?: number | null;
  tier: AlertTier;
}

export type OperationsQcBudgetBand =
  (typeof OperationsQcBudgetBand)[keyof typeof OperationsQcBudgetBand];

export const OperationsQcBudgetBand = {
  Healthy: "Healthy",
  Warn: "Warn",
  Block: "Block",
} as const;

export interface OperationsQcBudget {
  spaceId: number;
  monthlyQcBudget: number;
  qcAlertThreshold: number;
  qcBlockThreshold: number;
  currentSpend: number;
  percentUsed: number;
  band: OperationsQcBudgetBand;
  billingCycleStart?: string;
  billingCycleEnd?: string;
}

export interface UpdateSpaceQcBudgetBody {
  monthlyQcBudget?: number | null;
  qcAlertThreshold?: number | null;
  qcBlockThreshold?: number | null;
}

export interface InvoiceLineItem {
  id: number;
  invoiceId: number;
  memberChargeId?: number | null;
  sourceType: MemberChargeSourceType;
  description: string;
  hsnSacCode?: string | null;
  quantity: number;
  unitPrice: number;
  taxableAmount: number;
  gstRate: number;
  cgstRate?: number;
  cgstAmount?: number;
  sgstRate?: number;
  sgstAmount?: number;
  igstRate?: number;
  igstAmount?: number;
  lineTotal: number;
  createdAt: string;
}

export type InvoiceWithLineItems = Invoice & {
  lineItems: InvoiceLineItem[];
};

export interface MemberSecurityDeposit {
  id: number;
  spaceId: number;
  memberId: number;
  amount: number;
  status: DepositStatus;
  lockInUntilDate: string;
  heldAt: string;
  releasedAt?: string | null;
  releaseReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type MarkInvoicePaidBodyPaymentMethod =
  (typeof MarkInvoicePaidBodyPaymentMethod)[keyof typeof MarkInvoicePaidBodyPaymentMethod];

export const MarkInvoicePaidBodyPaymentMethod = {
  Cash: "Cash",
  Bank_Transfer: "Bank_Transfer",
  Cheque: "Cheque",
  UPI_Manual: "UPI_Manual",
  Gateway: "Gateway",
} as const;

export interface MarkInvoicePaidBody {
  paymentMethod: MarkInvoicePaidBodyPaymentMethod;
  /** @minimum 0 */
  amountPaid: number;
  transactionRef?: string | null;
  paymentDate: string;
}

export interface GenerateTokenBody {
  memberId: number;
}

export interface GenerateTokenResponse {
  /** 64-char hex */
  token: string;
  /** Self-service URL embedded in QR */
  url: string;
  expiresAt: string;
}

export interface SelfServiceCharges {
  memberId: number;
  memberName: string;
  charges: MemberCharge[];
  totalAmount?: number;
}

export interface ConfirmChargesBody {
  /** @minItems 1 */
  chargeIds: number[];
  /** If non-empty, marks the listed charges as Disputed */
  disputeReason?: string | null;
}

export interface BillingTodayMember {
  memberId: number;
  memberName: string;
  memberMobile?: string;
  planName: string;
  billingCycleDay: number;
  periodStart: string;
  periodEnd: string;
  draftSubtotal: number;
  draftTotal: number;
  /** Non-null if scheduler already generated this cycle */
  existingInvoiceId?: number | null;
}

export type PlanCoverageGapMissingItemsItem = {
  itemId: number;
  itemName: string;
  chargingModel: string;
};

export interface PlanCoverageGap {
  planId: number;
  planName: string;
  missingItems: PlanCoverageGapMissingItemsItem[];
}

export interface ResourcePricing {
  id: number;
  spaceId: number;
  /** Phase 10 D-11 — FK to inventory_plans.id; canonical classification. */
  planId: number;
  cadence: ResourcePricingCadence;
  paymentUnit: ResourcePricingPaymentUnit;
  /** Drizzle numeric — string-encoded decimal */
  basePrice: string;
  securityDepositRequired: boolean;
  securityDepositAmount?: string | null;
  discountPct?: string | null;
  lockInMonths?: number | null;
  status: ResourcePricingStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateResourcePricingBody {
  spaceId?: number | null;
  /** Phase 10 D-11 — FK to inventory_plans.id; canonical key. */
  planId: number;
  cadence: ResourcePricingCadence;
  paymentUnit: ResourcePricingPaymentUnit;
  basePrice: number;
  securityDepositRequired?: boolean;
  securityDepositAmount?: number | null;
  discountPct?: number | null;
  lockInMonths?: number | null;
  status?: ResourcePricingStatus;
}

export interface UpdateResourcePricingBody {
  /** Phase 10 (Plan 10-07): planId is the only classification key; memberSubtype dropped. */
  planId?: number;
  basePrice?: number;
  securityDepositRequired?: boolean;
  securityDepositAmount?: number | null;
  discountPct?: number | null;
  lockInMonths?: number | null;
  status?: ResourcePricingStatus;
}

export interface CreateBookingBody {
  memberId: number;
  resourcePricingId: number;
  /** D-04 — physical resource id (e.g. specific conference room inventory_items.id) */
  sourceReference?: string | null;
  /**
   * Hours for Hourly_Booking; 1 for Daily_Booking
   * @minimum 1
   */
  quantity: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  discountPct?: number | null;
  /** D-08 — surface member.gstin on the receipt when true */
  memberClaimsGst?: boolean;
  bookingStartTime?: string | null;
  bookingEndTime?: string | null;
  description?: string | null;
  /** Optional space_resources.id to assign at booking time; server inserts a resource_assignments row atomically with the member_charges row */
  spaceResourceId?: number | null;
  /** Phase 40 — contact the booking is for; validated against the account when supplied. Defaults to the account's primary contact when omitted (mirrors CreatePassSaleBody). */
  contactId?: number | null;
}

export interface BookingConflict {
  chargeId: number;
  memberName: string;
  bookingStartTime: string;
  bookingEndTime: string;
}

export type RescheduleBookingBody = BookingActionReason & {
  transactionDate?: string;
  bookingStartTime: string;
  bookingEndTime?: string | null;
};

/**
 * Cash or UPI
 */
export type CreatePassSaleBodyPaymentMode =
  | (typeof CreatePassSaleBodyPaymentMode)[keyof typeof CreatePassSaleBodyPaymentMode]
  | null;

export const CreatePassSaleBodyPaymentMode = {
  Cash: "Cash",
  UPI: "UPI",
} as const;

export interface CreatePassSaleBody {
  accountId: number;
  /** Must be a Non_Recurring inventory plan */
  planId: number;
  startDate: string;
  /** @minimum 1 */
  days?: number;
  /**
   * Number of passes sold in this sale — price is monthlyPrice × days × seats
   * @minimum 1
   */
  seats?: number;
  /** Single-seat shorthand; prefer seatResourceIds */
  seatResourceId?: number | null;
  /** Workstation seats held for the window — at most `seats` entries */
  seatResourceIds?: number[] | null;
  /** Defaults to account primary contact */
  contactId?: number | null;
  /**
   * @minimum 0
   * @maximum 100
   */
  discountPct?: number | null;
  /** Pass sales are GST-charged at the plan rate (fallback 18%); pass false only to sell GST-exempt */
  gstApplicable?: boolean;
  /** Cash or UPI */
  paymentMode?: CreatePassSaleBodyPaymentMode;
  description?: string | null;
}

export type InventoryAttributeKeyStatus =
  (typeof InventoryAttributeKeyStatus)[keyof typeof InventoryAttributeKeyStatus];

export const InventoryAttributeKeyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InventoryAttributeKey {
  id: number;
  spaceId: number;
  /** Color, Flavour, Weight, Volume, Brand, or operator-defined */
  name: string;
  status: InventoryAttributeKeyStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateAttributeKeyBodyStatus =
  (typeof CreateAttributeKeyBodyStatus)[keyof typeof CreateAttributeKeyBodyStatus];

export const CreateAttributeKeyBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateAttributeKeyBody {
  spaceId?: number | null;
  /**
   * @minLength 1
   * @maxLength 64
   */
  name: string;
  status?: CreateAttributeKeyBodyStatus;
}

export type UpdateAttributeKeyBodyStatus =
  | (typeof UpdateAttributeKeyBodyStatus)[keyof typeof UpdateAttributeKeyBodyStatus]
  | null;

export const UpdateAttributeKeyBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateAttributeKeyBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  name?: string | null;
  status?: UpdateAttributeKeyBodyStatus;
}

export type InventoryHsnCodeCodeType =
  (typeof InventoryHsnCodeCodeType)[keyof typeof InventoryHsnCodeCodeType];

export const InventoryHsnCodeCodeType = {
  HSN: "HSN",
  SAC: "SAC",
} as const;

export type InventoryHsnCodeStatus =
  (typeof InventoryHsnCodeStatus)[keyof typeof InventoryHsnCodeStatus];

export const InventoryHsnCodeStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InventoryHsnCode {
  id: number;
  spaceId: number;
  /** HSN (goods) or SAC (services) code */
  code: string;
  codeType: InventoryHsnCodeCodeType;
  description?: string | null;
  /** GST % charged for this code */
  gstRate: number;
  status: InventoryHsnCodeStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateHsnCodeBodyCodeType =
  (typeof CreateHsnCodeBodyCodeType)[keyof typeof CreateHsnCodeBodyCodeType];

export const CreateHsnCodeBodyCodeType = {
  HSN: "HSN",
  SAC: "SAC",
} as const;

export type CreateHsnCodeBodyStatus =
  (typeof CreateHsnCodeBodyStatus)[keyof typeof CreateHsnCodeBodyStatus];

export const CreateHsnCodeBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateHsnCodeBody {
  spaceId?: number | null;
  /**
   * @minLength 1
   * @maxLength 32
   */
  code: string;
  codeType?: CreateHsnCodeBodyCodeType;
  description?: string | null;
  gstRate: number;
  status?: CreateHsnCodeBodyStatus;
}

export type UpdateHsnCodeBodyCodeType =
  | (typeof UpdateHsnCodeBodyCodeType)[keyof typeof UpdateHsnCodeBodyCodeType]
  | null;

export const UpdateHsnCodeBodyCodeType = {
  HSN: "HSN",
  SAC: "SAC",
} as const;

export type UpdateHsnCodeBodyStatus =
  | (typeof UpdateHsnCodeBodyStatus)[keyof typeof UpdateHsnCodeBodyStatus]
  | null;

export const UpdateHsnCodeBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateHsnCodeBody {
  /**
   * @minLength 1
   * @maxLength 32
   */
  code?: string | null;
  codeType?: UpdateHsnCodeBodyCodeType;
  description?: string | null;
  gstRate?: number | null;
  status?: UpdateHsnCodeBodyStatus;
}

export type InventoryChargeTypeStatus =
  (typeof InventoryChargeTypeStatus)[keyof typeof InventoryChargeTypeStatus];

export const InventoryChargeTypeStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InventoryChargeType {
  id: number;
  spaceId: number;
  name: string;
  /** GST % suggested when this charge is added */
  defaultGstRate?: number | null;
  status: InventoryChargeTypeStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateChargeTypeBodyStatus =
  (typeof CreateChargeTypeBodyStatus)[keyof typeof CreateChargeTypeBodyStatus];

export const CreateChargeTypeBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateChargeTypeBody {
  spaceId?: number | null;
  /**
   * @minLength 1
   * @maxLength 64
   */
  name: string;
  defaultGstRate?: number | null;
  status?: CreateChargeTypeBodyStatus;
}

export type UpdateChargeTypeBodyStatus =
  | (typeof UpdateChargeTypeBodyStatus)[keyof typeof UpdateChargeTypeBodyStatus]
  | null;

export const UpdateChargeTypeBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateChargeTypeBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  name?: string | null;
  defaultGstRate?: number | null;
  status?: UpdateChargeTypeBodyStatus;
}

export type ExpenseTemplateCostType =
  (typeof ExpenseTemplateCostType)[keyof typeof ExpenseTemplateCostType];

export const ExpenseTemplateCostType = {
  Fixed: "Fixed",
  Variable: "Variable",
} as const;

export type ExpenseTemplateFrequency =
  (typeof ExpenseTemplateFrequency)[keyof typeof ExpenseTemplateFrequency];

export const ExpenseTemplateFrequency = {
  Monthly: "Monthly",
  Weekly: "Weekly",
  Quarterly: "Quarterly",
  Yearly: "Yearly",
} as const;

export type ExpenseTemplateStatus =
  (typeof ExpenseTemplateStatus)[keyof typeof ExpenseTemplateStatus];

export const ExpenseTemplateStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface ExpenseTemplate {
  id: number;
  spaceId: number;
  name: string;
  costType: ExpenseTemplateCostType;
  frequency: ExpenseTemplateFrequency;
  defaultAmount?: number | null;
  gstRate?: number | null;
  vendorId?: number | null;
  dueDayOfMonth?: number | null;
  startDate: string;
  invoiceUrl?: string | null;
  status: ExpenseTemplateStatus;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type CreateExpenseTemplateBodyCostType =
  (typeof CreateExpenseTemplateBodyCostType)[keyof typeof CreateExpenseTemplateBodyCostType];

export const CreateExpenseTemplateBodyCostType = {
  Fixed: "Fixed",
  Variable: "Variable",
} as const;

export type CreateExpenseTemplateBodyFrequency =
  (typeof CreateExpenseTemplateBodyFrequency)[keyof typeof CreateExpenseTemplateBodyFrequency];

export const CreateExpenseTemplateBodyFrequency = {
  Monthly: "Monthly",
  Weekly: "Weekly",
  Quarterly: "Quarterly",
  Yearly: "Yearly",
} as const;

export type CreateExpenseTemplateBodyStatus =
  (typeof CreateExpenseTemplateBodyStatus)[keyof typeof CreateExpenseTemplateBodyStatus];

export const CreateExpenseTemplateBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateExpenseTemplateBody {
  /** @minLength 1 */
  name: string;
  costType: CreateExpenseTemplateBodyCostType;
  frequency: CreateExpenseTemplateBodyFrequency;
  defaultAmount?: number | null;
  gstRate?: number | null;
  vendorId?: number | null;
  dueDayOfMonth?: number | null;
  startDate: string;
  invoiceUrl?: string | null;
  notes?: string | null;
  status?: CreateExpenseTemplateBodyStatus;
}

export type UpdateExpenseTemplateBodyCostType =
  | (typeof UpdateExpenseTemplateBodyCostType)[keyof typeof UpdateExpenseTemplateBodyCostType]
  | null;

export const UpdateExpenseTemplateBodyCostType = {
  Fixed: "Fixed",
  Variable: "Variable",
} as const;

export type UpdateExpenseTemplateBodyFrequency =
  | (typeof UpdateExpenseTemplateBodyFrequency)[keyof typeof UpdateExpenseTemplateBodyFrequency]
  | null;

export const UpdateExpenseTemplateBodyFrequency = {
  Monthly: "Monthly",
  Weekly: "Weekly",
  Quarterly: "Quarterly",
  Yearly: "Yearly",
} as const;

export type UpdateExpenseTemplateBodyStatus =
  | (typeof UpdateExpenseTemplateBodyStatus)[keyof typeof UpdateExpenseTemplateBodyStatus]
  | null;

export const UpdateExpenseTemplateBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateExpenseTemplateBody {
  name?: string | null;
  costType?: UpdateExpenseTemplateBodyCostType;
  frequency?: UpdateExpenseTemplateBodyFrequency;
  defaultAmount?: number | null;
  gstRate?: number | null;
  vendorId?: number | null;
  dueDayOfMonth?: number | null;
  startDate?: string | null;
  invoiceUrl?: string | null;
  notes?: string | null;
  status?: UpdateExpenseTemplateBodyStatus;
}

export type ExpenseEntryStatus =
  (typeof ExpenseEntryStatus)[keyof typeof ExpenseEntryStatus];

export const ExpenseEntryStatus = {
  Due: "Due",
  Paid: "Paid",
} as const;

export interface ExpenseEntry {
  id: number;
  spaceId: number;
  templateId: number;
  periodStart: string;
  periodLabel: string;
  amount?: number | null;
  gstRate?: number | null;
  gstAmount?: number | null;
  status: ExpenseEntryStatus;
  dueDate?: string | null;
  paidAt?: string | null;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentProofUrl?: string | null;
  invoiceUrl?: string | null;
  vendorId?: number | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type UpdateExpenseEntryBodyStatus =
  | (typeof UpdateExpenseEntryBodyStatus)[keyof typeof UpdateExpenseEntryBodyStatus]
  | null;

export const UpdateExpenseEntryBodyStatus = {
  Due: "Due",
  Paid: "Paid",
} as const;

export interface UpdateExpenseEntryBody {
  amount?: number | null;
  gstRate?: number | null;
  gstAmount?: number | null;
  status?: UpdateExpenseEntryBodyStatus;
  dueDate?: string | null;
  paidAt?: string | null;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentProofUrl?: string | null;
  invoiceUrl?: string | null;
  vendorId?: number | null;
  notes?: string | null;
}

export type InventoryAttributeValueStatus =
  (typeof InventoryAttributeValueStatus)[keyof typeof InventoryAttributeValueStatus];

export const InventoryAttributeValueStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InventoryAttributeValue {
  id: number;
  spaceId: number;
  attributeKeyId: number;
  value: string;
  status: InventoryAttributeValueStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateAttributeValueBodyStatus =
  | (typeof CreateAttributeValueBodyStatus)[keyof typeof CreateAttributeValueBodyStatus]
  | null;

export const CreateAttributeValueBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateAttributeValueBody {
  spaceId?: number | null;
  attributeKeyId: number;
  /**
   * @minLength 1
   * @maxLength 64
   */
  value: string;
  status?: CreateAttributeValueBodyStatus;
}

export type UpdateAttributeValueBodyStatus =
  | (typeof UpdateAttributeValueBodyStatus)[keyof typeof UpdateAttributeValueBodyStatus]
  | null;

export const UpdateAttributeValueBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateAttributeValueBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  value?: string | null;
  status?: UpdateAttributeValueBodyStatus;
}

export type InventoryItemVariantStatus =
  (typeof InventoryItemVariantStatus)[keyof typeof InventoryItemVariantStatus];

export const InventoryItemVariantStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export interface InventoryItemVariant {
  id: number;
  spaceId: number;
  parentItemId: number;
  attributeValueId: number;
  itemCode?: string | null;
  /** Server-computed: parent item name + attribute value (e.g. 'Pen — Blue') */
  displayName?: string | null;
  /** Drizzle numeric — string-encoded decimal */
  currentStock: string;
  /** 2026-05-18 hot-fix. Per-variant price override. NULL = inherit parent item.sellingPrice. Used when variants have meaningfully different prices (e.g. Print A4 B&W vs Color). */
  sellingPrice?: string | null;
  status: InventoryItemVariantStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateItemVariantBodyStatus =
  | (typeof CreateItemVariantBodyStatus)[keyof typeof CreateItemVariantBodyStatus]
  | null;

export const CreateItemVariantBodyStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export interface CreateItemVariantBody {
  /** (Legacy single-attribute variant.) Provide this when the variant has
exactly one attribute value. Prefer `attributeValueIds` for composite
SKUs. When both are sent, `attributeValueIds` wins and this is set to
its first element for backward-compat reads.
 */
  attributeValueId?: number | null;
  /** (2026-05-18 composite-SKU hot-fix.) Array of one or more attribute_value_ids
that together define this SKU. Example: [Blue, 250ml] = Pen Blue 250ml.
One junction row is written per id. The `displayName` is composed by
joining the attribute values with ", ".
 */
  attributeValueIds?: number[] | null;
  itemCode?: string | null;
  currentStock?: string | null;
  /** Per-variant price override. NULL = inherit parent item.sellingPrice. */
  sellingPrice?: string | null;
  status?: CreateItemVariantBodyStatus;
}

export type UpdateItemVariantBodyStatus =
  | (typeof UpdateItemVariantBodyStatus)[keyof typeof UpdateItemVariantBodyStatus]
  | null;

export const UpdateItemVariantBodyStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export interface UpdateItemVariantBody {
  attributeValueId?: number | null;
  /** (2026-05-18 composite-SKU hot-fix.) If provided, replaces the variant's
entire attribute-value junction set. Display name is recomposed.
 */
  attributeValueIds?: number[] | null;
  itemCode?: string | null;
  currentStock?: string | null;
  /** Per-variant price override. NULL = inherit parent item.sellingPrice. */
  sellingPrice?: string | null;
  status?: UpdateItemVariantBodyStatus;
}

/**
 * 2026-05-18 hot-fix. 'tracked' = decrement component stock on serve (default). 'estimated' = known dependency but no auto-decrement (e.g. ink per print).
 */
export type InventoryItemRecipeConsumptionMode =
  (typeof InventoryItemRecipeConsumptionMode)[keyof typeof InventoryItemRecipeConsumptionMode];

export const InventoryItemRecipeConsumptionMode = {
  tracked: "tracked",
  estimated: "estimated",
} as const;

export interface InventoryItemRecipe {
  id: number;
  spaceId: number;
  servedItemId: number;
  componentItemId: number;
  /** Drizzle numeric — string-encoded decimal */
  qtyPerServe: string;
  /** 2026-05-18 hot-fix. 'tracked' = decrement component stock on serve (default). 'estimated' = known dependency but no auto-decrement (e.g. ink per print). */
  consumptionMode: InventoryItemRecipeConsumptionMode;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Defaults to 'tracked' if omitted.
 */
export type CreateItemRecipeBodyConsumptionMode =
  | (typeof CreateItemRecipeBodyConsumptionMode)[keyof typeof CreateItemRecipeBodyConsumptionMode]
  | null;

export const CreateItemRecipeBodyConsumptionMode = {
  tracked: "tracked",
  estimated: "estimated",
} as const;

export interface CreateItemRecipeBody {
  componentItemId: number;
  /** @pattern ^[0-9]+(\.[0-9]{1,3})?$ */
  qtyPerServe: string;
  /** Defaults to 'tracked' if omitted. */
  consumptionMode?: CreateItemRecipeBodyConsumptionMode;
  notes?: string | null;
}

export type UpdateItemRecipeBodyConsumptionMode =
  | (typeof UpdateItemRecipeBodyConsumptionMode)[keyof typeof UpdateItemRecipeBodyConsumptionMode]
  | null;

export const UpdateItemRecipeBodyConsumptionMode = {
  tracked: "tracked",
  estimated: "estimated",
} as const;

export interface UpdateItemRecipeBody {
  /** @pattern ^[0-9]+(\.[0-9]{1,3})?$ */
  qtyPerServe?: string | null;
  consumptionMode?: UpdateItemRecipeBodyConsumptionMode;
  notes?: string | null;
}

/**
 * RECIPE-COMPOSITION-01/02/03. AND = all linked components decrement together on each use. OR = operator picks one at Stock-Out time via `chosenComponentItemId`. Defaults to AND on legacy single-component modifiers.
 */
export type InventoryRecipeModifierLogicType =
  (typeof InventoryRecipeModifierLogicType)[keyof typeof InventoryRecipeModifierLogicType];

export const InventoryRecipeModifierLogicType = {
  AND: "AND",
  OR: "OR",
} as const;

export type InventoryRecipeModifierStatus =
  (typeof InventoryRecipeModifierStatus)[keyof typeof InventoryRecipeModifierStatus];

export const InventoryRecipeModifierStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

/**
 * RECIPE-COMPOSITION-01. One linked component on a modifier. `qtyPerUse` is per-link consumption (multiplied at sale time by modifier count × sale qty out).
 */
export interface CreateModifierComponentInput {
  /**
   * FK → inventory_items.id. Must not itself be a recipe item (per-component nested-recipe guard — RECIPE-COMPOSITION-06).
   * @minimum 1
   */
  componentItemId: number;
  /**
   * Per-link consumption; > 0. Stored as numeric(12,3).
   * @minimum 0.001
   */
  qtyPerUse: number;
  /** Display order in editor + OR-picker dropdown. Ascending. */
  sortOrder?: number;
}

export interface InventoryRecipeModifier {
  id: number;
  spaceId: number;
  recipeItemId: number;
  modifierName: string;
  /** Drizzle numeric — string-encoded decimal */
  addPrice: string;
  /** Drizzle numeric — string-encoded decimal */
  gstRate: string;
  /** DEPRECATED (Phase 56). Legacy single-component field; read-only for one release cycle. Prefer the `components[]` array. Will be dropped in a future phase. */
  componentItemId?: number | null;
  /** DEPRECATED (Phase 56). Legacy single-component qty; read-only. See per-component qty on `components[]`. */
  qtyPerUse?: string | null;
  /** RECIPE-COMPOSITION-01/02/03. AND = all linked components decrement together on each use. OR = operator picks one at Stock-Out time via `chosenComponentItemId`. Defaults to AND on legacy single-component modifiers. */
  logicType: InventoryRecipeModifierLogicType;
  /** RECIPE-COMPOSITION-01. Linked components (AND: all decrement, OR: operator picks one). Nullable during rollout — annotation-only modifiers have an empty/missing array. */
  components?: CreateModifierComponentInput[] | null;
  status: InventoryRecipeModifierStatus;
  createdAt: string;
  updatedAt: string;
}

/**
 * RECIPE-COMPOSITION-05. AND (default) = all linked components decrement together; OR = operator picks one at Stock-Out. When `components.length <= 1`, only 'AND' is valid.
 */
export type CreateItemModifierBodyLogicType =
  | (typeof CreateItemModifierBodyLogicType)[keyof typeof CreateItemModifierBodyLogicType]
  | null;

export const CreateItemModifierBodyLogicType = {
  AND: "AND",
  OR: "OR",
} as const;

export type CreateItemModifierBodyStatus =
  | (typeof CreateItemModifierBodyStatus)[keyof typeof CreateItemModifierBodyStatus]
  | null;

export const CreateItemModifierBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateItemModifierBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  modifierName: string;
  addPrice?: string | null;
  /** Allowed values: 0, 5, 12, 18, 28 (as string numerics) */
  gstRate?: string | null;
  /** DEPRECATED (Phase 56). Legacy single-component shape. Prefer `components[]`. When both are absent → annotation-only modifier. When `components[]` is present, it wins and this field is ignored. */
  componentItemId?: number | null;
  /** DEPRECATED (Phase 56). Paired with legacy `componentItemId`. */
  qtyPerUse?: string | null;
  /** RECIPE-COMPOSITION-05. AND (default) = all linked components decrement together; OR = operator picks one at Stock-Out. When `components.length <= 1`, only 'AND' is valid. */
  logicType?: CreateItemModifierBodyLogicType;
  /** RECIPE-COMPOSITION-01/05. Multi-component composition. Empty array or absent → annotation-only. Mutually exclusive with legacy top-level `componentItemId` (422 ambiguity guard if both supplied). */
  components?: CreateModifierComponentInput[] | null;
  status?: CreateItemModifierBodyStatus;
}

/**
 * RECIPE-COMPOSITION-05. When supplied, updates the modifier's cascade mode. When `components.length <= 1`, only 'AND' is valid.
 */
export type UpdateItemModifierBodyLogicType =
  | (typeof UpdateItemModifierBodyLogicType)[keyof typeof UpdateItemModifierBodyLogicType]
  | null;

export const UpdateItemModifierBodyLogicType = {
  AND: "AND",
  OR: "OR",
} as const;

export type UpdateItemModifierBodyStatus =
  | (typeof UpdateItemModifierBodyStatus)[keyof typeof UpdateItemModifierBodyStatus]
  | null;

export const UpdateItemModifierBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateItemModifierBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  modifierName?: string | null;
  addPrice?: string | null;
  /** Allowed values: 0, 5, 12, 18, 28 (as string numerics) */
  gstRate?: string | null;
  /** DEPRECATED (Phase 56). Legacy single-component shape. Prefer `components[]`. On PATCH: when `components[]` is supplied, the whole join set is DELETE+INSERT-replaced atomically (rows are immutable). Mutually exclusive with `components[]` (422 ambiguity guard). */
  componentItemId?: number | null;
  /** DEPRECATED (Phase 56). Paired with legacy `componentItemId`. */
  qtyPerUse?: string | null;
  /** RECIPE-COMPOSITION-05. When supplied, updates the modifier's cascade mode. When `components.length <= 1`, only 'AND' is valid. */
  logicType?: UpdateItemModifierBodyLogicType;
  /** RECIPE-COMPOSITION-01/05. Multi-component composition. On PATCH: replaces the entire linked set atomically (DELETE+INSERT in one transaction per CONTEXT §Data model shape — join rows are immutable). Empty array clears the composition (annotation-only). */
  components?: CreateModifierComponentInput[] | null;
  status?: UpdateItemModifierBodyStatus;
}

export type StockOutInsufficientComponentErrorDetails = {
  componentItemId: number;
  componentName: string;
  currentStock: number;
  required: number;
};

export interface StockOutInsufficientComponentError {
  error: string;
  details: StockOutInsufficientComponentErrorDetails;
}

export type InfraItemPricingModel =
  (typeof InfraItemPricingModel)[keyof typeof InfraItemPricingModel];

export const InfraItemPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type InfraItemLabourBasis =
  | (typeof InfraItemLabourBasis)[keyof typeof InfraItemLabourBasis]
  | null;

export const InfraItemLabourBasis = {
  Per_Day: "Per_Day",
  Per_Area: "Per_Area",
  Lump_Sum: "Lump_Sum",
} as const;

export type InfraItemStatus =
  (typeof InfraItemStatus)[keyof typeof InfraItemStatus];

export const InfraItemStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InfraItem {
  id: number;
  spaceId: number;
  name: string;
  category?: string | null;
  categoryId?: number | null;
  pricingModel: InfraItemPricingModel;
  unitLabel?: string | null;
  unitPrice?: number | null;
  measurementUnit?: string | null;
  ratePerUnit?: number | null;
  labourBasis?: InfraItemLabourBasis;
  labourRate?: number | null;
  warrantyApplicable: boolean;
  warrantyMonths?: number | null;
  hsnCode?: string | null;
  gstRate?: number | null;
  defaultVendorId?: number | null;
  location?: string | null;
  notes?: string | null;
  imageUrl?: string | null;
  status: InfraItemStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateInfraItemBodyPricingModel =
  (typeof CreateInfraItemBodyPricingModel)[keyof typeof CreateInfraItemBodyPricingModel];

export const CreateInfraItemBodyPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type CreateInfraItemBodyLabourBasis =
  | (typeof CreateInfraItemBodyLabourBasis)[keyof typeof CreateInfraItemBodyLabourBasis]
  | null;

export const CreateInfraItemBodyLabourBasis = {
  Per_Day: "Per_Day",
  Per_Area: "Per_Area",
  Lump_Sum: "Lump_Sum",
} as const;

export type CreateInfraItemBodyStatus =
  (typeof CreateInfraItemBodyStatus)[keyof typeof CreateInfraItemBodyStatus];

export const CreateInfraItemBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateInfraItemBody {
  /** @minLength 1 */
  name: string;
  spaceId?: number | null;
  category?: string | null;
  categoryId?: number | null;
  pricingModel: CreateInfraItemBodyPricingModel;
  unitLabel?: string | null;
  unitPrice?: number | null;
  measurementUnit?: string | null;
  ratePerUnit?: number | null;
  labourBasis?: CreateInfraItemBodyLabourBasis;
  labourRate?: number | null;
  warrantyApplicable?: boolean;
  warrantyMonths?: number | null;
  hsnCode?: string | null;
  gstRate?: number | null;
  defaultVendorId?: number | null;
  location?: string | null;
  notes?: string | null;
  imageUrl?: string | null;
  status?: CreateInfraItemBodyStatus;
}

export type UpdateInfraItemBodyPricingModel =
  | (typeof UpdateInfraItemBodyPricingModel)[keyof typeof UpdateInfraItemBodyPricingModel]
  | null;

export const UpdateInfraItemBodyPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type UpdateInfraItemBodyLabourBasis =
  | (typeof UpdateInfraItemBodyLabourBasis)[keyof typeof UpdateInfraItemBodyLabourBasis]
  | null;

export const UpdateInfraItemBodyLabourBasis = {
  Per_Day: "Per_Day",
  Per_Area: "Per_Area",
  Lump_Sum: "Lump_Sum",
} as const;

export type UpdateInfraItemBodyStatus =
  | (typeof UpdateInfraItemBodyStatus)[keyof typeof UpdateInfraItemBodyStatus]
  | null;

export const UpdateInfraItemBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateInfraItemBody {
  name?: string | null;
  category?: string | null;
  categoryId?: number | null;
  pricingModel?: UpdateInfraItemBodyPricingModel;
  unitLabel?: string | null;
  unitPrice?: number | null;
  measurementUnit?: string | null;
  ratePerUnit?: number | null;
  labourBasis?: UpdateInfraItemBodyLabourBasis;
  labourRate?: number | null;
  warrantyApplicable?: boolean | null;
  warrantyMonths?: number | null;
  hsnCode?: string | null;
  gstRate?: number | null;
  defaultVendorId?: number | null;
  location?: string | null;
  notes?: string | null;
  imageUrl?: string | null;
  status?: UpdateInfraItemBodyStatus;
}

export type InfraCategoryBillingType =
  (typeof InfraCategoryBillingType)[keyof typeof InfraCategoryBillingType];

export const InfraCategoryBillingType = {
  Office: "Office",
  Client_Billable: "Client_Billable",
} as const;

export type InfraCategoryPaymentType =
  | (typeof InfraCategoryPaymentType)[keyof typeof InfraCategoryPaymentType]
  | null;

export const InfraCategoryPaymentType = {
  Monthly_Rental: "Monthly_Rental",
  One_Time: "One_Time",
} as const;

export type InfraCategoryStatus =
  (typeof InfraCategoryStatus)[keyof typeof InfraCategoryStatus];

export const InfraCategoryStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InfraCategory {
  id: number;
  spaceId: number;
  name: string;
  billingType: InfraCategoryBillingType;
  paymentType?: InfraCategoryPaymentType;
  status: InfraCategoryStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateInfraCategoryBodyBillingType =
  (typeof CreateInfraCategoryBodyBillingType)[keyof typeof CreateInfraCategoryBodyBillingType];

export const CreateInfraCategoryBodyBillingType = {
  Office: "Office",
  Client_Billable: "Client_Billable",
} as const;

export type CreateInfraCategoryBodyPaymentType =
  | (typeof CreateInfraCategoryBodyPaymentType)[keyof typeof CreateInfraCategoryBodyPaymentType]
  | null;

export const CreateInfraCategoryBodyPaymentType = {
  Monthly_Rental: "Monthly_Rental",
  One_Time: "One_Time",
} as const;

export type CreateInfraCategoryBodyStatus =
  (typeof CreateInfraCategoryBodyStatus)[keyof typeof CreateInfraCategoryBodyStatus];

export const CreateInfraCategoryBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateInfraCategoryBody {
  /** @minLength 1 */
  name: string;
  billingType: CreateInfraCategoryBodyBillingType;
  paymentType?: CreateInfraCategoryBodyPaymentType;
  status?: CreateInfraCategoryBodyStatus;
}

export type UpdateInfraCategoryBodyBillingType =
  | (typeof UpdateInfraCategoryBodyBillingType)[keyof typeof UpdateInfraCategoryBodyBillingType]
  | null;

export const UpdateInfraCategoryBodyBillingType = {
  Office: "Office",
  Client_Billable: "Client_Billable",
} as const;

export type UpdateInfraCategoryBodyPaymentType =
  | (typeof UpdateInfraCategoryBodyPaymentType)[keyof typeof UpdateInfraCategoryBodyPaymentType]
  | null;

export const UpdateInfraCategoryBodyPaymentType = {
  Monthly_Rental: "Monthly_Rental",
  One_Time: "One_Time",
} as const;

export type UpdateInfraCategoryBodyStatus =
  | (typeof UpdateInfraCategoryBodyStatus)[keyof typeof UpdateInfraCategoryBodyStatus]
  | null;

export const UpdateInfraCategoryBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateInfraCategoryBody {
  name?: string | null;
  billingType?: UpdateInfraCategoryBodyBillingType;
  paymentType?: UpdateInfraCategoryBodyPaymentType;
  status?: UpdateInfraCategoryBodyStatus;
}

export type InfraAcquisitionPricingModel =
  (typeof InfraAcquisitionPricingModel)[keyof typeof InfraAcquisitionPricingModel];

export const InfraAcquisitionPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type InfraAcquisitionLabourBasis =
  | (typeof InfraAcquisitionLabourBasis)[keyof typeof InfraAcquisitionLabourBasis]
  | null;

export const InfraAcquisitionLabourBasis = {
  Per_Day: "Per_Day",
  Per_Area: "Per_Area",
  Lump_Sum: "Lump_Sum",
} as const;

export type InfraAcquisitionPaymentStatus =
  (typeof InfraAcquisitionPaymentStatus)[keyof typeof InfraAcquisitionPaymentStatus];

export const InfraAcquisitionPaymentStatus = {
  Paid: "Paid",
  Partially_Paid: "Partially_Paid",
  Pending: "Pending",
} as const;

export interface InfraAcquisition {
  id: number;
  spaceId: number;
  infraItemId: number;
  vendorId?: number | null;
  acquisitionDate: string;
  pricingModel: InfraAcquisitionPricingModel;
  qty?: number | null;
  unitPrice?: number | null;
  measurement?: number | null;
  ratePerUnit?: number | null;
  materialCost?: number | null;
  labourBasis?: InfraAcquisitionLabourBasis;
  labourDays?: number | null;
  labourArea?: number | null;
  labourRate?: number | null;
  labourLumpSum?: number | null;
  totalCost: number;
  gstRate?: number | null;
  gstAmount?: number | null;
  warrantyMonths?: number | null;
  warrantyStartDate?: string | null;
  warrantyEndDate?: string | null;
  location?: string | null;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
  invoiceUrl?: string | null;
  /** Optional infra item variant; NULL = no variant selected */
  variantId?: number | null;
  /** When false, server stores NULL gst_rate + NULL gst_amount regardless of body */
  gstApplicable?: boolean;
  paymentStatus: InfraAcquisitionPaymentStatus;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type CreateInfraAcquisitionBodyPricingModel =
  (typeof CreateInfraAcquisitionBodyPricingModel)[keyof typeof CreateInfraAcquisitionBodyPricingModel];

export const CreateInfraAcquisitionBodyPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type CreateInfraAcquisitionBodyLabourBasis =
  | (typeof CreateInfraAcquisitionBodyLabourBasis)[keyof typeof CreateInfraAcquisitionBodyLabourBasis]
  | null;

export const CreateInfraAcquisitionBodyLabourBasis = {
  Per_Day: "Per_Day",
  Per_Area: "Per_Area",
  Lump_Sum: "Lump_Sum",
} as const;

export type CreateInfraAcquisitionBodyPaymentStatus =
  (typeof CreateInfraAcquisitionBodyPaymentStatus)[keyof typeof CreateInfraAcquisitionBodyPaymentStatus];

export const CreateInfraAcquisitionBodyPaymentStatus = {
  Paid: "Paid",
  Partially_Paid: "Partially_Paid",
  Pending: "Pending",
} as const;

export interface CreateInfraAcquisitionBody {
  infraItemId: number;
  spaceId?: number | null;
  /** Optional infra item variant */
  variantId?: number | null;
  vendorId?: number | null;
  acquisitionDate: string;
  pricingModel: CreateInfraAcquisitionBodyPricingModel;
  qty?: number | null;
  unitPrice?: number | null;
  measurement?: number | null;
  ratePerUnit?: number | null;
  materialCost?: number | null;
  labourBasis?: CreateInfraAcquisitionBodyLabourBasis;
  labourDays?: number | null;
  labourArea?: number | null;
  labourRate?: number | null;
  labourLumpSum?: number | null;
  /** When false, server clears gst_rate + gst_amount. Defaults to true. */
  gstApplicable?: boolean | null;
  gstRate?: number | null;
  warrantyMonths?: number | null;
  warrantyStartDate?: string | null;
  location?: string | null;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
  invoiceUrl?: string | null;
  paymentStatus?: CreateInfraAcquisitionBodyPaymentStatus;
  notes?: string | null;
}

export type UpdateInfraAcquisitionBodyPricingModel =
  | (typeof UpdateInfraAcquisitionBodyPricingModel)[keyof typeof UpdateInfraAcquisitionBodyPricingModel]
  | null;

export const UpdateInfraAcquisitionBodyPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type UpdateInfraAcquisitionBodyLabourBasis =
  | (typeof UpdateInfraAcquisitionBodyLabourBasis)[keyof typeof UpdateInfraAcquisitionBodyLabourBasis]
  | null;

export const UpdateInfraAcquisitionBodyLabourBasis = {
  Per_Day: "Per_Day",
  Per_Area: "Per_Area",
  Lump_Sum: "Lump_Sum",
} as const;

export type UpdateInfraAcquisitionBodyPaymentStatus =
  | (typeof UpdateInfraAcquisitionBodyPaymentStatus)[keyof typeof UpdateInfraAcquisitionBodyPaymentStatus]
  | null;

export const UpdateInfraAcquisitionBodyPaymentStatus = {
  Paid: "Paid",
  Partially_Paid: "Partially_Paid",
  Pending: "Pending",
} as const;

export interface UpdateInfraAcquisitionBody {
  /** Optional infra item variant */
  variantId?: number | null;
  vendorId?: number | null;
  acquisitionDate?: string | null;
  pricingModel?: UpdateInfraAcquisitionBodyPricingModel;
  qty?: number | null;
  unitPrice?: number | null;
  measurement?: number | null;
  ratePerUnit?: number | null;
  materialCost?: number | null;
  labourBasis?: UpdateInfraAcquisitionBodyLabourBasis;
  labourDays?: number | null;
  labourArea?: number | null;
  labourRate?: number | null;
  labourLumpSum?: number | null;
  /** When false, server clears gst_rate + gst_amount. */
  gstApplicable?: boolean | null;
  gstRate?: number | null;
  warrantyMonths?: number | null;
  warrantyStartDate?: string | null;
  location?: string | null;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
  invoiceUrl?: string | null;
  paymentStatus?: UpdateInfraAcquisitionBodyPaymentStatus;
  notes?: string | null;
}

export type InfraAttributeKeyStatus =
  (typeof InfraAttributeKeyStatus)[keyof typeof InfraAttributeKeyStatus];

export const InfraAttributeKeyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InfraAttributeKey {
  id: number;
  spaceId: number;
  /** Arm Rest, Material, Colour, or operator-defined infra attribute */
  name: string;
  status: InfraAttributeKeyStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateInfraAttributeKeyBodyStatus =
  (typeof CreateInfraAttributeKeyBodyStatus)[keyof typeof CreateInfraAttributeKeyBodyStatus];

export const CreateInfraAttributeKeyBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateInfraAttributeKeyBody {
  spaceId?: number | null;
  /**
   * @minLength 1
   * @maxLength 64
   */
  name: string;
  status?: CreateInfraAttributeKeyBodyStatus;
}

export type UpdateInfraAttributeKeyBodyStatus =
  | (typeof UpdateInfraAttributeKeyBodyStatus)[keyof typeof UpdateInfraAttributeKeyBodyStatus]
  | null;

export const UpdateInfraAttributeKeyBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateInfraAttributeKeyBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  name?: string | null;
  status?: UpdateInfraAttributeKeyBodyStatus;
}

export type InfraAttributeValueStatus =
  (typeof InfraAttributeValueStatus)[keyof typeof InfraAttributeValueStatus];

export const InfraAttributeValueStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface InfraAttributeValue {
  id: number;
  spaceId: number;
  attributeKeyId: number;
  value: string;
  status: InfraAttributeValueStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateInfraAttributeValueBodyStatus =
  | (typeof CreateInfraAttributeValueBodyStatus)[keyof typeof CreateInfraAttributeValueBodyStatus]
  | null;

export const CreateInfraAttributeValueBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface CreateInfraAttributeValueBody {
  spaceId?: number | null;
  attributeKeyId: number;
  /**
   * @minLength 1
   * @maxLength 64
   */
  value: string;
  status?: CreateInfraAttributeValueBodyStatus;
}

export type UpdateInfraAttributeValueBodyStatus =
  | (typeof UpdateInfraAttributeValueBodyStatus)[keyof typeof UpdateInfraAttributeValueBodyStatus]
  | null;

export const UpdateInfraAttributeValueBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateInfraAttributeValueBody {
  /**
   * @minLength 1
   * @maxLength 64
   */
  value?: string | null;
  status?: UpdateInfraAttributeValueBodyStatus;
}

export type InfraItemVariantStatus =
  (typeof InfraItemVariantStatus)[keyof typeof InfraItemVariantStatus];

export const InfraItemVariantStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export interface InfraItemVariant {
  id: number;
  spaceId: number;
  parentItemId: number;
  /** Legacy single-attribute FK; composite variants use the junction table */
  attributeValueId?: number | null;
  itemCode?: string | null;
  /** Server-computed: parent item name + attribute values (e.g. 'Chair — Black, Mesh') */
  displayName?: string | null;
  /** NULL = inherit parent infra_item.hsnCode */
  hsnCode?: string | null;
  /** NULL = inherit parent infra_item.gstRate */
  gstRate?: number | null;
  /** NULL = inherit parent infra_item.unitPrice */
  unitPrice?: number | null;
  status: InfraItemVariantStatus;
  createdAt: string;
  updatedAt: string;
}

export type CreateInfraItemVariantBodyStatus =
  | (typeof CreateInfraItemVariantBodyStatus)[keyof typeof CreateInfraItemVariantBodyStatus]
  | null;

export const CreateInfraItemVariantBodyStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export interface CreateInfraItemVariantBody {
  /** Array of infra attribute_value_ids that together define this SKU. One junction row written per id. */
  attributeValueIds?: number[] | null;
  itemCode?: string | null;
  hsnCode?: string | null;
  gstRate?: number | null;
  unitPrice?: number | null;
  status?: CreateInfraItemVariantBodyStatus;
}

export type UpdateInfraItemVariantBodyStatus =
  | (typeof UpdateInfraItemVariantBodyStatus)[keyof typeof UpdateInfraItemVariantBodyStatus]
  | null;

export const UpdateInfraItemVariantBodyStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export interface UpdateInfraItemVariantBody {
  /** If provided, replaces the variant's entire attribute-value junction set. Display name is recomposed. */
  attributeValueIds?: number[] | null;
  itemCode?: string | null;
  hsnCode?: string | null;
  gstRate?: number | null;
  unitPrice?: number | null;
  status?: UpdateInfraItemVariantBodyStatus;
}

export interface InfraAcquisitionPayment {
  id: number;
  spaceId: number;
  acquisitionId: number;
  /** Amount paid in this installment */
  amount: number;
  paymentDate: string;
  paymentMethod?: string | null;
  paidBy?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentProofUrl?: string | null;
  notes?: string | null;
  createdAt: string;
}

export interface CreateInfraAcquisitionPaymentBody {
  amount: number;
  paymentDate: string;
  paymentMethod?: string | null;
  paidBy?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentProofUrl?: string | null;
  notes?: string | null;
}

export type SpaceFloorStatus =
  (typeof SpaceFloorStatus)[keyof typeof SpaceFloorStatus];

export const SpaceFloorStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface SpaceFloor {
  id: number;
  spaceId: number;
  name: string;
  level: number;
  canvasWidth: number;
  canvasHeight: number;
  /** Phase A — display scale; px/ft. Default 8. */
  pixelsPerFoot: number;
  status: SpaceFloorStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSpaceFloorBody {
  name: string;
  level: number;
  canvasWidth?: number | null;
  canvasHeight?: number | null;
  /** Phase A — default 8 if omitted. */
  pixelsPerFoot?: number | null;
}

export type UpdateSpaceFloorBodyStatus =
  | (typeof UpdateSpaceFloorBodyStatus)[keyof typeof UpdateSpaceFloorBodyStatus]
  | null;

export const UpdateSpaceFloorBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateSpaceFloorBody {
  name?: string | null;
  level?: number | null;
  canvasWidth?: number | null;
  canvasHeight?: number | null;
  pixelsPerFoot?: number | null;
  status?: UpdateSpaceFloorBodyStatus;
}

export interface FloorDesignProjectionCluster {
  designItemId: string;
  label: string;
  x: number;
  y: number;
  rows: number;
  seatsPerRow: number;
  seatWidthFt: number;
  seatLengthFt: number;
  tableLengthFt?: number | null;
  tableDepthFt: number;
  partitionType: string;
}

export interface FloorDesignProjectionResource {
  designItemId: string;
  clusterDesignItemId?: string | null;
  resourceType: string;
  label: string;
  seatIndex?: number | null;
  capacity?: number | null;
  x: number;
  y: number;
  w: number;
  h: number;
  rotation?: number | null;
  widthFt?: number | null;
  lengthFt?: number | null;
  status?: string | null;
  zone?: string | null;
}

export interface FloorDesignProjection {
  clusters: FloorDesignProjectionCluster[];
  resources: FloorDesignProjectionResource[];
}

/**
 * The full SDS Scene blob (opaque to the server).
 */
export type PutFloorDesignBodyScene = { [key: string]: unknown };

export interface PutFloorDesignBody {
  /** The full SDS Scene blob (opaque to the server). */
  scene: PutFloorDesignBodyScene;
  projection?: FloorDesignProjection;
}

/**
 * LIVE design (what /inventory/space sees).
 */
export type FloorDesignResponseScene = { [key: string]: unknown };

/**
 * Draft design if the operator has unpublished edits. NULL when there is no pending draft.
 */
export type FloorDesignResponsePendingScene = { [key: string]: unknown } | null;

export interface FloorDesignResponse {
  /** LIVE design (what /inventory/space sees). */
  scene: FloorDesignResponseScene;
  designUpdatedAt?: string | null;
  /** Draft design if the operator has unpublished edits. NULL when there is no pending draft. */
  pendingScene?: FloorDesignResponsePendingScene;
  pendingUpdatedAt?: string | null;
  pendingActorUserId?: number | null;
  /** True when pendingScene is not NULL (there are unpublished changes). */
  isDirty: boolean;
}

export interface FloorDesignBlockedItem {
  designItemId: string;
  resourceId: number;
  label: string;
  reason: string;
}

export type PutFloorDesignResponseProjected = { [key: string]: unknown } | null;

export interface PutFloorDesignResponse {
  ok: boolean;
  savedDesign?: boolean | null;
  projectionError?: string | null;
  projected?: PutFloorDesignResponseProjected;
  blocked?: FloorDesignBlockedItem[];
}

export interface SpaceSvgAsset {
  id: number;
  spaceId: number;
  name: string;
  markup: string;
  markupHash: string;
  viewBox: string;
  width?: number | null;
  height?: number | null;
  createdBy?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSpaceSvgAssetBody {
  name: string;
  markup: string;
  viewBox: string;
  width?: number | null;
  height?: number | null;
}

export interface UpdateSpaceSvgAssetBody {
  name: string;
}

/**
 * SpaceResourceType — fixed 4 values
 */
export type SpaceResourceResourceType =
  (typeof SpaceResourceResourceType)[keyof typeof SpaceResourceResourceType];

export const SpaceResourceResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
  Bay: "Bay",
  Cafeteria: "Cafeteria",
  Reception: "Reception",
  Washroom_Female: "Washroom_Female",
  Washroom_Male: "Washroom_Male",
  Store_Room: "Store_Room",
  Washbasin: "Washbasin",
  Pantry: "Pantry",
} as const;

/**
 * Derived server-side from resourceType (never client-set). Assignable = held to an account via Add Plan (Workstation/Private_Cabin). Amenity = physical common-area space (Bay, Cafeteria, Reception, Washroom_Female, Washroom_Male, Store_Room, Washbasin, Pantry). Bookable = per-slot booking (Meeting_Room/Conference_Room).
 */
export type SpaceResourceUnitKind =
  (typeof SpaceResourceUnitKind)[keyof typeof SpaceResourceUnitKind];

export const SpaceResourceUnitKind = {
  assignable: "assignable",
  amenity: "amenity",
  bookable: "bookable",
} as const;

/**
 * SpaceResourceStatus
 */
export type SpaceResourceStatus =
  (typeof SpaceResourceStatus)[keyof typeof SpaceResourceStatus];

export const SpaceResourceStatus = {
  Active: "Active",
  Out_of_service: "Out_of_service",
} as const;

export interface SpaceResource {
  id: number;
  spaceId: number;
  floorId: number;
  /** SpaceResourceType — fixed 4 values */
  resourceType: SpaceResourceResourceType;
  /** Derived server-side from resourceType (never client-set). Assignable = held to an account via Add Plan (Workstation/Private_Cabin). Amenity = physical common-area space (Bay, Cafeteria, Reception, Washroom_Female, Washroom_Male, Store_Room, Washbasin, Pantry). Bookable = per-slot booking (Meeting_Room/Conference_Room). */
  unitKind: SpaceResourceUnitKind;
  label: string;
  capacity: number;
  /** SpaceResourceStatus */
  status: SpaceResourceStatus;
  x: number;
  y: number;
  w: number;
  h: number;
  /** Real-world width in feet. */
  widthFt?: number | null;
  /** Real-world length (depth) in feet. */
  lengthFt?: number | null;
  /** Phase B — parent workstation cluster, NULL for standalone. */
  clusterId?: number | null;
  /** Phase B — 0-based seat ordinal within the cluster. */
  seatIndex?: number | null;
  zone?: string | null;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * SpaceResourceType
 */
export type CreateSpaceResourceBodyResourceType =
  (typeof CreateSpaceResourceBodyResourceType)[keyof typeof CreateSpaceResourceBodyResourceType];

export const CreateSpaceResourceBodyResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
  Bay: "Bay",
  Cafeteria: "Cafeteria",
  Reception: "Reception",
  Washroom_Female: "Washroom_Female",
  Washroom_Male: "Washroom_Male",
  Store_Room: "Store_Room",
  Washbasin: "Washbasin",
  Pantry: "Pantry",
} as const;

/**
 * Optional; server ignores this and derives unit_kind from resourceType via unitKindForResourceType(). Field kept in schema for future compatibility.
 */
export type CreateSpaceResourceBodyUnitKind =
  | (typeof CreateSpaceResourceBodyUnitKind)[keyof typeof CreateSpaceResourceBodyUnitKind]
  | null;

export const CreateSpaceResourceBodyUnitKind = {
  assignable: "assignable",
  amenity: "amenity",
  bookable: "bookable",
} as const;

/**
 * SpaceResourceStatus; defaults to Active
 */
export type CreateSpaceResourceBodyStatus =
  | (typeof CreateSpaceResourceBodyStatus)[keyof typeof CreateSpaceResourceBodyStatus]
  | null;

export const CreateSpaceResourceBodyStatus = {
  Active: "Active",
  Out_of_service: "Out_of_service",
} as const;

export interface CreateSpaceResourceBody {
  floorId: number;
  /** SpaceResourceType */
  resourceType: CreateSpaceResourceBodyResourceType;
  /** Optional; server ignores this and derives unit_kind from resourceType via unitKindForResourceType(). Field kept in schema for future compatibility. */
  unitKind?: CreateSpaceResourceBodyUnitKind;
  label: string;
  capacity?: number | null;
  /** SpaceResourceStatus; defaults to Active */
  status?: CreateSpaceResourceBodyStatus;
  x?: number | null;
  y?: number | null;
  w?: number | null;
  h?: number | null;
  widthFt?: number | null;
  lengthFt?: number | null;
  zone?: string | null;
  notes?: string | null;
}

/**
 * Optional; server ignores this and derives unit_kind from resourceType via unitKindForResourceType(). Field kept in schema for future compatibility.
 */
export type UpdateSpaceResourceBodyUnitKind =
  | (typeof UpdateSpaceResourceBodyUnitKind)[keyof typeof UpdateSpaceResourceBodyUnitKind]
  | null;

export const UpdateSpaceResourceBodyUnitKind = {
  assignable: "assignable",
  amenity: "amenity",
  bookable: "bookable",
} as const;

/**
 * SpaceResourceStatus
 */
export type UpdateSpaceResourceBodyStatus =
  | (typeof UpdateSpaceResourceBodyStatus)[keyof typeof UpdateSpaceResourceBodyStatus]
  | null;

export const UpdateSpaceResourceBodyStatus = {
  Active: "Active",
  Out_of_service: "Out_of_service",
} as const;

export interface UpdateSpaceResourceBody {
  label?: string | null;
  /** Optional; server ignores this and derives unit_kind from resourceType via unitKindForResourceType(). Field kept in schema for future compatibility. */
  unitKind?: UpdateSpaceResourceBodyUnitKind;
  capacity?: number | null;
  /** SpaceResourceStatus */
  status?: UpdateSpaceResourceBodyStatus;
  x?: number | null;
  y?: number | null;
  w?: number | null;
  h?: number | null;
  widthFt?: number | null;
  lengthFt?: number | null;
  zone?: string | null;
  notes?: string | null;
}

/**
 * 1 = one-sided; 2 = facing-each-other across a partition.
 */
export type SpaceWorkstationClusterRows =
  (typeof SpaceWorkstationClusterRows)[keyof typeof SpaceWorkstationClusterRows];

export const SpaceWorkstationClusterRows = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

export type SpaceWorkstationClusterPartitionType =
  (typeof SpaceWorkstationClusterPartitionType)[keyof typeof SpaceWorkstationClusterPartitionType];

export const SpaceWorkstationClusterPartitionType = {
  Lacquer_Glass: "Lacquer_Glass",
  None: "None",
} as const;

export type SpaceWorkstationClusterStatus =
  (typeof SpaceWorkstationClusterStatus)[keyof typeof SpaceWorkstationClusterStatus];

export const SpaceWorkstationClusterStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface SpaceWorkstationCluster {
  id: number;
  spaceId: number;
  floorId: number;
  label: string;
  x: number;
  y: number;
  /** 1 = one-sided; 2 = facing-each-other across a partition. */
  rows: SpaceWorkstationClusterRows;
  seatsPerRow: number;
  seatWidthFt: number;
  seatLengthFt: number;
  /** Default = seatsPerRow * seatWidthFt */
  tableLengthFt?: number | null;
  tableDepthFt: number;
  partitionType: SpaceWorkstationClusterPartitionType;
  status: SpaceWorkstationClusterStatus;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Default 2.
 */
export type CreateSpaceWorkstationClusterBodyRows =
  | (typeof CreateSpaceWorkstationClusterBodyRows)[keyof typeof CreateSpaceWorkstationClusterBodyRows]
  | null;

export const CreateSpaceWorkstationClusterBodyRows = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

/**
 * Default Lacquer_Glass (rows=2 only).
 */
export type CreateSpaceWorkstationClusterBodyPartitionType =
  | (typeof CreateSpaceWorkstationClusterBodyPartitionType)[keyof typeof CreateSpaceWorkstationClusterBodyPartitionType]
  | null;

export const CreateSpaceWorkstationClusterBodyPartitionType = {
  Lacquer_Glass: "Lacquer_Glass",
  None: "None",
} as const;

export interface CreateSpaceWorkstationClusterBody {
  floorId: number;
  label: string;
  x?: number | null;
  y?: number | null;
  /** Default 2. */
  rows?: CreateSpaceWorkstationClusterBodyRows;
  seatsPerRow: number;
  /** Default 3 ft. */
  seatWidthFt?: number | null;
  /** Default 3 ft. */
  seatLengthFt?: number | null;
  /** Default = seatsPerRow * seatWidthFt. */
  tableLengthFt?: number | null;
  /** Default 2 ft. */
  tableDepthFt?: number | null;
  /** Default Lacquer_Glass (rows=2 only). */
  partitionType?: CreateSpaceWorkstationClusterBodyPartitionType;
  notes?: string | null;
}

export interface UpdateSpaceWorkstationClusterBody {
  /** New top-left x; child seats shift by the delta. */
  x?: number | null;
  /** New top-left y; child seats shift by the delta. */
  y?: number | null;
  label?: string | null;
}

export interface CreateSpaceWorkstationClusterResponse {
  cluster: SpaceWorkstationCluster;
  seats: SpaceResource[];
}

export interface SpaceWorkstationClusterListResponse {
  clusters: SpaceWorkstationCluster[];
}

/**
 * AssignmentType
 */
export type ResourceAssignmentAssignmentType =
  (typeof ResourceAssignmentAssignmentType)[keyof typeof ResourceAssignmentAssignmentType];

export const ResourceAssignmentAssignmentType = {
  recurring: "recurring",
  daily: "daily",
  slot: "slot",
} as const;

export interface ResourceAssignment {
  id: number;
  spaceId: number;
  spaceResourceId: number;
  /** AssignmentType */
  assignmentType: ResourceAssignmentAssignmentType;
  memberId?: number | null;
  memberChargesId?: number | null;
  assignedDate: string;
  releaseDate?: string | null;
  slotStart?: string | null;
  slotEnd?: string | null;
  createdAt: string;
}

export interface AssignRecurringBody {
  memberId: number;
  /** Defaults to today if omitted */
  assignedDate?: string | null;
}

/**
 * SpaceResourceType
 */
export type OccupancyViewResourceType =
  (typeof OccupancyViewResourceType)[keyof typeof OccupancyViewResourceType];

export const OccupancyViewResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
  Bay: "Bay",
  Cafeteria: "Cafeteria",
  Reception: "Reception",
  Washroom_Female: "Washroom_Female",
  Washroom_Male: "Washroom_Male",
  Store_Room: "Store_Room",
  Washbasin: "Washbasin",
  Pantry: "Pantry",
} as const;

/**
 * Derived occupancy state for the requested date/time
 */
export type OccupancyViewStatus =
  (typeof OccupancyViewStatus)[keyof typeof OccupancyViewStatus];

export const OccupancyViewStatus = {
  Free: "Free",
  Occupied: "Occupied",
  Out_of_service: "Out_of_service",
} as const;

/**
 * AssignmentType; null when Free or Out_of_service
 */
export type OccupancyViewAssignmentType =
  | (typeof OccupancyViewAssignmentType)[keyof typeof OccupancyViewAssignmentType]
  | null;

export const OccupancyViewAssignmentType = {
  recurring: "recurring",
  daily: "daily",
  slot: "slot",
} as const;

export interface OccupancyView {
  resourceId: number;
  label: string;
  /** SpaceResourceType */
  resourceType: OccupancyViewResourceType;
  /** Derived occupancy state for the requested date/time */
  status: OccupancyViewStatus;
  x: number;
  y: number;
  w: number;
  h: number;
  /** AssignmentType; null when Free or Out_of_service */
  assignmentType?: OccupancyViewAssignmentType;
  /** For Occupied rows, the contact currently holding the seat (nullable for Free / Out_of_service rows). Powers deep-link to /members/:contactId. */
  contactId?: number | null;
  /** For Occupied rows, the account the contact belongs to. */
  accountId?: number | null;
  memberName?: string | null;
  assignedDate?: string | null;
  releaseDate?: string | null;
  slotStart?: string | null;
  slotEnd?: string | null;
}

export type StockInOrderStatus =
  (typeof StockInOrderStatus)[keyof typeof StockInOrderStatus];

export const StockInOrderStatus = {
  Draft: "Draft",
  Placed: "Placed",
  Partially_Delivered: "Partially_Delivered",
  Fully_Delivered: "Fully_Delivered",
  Closed: "Closed",
  Cancelled: "Cancelled",
} as const;

export type StockInOrderRefundTrigger =
  (typeof StockInOrderRefundTrigger)[keyof typeof StockInOrderRefundTrigger];

export const StockInOrderRefundTrigger = {
  Under_Delivery: "Under_Delivery",
  Cancellation: "Cancellation",
  Price_Drop: "Price_Drop",
  Quality_Rejection: "Quality_Rejection",
} as const;

export type StockInOrderCartLineStatus =
  (typeof StockInOrderCartLineStatus)[keyof typeof StockInOrderCartLineStatus];

export const StockInOrderCartLineStatus = {
  Ordered: "Ordered",
  In_Progress: "In_Progress",
  Delivered: "Delivered",
  Returned: "Returned",
  Refunded: "Refunded",
  Personal: "Personal",
} as const;

/**
 * Computed live from deliveries and refund lines. Populated on GET detail only.
 */
export type StockInOrderReconciliation = {
  prepaid?: number;
  deliveredValue?: number;
  refundsReceived?: number;
  balance?: number;
} | null;

export interface StockInOrderCartLine {
  id: number;
  spaceId: number;
  orderId: number;
  itemId: number;
  itemName?: string | null;
  /** inventory_items.brand (e.g. Continental Malgudi) */
  itemBrand?: string | null;
  /** Rich specs joined from inventory_items.specs JSONB (Flavour · Volume · Weight · Pack, etc., excluding Brand). Falls back to brand_agnostic_specs when JSONB is empty. */
  itemSpecs?: string | null;
  /** inventory_items.unit_of_measurement (e.g. piece, kg, pack) */
  itemUom?: string | null;
  /** inventory_items.current_stock at the time of the GET */
  itemCurrentStock?: number | null;
  variantId?: number | null;
  quantityOrdered: number;
  expectedUnitPrice: number;
  notes?: string | null;
  status: StockInOrderCartLineStatus;
  createdAt: string;
}

export interface StockInOrderRefundLine {
  id: number;
  spaceId: number;
  orderId: number;
  trigger: StockInOrderRefundTrigger;
  amount: number;
  notes?: string | null;
  /** Expected | Received */
  status: string;
  /** Cash | UPI | Bank_Transfer | Card | Cheque */
  receivedMethod?: string | null;
  /** UTR / transaction id */
  receivedReference?: string | null;
  receivedDate?: string | null;
  receivedProofUrl?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface StockInOrder {
  id: number;
  spaceId: number;
  /** ORD-YYMMDD-NNN auto-generated on create */
  orderId?: string | null;
  status: StockInOrderStatus;
  vendorId?: number | null;
  vendorNameFreeText?: string | null;
  expectedDeliveryFrom?: string | null;
  expectedDeliveryTo?: string | null;
  notes?: string | null;
  createdByUserId?: number | null;
  prepaidAmount?: number | null;
  /** Company | Personal */
  paidBy?: string | null;
  /** Cash | UPI | Bank_Transfer | Card | Cheque */
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  /** UTR / transaction id / cheque number */
  paymentReference?: string | null;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
  /** External reference (vendor PO number, e-commerce order id, etc.) */
  referenceId?: string | null;
  /** Uploaded proof of the order placement (confirmation email screenshot, PO PDF, …) */
  orderProofUrl?: string | null;
  /** Joined inventory_vendors.vendor_name when vendorId is set. Detail-response only. */
  vendorName?: string | null;
  createdAt: string;
  updatedAt: string;
  /** Total cart lines on this order. List response only. */
  cartLinesTotal?: number | null;
  /** Cart lines whose status='Delivered'. List response only. */
  cartLinesDelivered?: number | null;
  /** Sum of quantity_ordered across cart lines. List response only. */
  itemsOrdered?: number | null;
  /** Sum of quantity_received across linked stock_in receipts. List response only. */
  itemsDelivered?: number | null;
  /** SUM(quantity_ordered * expected_unit_price). List response only. */
  orderTotal?: number | null;
  /** Joined inventory_vendors.vendor_type — drives the vendor-nature badge in the CRM. List response only. */
  vendorType?: string | null;
  /** Count of cart lines flagged status='Delivered' but with qty still missing from receipts. Drives the Add Stock In PO picker. List response only. */
  nonStockInDeliveredLineCount?: number | null;
  /** MAX(stock_in.transaction_date) across linked receipts. Drives the 'Delivered Date' column with day-delta vs order date. List response only. */
  lastDeliveryDate?: string | null;
  /** Populated on GET detail only */
  cartLines?: StockInOrderCartLine[] | null;
  /** Linked stock_in receipts for this order. Populated on GET detail only. */
  deliveries?: StockIn[] | null;
  /** Populated on GET detail only */
  refundLines?: StockInOrderRefundLine[] | null;
  /** Computed live from deliveries and refund lines. Populated on GET detail only. */
  reconciliation?: StockInOrderReconciliation;
}

export interface StockInOrderListResponse {
  items: StockInOrder[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateStockInOrderCartLineInput {
  itemId: number;
  variantId?: number | null;
  quantityOrdered: number;
  expectedUnitPrice: number;
  notes?: string | null;
  /** Defaults to Ordered when omitted. Use Personal for items that won't enter stock. */
  status?: StockInOrderCartLineStatus | null;
}

export interface CreateStockInOrderBody {
  spaceId?: number | null;
  vendorId?: number | null;
  vendorNameFreeText?: string | null;
  expectedDeliveryFrom?: string | null;
  expectedDeliveryTo?: string | null;
  notes?: string | null;
  referenceId?: string | null;
  orderProofUrl?: string | null;
  cartLines: CreateStockInOrderCartLineInput[];
}

export interface UpdateStockInOrderHeaderBody {
  notes?: string | null;
  referenceId?: string | null;
  orderProofUrl?: string | null;
}

export interface RecordOrderPaymentBody {
  /** Upfront payment amount (pre-tax) */
  prepaidAmount: number;
  /** Company | Personal */
  paidBy?: string | null;
  /** Cash | UPI | Bank_Transfer | Card | Cheque */
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
}

export interface UpdateStockInOrderPaymentDetailsBody {
  /**
   * Correct the prepaid amount stamped at payment time (e.g., typo fix). Audit-logged.
   * @minimum 0
   */
  prepaidAmount?: number;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
}

export interface RecordOrderDeliveryBody {
  transactionDate: string;
  invoiceNumber?: string | null;
  invoiceDate?: string | null;
  invoicePdfUrl?: string | null;
  /** Whether input GST credit is claimed on this delivery invoice */
  gstInputClaimed?: boolean | null;
  notes?: string | null;
  lineItems: CreateStockInLineItem[];
  /** Additional invoice charges (Delivery, Handling, Platform Fee, Surge, …). Persisted into stock_in_charges and folded into grand total. */
  charges?: CreateStockInCharge[] | null;
}

export interface CreateOrderRefundLineBody {
  trigger: StockInOrderRefundTrigger;
  amount: number;
  notes?: string | null;
}

export interface UpdateStockInOrderCartLineBody {
  quantityOrdered?: number | null;
  expectedUnitPrice?: number | null;
  notes?: string | null;
}

export interface UpdateStockInOrderCartLineStatusBody {
  status: StockInOrderCartLineStatus;
}

/**
 * Mark refund as Received
 */
export type UpdateOrderRefundLineBodyStatus =
  (typeof UpdateOrderRefundLineBodyStatus)[keyof typeof UpdateOrderRefundLineBodyStatus];

export const UpdateOrderRefundLineBodyStatus = {
  Received: "Received",
} as const;

export interface UpdateOrderRefundLineBody {
  /** Mark refund as Received */
  status: UpdateOrderRefundLineBodyStatus;
  /** Cash | UPI | Bank_Transfer | Card | Cheque */
  receivedMethod?: string | null;
  receivedReference?: string | null;
  receivedDate?: string | null;
  receivedProofUrl?: string | null;
}

export interface CancelOrderBody {
  /** Optional cancellation reason (stored as notes on auto-created refund line) */
  reason?: string | null;
}

export interface CloseOrderBody {
  /** Set true to confirm close when undelivered value remains. Server auto-creates shortfall refund lines. */
  confirmShortfall?: boolean | null;
}

export interface StockInSummaryPeriod {
  from: string;
  to: string;
}

export interface StockInSummaryAmount {
  /** Sum for the current period */
  current: number;
  /** Sum for the previous same-length period */
  previous: number;
}

export interface StockInSummaryPerHead {
  /** Expense ÷ active member count */
  current: number;
  /** Active member count used as divisor */
  headCount: number;
}

export interface StockInSummary {
  period: StockInSummaryPeriod;
  previous: StockInSummaryPeriod;
  receipts: StockInSummaryAmount;
  pendingReceipts: StockInSummaryAmount;
  expense: StockInSummaryAmount;
  expensePerHead: StockInSummaryPerHead;
}

/**
 * Phase 26: soft-archive flag. DELETE flips to Archived; default catalog/list filters to Active.
 */
export type InventoryPlanPeriodStatus =
  (typeof InventoryPlanPeriodStatus)[keyof typeof InventoryPlanPeriodStatus];

export const InventoryPlanPeriodStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

/**
 * Phase 26: server-derived from cycle via parsePeriodCycle (e.g., 'Month' for '3_Month').
 */
export type InventoryPlanPeriodPeriodUnit =
  | (typeof InventoryPlanPeriodPeriodUnit)[keyof typeof InventoryPlanPeriodPeriodUnit]
  | null;

export const InventoryPlanPeriodPeriodUnit = {
  Hour: "Hour",
  Day: "Day",
  Month: "Month",
} as const;

export interface InventoryPlanPeriod {
  id: number;
  planId: number;
  /** Legacy enum (Monthly/Quarterly/Six_Month/Yearly) or new {n}_{Hour|Day|Month} format */
  cycle: string;
  /** Stored as numeric(5,2); operator types percent (e.g., 5 means 5%). */
  discountPct: number;
  /** When non-null, REPLACES the plan-level securityDepositAmount for billing at this cycle. */
  securityDepositAmount?: number | null;
  /** Phase 26: absolute price override for this period (XOR with discountPct). */
  price?: number | null;
  /** Phase 26: per-period validity days (Non_Recurring catalog use). */
  validityDays?: number | null;
  /** Phase 26: soft-archive flag. DELETE flips to Archived; default catalog/list filters to Active. */
  status?: InventoryPlanPeriodStatus;
  /** Phase 26: server-derived from cycle via parsePeriodCycle (e.g., 3 for '3_Month'). */
  periodValue?: number | null;
  /** Phase 26: server-derived from cycle via parsePeriodCycle (e.g., 'Month' for '3_Month'). */
  periodUnit?: InventoryPlanPeriodPeriodUnit;
  /**
   * Phase 27 — seats dimension on the pricing matrix. Each (period, seats)
tuple is unique per plan via partial idx
`inventory_plan_periods_active_value_unit_seats_unique` (status='Active').

   * @minimum 1
   */
  seats?: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * Phase 26: optional on input; defaults to Active server-side. Pass 'Active' to reactivate an Archived row.
 */
export type CreateInventoryPlanPeriodBodyStatus =
  (typeof CreateInventoryPlanPeriodBodyStatus)[keyof typeof CreateInventoryPlanPeriodBodyStatus];

export const CreateInventoryPlanPeriodBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

/**
 * Phase 26: optional on input — server derives from cycle via parsePeriodCycle.
 */
export type CreateInventoryPlanPeriodBodyPeriodUnit =
  | (typeof CreateInventoryPlanPeriodBodyPeriodUnit)[keyof typeof CreateInventoryPlanPeriodBodyPeriodUnit]
  | null;

export const CreateInventoryPlanPeriodBodyPeriodUnit = {
  Hour: "Hour",
  Day: "Day",
  Month: "Month",
} as const;

export interface CreateInventoryPlanPeriodBody {
  /** Phase 26: optional on input — defaults to 0 server-side. XOR with price when > 0. */
  discountPct?: number;
  securityDepositAmount?: number | null;
  /** Phase 26: absolute price override (XOR with discountPct > 0). */
  price?: number | null;
  /** Phase 26: per-period validity days. */
  validityDays?: number | null;
  /** Phase 26: optional on input; defaults to Active server-side. Pass 'Active' to reactivate an Archived row. */
  status?: CreateInventoryPlanPeriodBodyStatus;
  /** Phase 26: optional on input — server derives from cycle via parsePeriodCycle. */
  periodValue?: number | null;
  /** Phase 26: optional on input — server derives from cycle via parsePeriodCycle. */
  periodUnit?: CreateInventoryPlanPeriodBodyPeriodUnit;
  /**
   * Phase 27 — optional seats dimension. Defaults to 1 server-side when omitted. Back-compat with Phase 26 callers.
   * @minimum 1
   */
  seats?: number;
}

export type SundayAccessRateResourceType =
  (typeof SundayAccessRateResourceType)[keyof typeof SundayAccessRateResourceType];

export const SundayAccessRateResourceType = {
  Private_Cabin: "Private_Cabin",
  Workstation: "Workstation",
} as const;

export interface SundayAccessRate {
  id: number;
  spaceId: number;
  resourceType: SundayAccessRateResourceType;
  /** Rupees per unit per month. Multiplied by the line's quantity. */
  monthlyFee: number;
  isActive: boolean;
}

export interface UpsertSundayAccessRateBody {
  /** @minimum 0 */
  monthlyFee: number;
  isActive?: boolean;
  spaceId?: number | null;
}

export interface SundayAccessToggleResult {
  ok: boolean;
  enabled: boolean;
  /** Fee per month for the whole line (rate x quantity). */
  monthlyFee: number;
  repricedPeriodIds: number[];
  /** Periods left untouched because they are already settled (paid, part-paid, invoiced, credit-noted, pinned, or with a payment attached). */
  skippedPeriodIds: number[];
  /** Repriced periods that already carry an order receipt. Press Update on the receipt to regenerate it with the new amount. */
  receiptsToRefreshPeriodIds: number[];
  /** Subset of receiptsToRefreshPeriodIds whose receipt was already sent to the client at the old amount. */
  receiptsAlreadySentPeriodIds: number[];
  /** Start date of the earliest repriced period. */
  effectiveFrom?: string | null;
}

export type PlanSecondaryAccessResourceType =
  (typeof PlanSecondaryAccessResourceType)[keyof typeof PlanSecondaryAccessResourceType];

export const PlanSecondaryAccessResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
} as const;

export interface PlanSecondaryAccess {
  id: number;
  planId: number;
  resourceType: PlanSecondaryAccessResourceType;
  /** 0=full price; 100=free; 0..100=N% off normal pricing for this resource_type. */
  discountPct: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePlanSecondaryAccessBody {
  discountPct: number;
}

export type PublicPlanPeriodOverrideCycle =
  (typeof PublicPlanPeriodOverrideCycle)[keyof typeof PublicPlanPeriodOverrideCycle];

export const PublicPlanPeriodOverrideCycle = {
  Quarterly: "Quarterly",
  Six_Month: "Six_Month",
  Yearly: "Yearly",
} as const;

export interface PublicPlanPeriodOverride {
  cycle: PublicPlanPeriodOverrideCycle;
  discountPct: number;
  /** Pre-computed monthlyPrice × (1 - discountPct/100) for website rendering convenience. */
  effectiveMonthlyRate?: number;
}

export interface PublicPlan {
  /** planName.toLowerCase().replace(/_/g, '-') */
  slug: string;
  planName: string;
  description?: string | null;
  monthlyPrice: number;
  minimumCommitmentMonths?: number | null;
  resourceType: string;
  dedicatedAmenities?: string[];
  commonAmenities?: string[];
  periodOverrides?: PublicPlanPeriodOverride[];
}

export type AttendanceSessionStatus =
  (typeof AttendanceSessionStatus)[keyof typeof AttendanceSessionStatus];

export const AttendanceSessionStatus = {
  open: "open",
  closed: "closed",
  anomalous: "anomalous",
} as const;

export interface AttendanceSession {
  id: number;
  spaceId: number;
  contactId: number;
  accountId: number;
  entryPunchId?: number | null;
  exitPunchId?: number | null;
  entryAt?: string | null;
  exitAt?: string | null;
  durationMinutes?: number | null;
  sessionDate: string;
  status: AttendanceSessionStatus;
  source: string;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
  userId?: number | null;
  contactName?: string | null;
  accountName?: string | null;
  userName?: string | null;
  personType?: string | null;
  checkoutDistanceM?: number | null;
  checkoutOverride?: boolean | null;
}

export interface AttendanceSessionListResponse {
  items: AttendanceSession[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateAttendanceSessionBody {
  contactId: number;
  entryAt: string;
  exitAt?: string | null;
  note?: string | null;
}

export interface UpdateAttendanceSessionBody {
  entryAt?: string | null;
  exitAt?: string | null;
  status?: AttendanceSessionStatus | null;
  note?: string | null;
}

export interface AttendanceDevice {
  id: number;
  spaceId: number;
  serialNumber: string;
  name: string;
  location?: string | null;
  model?: string | null;
  mode?: string;
  isActive: boolean;
  lastSeenAt?: string | null;
  lastPunchAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAttendanceDeviceBody {
  spaceId?: number | null;
  serialNumber: string;
  name: string;
  location?: string | null;
  model?: string | null;
  mode?: string | null;
  isActive?: boolean | null;
}

export interface UpdateAttendanceDeviceBody {
  name?: string | null;
  location?: string | null;
  model?: string | null;
  mode?: string | null;
  isActive?: boolean | null;
}

export interface ImportAttendanceRow {
  pin: string;
  time: string;
  status?: number | null;
}

export interface ImportAttendanceBody {
  deviceSerial?: string | null;
  rows: ImportAttendanceRow[];
}

export interface ImportAttendanceResponse {
  received: number;
  inserted: number;
  duplicates: number;
  unresolved: number;
}

export interface CheckoutAttendanceSessionBody {
  lat?: number | null;
  lng?: number | null;
  override?: boolean | null;
}

export interface GeofenceSpace {
  spaceId: number;
  spaceName: string;
  geoLat?: number | null;
  geoLng?: number | null;
  geoRadiusM?: number | null;
}

export interface UpdateGeofenceBody {
  geoLat?: number | null;
  geoLng?: number | null;
  geoRadiusM?: number | null;
}

export interface ResyncAttendanceResponse {
  matched: number;
}

export interface AttendanceRosterEntry {
  contactId: number;
  fullName: string;
  accountId?: number | null;
  accountName?: string | null;
  biometricId?: string | null;
  enrolled?: boolean;
  deactivated?: boolean;
  present: boolean;
  sessionId?: number | null;
  entryAt?: string | null;
  exitAt?: string | null;
  status?: string | null;
}

export interface StaffAttendanceDayEntry {
  userId: number;
  entryAt?: string | null;
  exitAt?: string | null;
  durationMinutes?: number | null;
  openSessionId?: number | null;
  openEntryAt?: string | null;
  loggedIn: boolean;
}

export interface LogoutAttendanceSessionBody {
  exitAt?: string | null;
  note?: string | null;
}

export interface PunchLogEntry {
  day: string;
  pin: string;
  contactId?: number | null;
  userId?: number | null;
  personName?: string | null;
  personType: string;
  accountName?: string | null;
  taps: number;
  firstAt?: string | null;
  lastAt?: string | null;
  times: string[];
}

export interface CommunicationLogEntry {
  id: number;
  spaceId: number;
  accountId: number;
  contactId?: number | null;
  channel: string;
  eventType: string;
  recipient: string;
  status: string;
  provider: string;
  errorDetail?: string | null;
  bodyPreview?: string | null;
  pdfUrl?: string | null;
  documentId?: number | null;
  documentRef?: string | null;
  sentAt: string;
  createdAt: string;
}

export interface CommunicationLogListResponse {
  items: CommunicationLogEntry[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreditNoteLine {
  id: number;
  description: string;
  taxableAmount: number;
  gstRate: number;
  cgstAmount: number;
  sgstAmount: number;
  igstAmount: number;
  lineTotal: number;
}

/**
 * Operator-chosen terminal/pending state. Cannot move back to Issued or to Applied (Applied is set internally when the credit is consumed by a new membership).
 */
export type SettleCreditNoteBodySettlementStatus =
  (typeof SettleCreditNoteBodySettlementStatus)[keyof typeof SettleCreditNoteBodySettlementStatus];

export const SettleCreditNoteBodySettlementStatus = {
  Refunded: "Refunded",
  Adjusted: "Adjusted",
} as const;

export interface SettleCreditNoteBody {
  /** Operator-chosen terminal/pending state. Cannot move back to Issued or to Applied (Applied is set internally when the credit is consumed by a new membership). */
  settlementStatus: SettleCreditNoteBodySettlementStatus;
  /** Refund date (for Refunded). Defaults to today. */
  settlementDate?: string | null;
  /** How the refund was paid (UPI / Bank_Transfer / etc.). For Refunded only. */
  settlementPaymentMode?: string | null;
  /** Public URL of the refund proof (bank slip / UPI screenshot). For Refunded only. */
  settlementProofUrl?: string | null;
  settlementNotes?: string | null;
}

export interface ApplyCreditNoteToPeriodBody {
  /** Target period to apply the credit note toward. WHOLE credit note only — server clamps the applied amount to min(creditNote.totalReversed, period.amount - period.amountPaid); no partial-amount input. */
  periodId: number;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
}

export interface CreateManualCreditNoteBody {
  /** The exited / source membership the credit note is being issued against. */
  membershipId: number;
  /**
   * GST-INCLUSIVE total to credit. Server splits taxable + GST at the source plan's rate.
   * @minimum 0.01
   */
  amount: number;
  /** Free-text reason; printed on the credit-note PDF. */
  reason?: string | null;
}

export type CreditNoteSettlementStatus =
  (typeof CreditNoteSettlementStatus)[keyof typeof CreditNoteSettlementStatus];

export const CreditNoteSettlementStatus = {
  Issued: "Issued",
  Refunded: "Refunded",
  Adjusted: "Adjusted",
  Applied: "Applied",
} as const;

export interface CreditNote {
  id: number;
  spaceId: number;
  accountId: number;
  periodId?: number | null;
  creditNoteNumber: string;
  creditNoteDate: string;
  appliedToInvoiceNumber?: string | null;
  taxableReversed: number;
  cgstReversed: number;
  sgstReversed: number;
  igstReversed: number;
  totalReversed: number;
  pdfUrl?: string | null;
  issuedAt?: string | null;
  settlementStatus?: CreditNoteSettlementStatus;
  settlementDate?: string | null;
  settlementPaymentMode?: string | null;
  settlementProofUrl?: string | null;
  settlementNotes?: string | null;
  appliedToMembershipId?: number | null;
  membershipId?: number | null;
  createdAt: string;
  lines?: CreditNoteLine[] | null;
}

export type BundleReceiptBodyChannel =
  | (typeof BundleReceiptBodyChannel)[keyof typeof BundleReceiptBodyChannel]
  | null;

export const BundleReceiptBodyChannel = {
  whatsapp: "whatsapp",
  email: "email",
} as const;

export interface BundleReceiptBody {
  quoteGroupId: string;
  periodIds?: number[] | null;
  memberChargeIds?: number[] | null;
  channel?: BundleReceiptBodyChannel;
}

export interface BundleReceiptResult {
  receiptNumber: string;
  pdfUrl: string;
  lineCount: number;
  sent: boolean;
  channel?: string | null;
}

export type BundleInvoiceBodyChannel =
  | (typeof BundleInvoiceBodyChannel)[keyof typeof BundleInvoiceBodyChannel]
  | null;

export const BundleInvoiceBodyChannel = {
  whatsapp: "whatsapp",
  email: "email",
} as const;

export interface BundleInvoiceBody {
  quoteGroupId: string;
  periodIds?: number[] | null;
  memberChargeIds?: number[] | null;
  channel?: BundleInvoiceBodyChannel;
}

export interface BundleInvoiceResult {
  invoiceNumber: string;
  pdfUrl: string;
  lineCount: number;
  sent: boolean;
  channel?: string | null;
}

export interface RestructureItem {
  membershipId: number;
  newPerMonth: number;
  quantity: number;
  gstApplicable: boolean;
  newDepositAmount?: number | null;
}

export type DepositDispositionDisposition =
  (typeof DepositDispositionDisposition)[keyof typeof DepositDispositionDisposition];

export const DepositDispositionDisposition = {
  refund: "refund",
  adjust_new_deposit: "adjust_new_deposit",
  adjust_package: "adjust_package",
} as const;

export interface DepositDisposition {
  depositId: number;
  membershipId?: number | null;
  disposition: DepositDispositionDisposition;
  amount?: number;
  heldDepositAmount?: number | null;
}

export type RestructureBodyCreditDisposition =
  | (typeof RestructureBodyCreditDisposition)[keyof typeof RestructureBodyCreditDisposition]
  | null;

export const RestructureBodyCreditDisposition = {
  refund: "refund",
  adjust: "adjust",
} as const;

export type RestructureBodyRefundPaymentMode =
  | (typeof RestructureBodyRefundPaymentMode)[keyof typeof RestructureBodyRefundPaymentMode]
  | null;

export const RestructureBodyRefundPaymentMode = {
  Cash: "Cash",
  UPI: "UPI",
} as const;

export interface RestructureBody {
  quoteGroupId?: string | null;
  membershipIds?: number[] | null;
  depositDispositions?: DepositDisposition[] | null;
  creditDisposition?: RestructureBodyCreditDisposition;
  refundPaymentMode?: RestructureBodyRefundPaymentMode;
  refundPaymentDate?: string | null;
  refundProofUrl?: string | null;
  cutoverDate: string;
  newCycleMode?: string | null;
  /** @minimum 1 */
  durationMonths: number;
  /** @minItems 1 */
  items: RestructureItem[];
  additionalDiscountPct?: number | null;
}

export interface RestructureResult {
  creditNoteId: number;
  creditNoteNumber: string;
  creditNoteTotal: number;
  newQuoteGroupId: string;
  newMembershipIds: number[];
  netDue: number;
  refundIds?: number[] | null;
  depositAdjustToPackageTotal?: number | null;
  effectiveCreditTotal?: number | null;
}

export interface Refund {
  id: number;
  spaceId?: number;
  accountId: number;
  creditNoteId?: number | null;
  depositId?: number | null;
  creditNoteNumber?: string | null;
  amount: number;
  paymentMode: string;
  refundDate: string;
  proofUrl?: string | null;
  notes?: string | null;
  status: string;
  createdAt?: string;
}

export interface RefundList {
  items: Refund[];
}

export type HeldDepositSettlementStatus =
  (typeof HeldDepositSettlementStatus)[keyof typeof HeldDepositSettlementStatus];

export const HeldDepositSettlementStatus = {
  Held: "Held",
  Refunded: "Refunded",
  Adjusted: "Adjusted",
  Applied: "Applied",
} as const;

export interface HeldDeposit {
  id: number;
  spaceId?: number;
  accountId: number;
  amount: number;
  status: string;
  lockInUntilDate?: string | null;
  resourceType?: string | null;
  createdAt?: string;
  settlementStatus?: HeldDepositSettlementStatus;
  settlementDate?: string | null;
  settlementPaymentMode?: string | null;
  settlementProofUrl?: string | null;
  settlementNotes?: string | null;
  appliedToMembershipId?: number | null;
  membershipId?: number | null;
}

/**
 * Refunded is terminal and gated on lockInUntilDate <= today (returns 400 lock_in_not_completed otherwise). Adjusted is pending and auto-applies to the customer's next plan.
 */
export type SettleDepositBodySettlementStatus =
  (typeof SettleDepositBodySettlementStatus)[keyof typeof SettleDepositBodySettlementStatus];

export const SettleDepositBodySettlementStatus = {
  Refunded: "Refunded",
  Adjusted: "Adjusted",
} as const;

export interface SettleDepositBody {
  /** Refunded is terminal and gated on lockInUntilDate <= today (returns 400 lock_in_not_completed otherwise). Adjusted is pending and auto-applies to the customer's next plan. */
  settlementStatus: SettleDepositBodySettlementStatus;
  /** Refund date (for Refunded). Defaults to today. */
  settlementDate?: string | null;
  settlementPaymentMode?: string | null;
  settlementProofUrl?: string | null;
  settlementNotes?: string | null;
}

export interface ApplyDepositToPeriodBody {
  /** Target period to apply the deposit toward. Server clamps the applied amount to min(deposit.amount, period.amount - period.amountPaid) — the full deposit amount is used, no partial-amount input. */
  periodId: number;
  paymentDate?: string | null;
  paymentProofUrl?: string | null;
}

export interface DepositList {
  items: HeldDeposit[];
}

export interface ExitRenewItem {
  planId: number;
  perMonth: number;
  quantity: number;
  gstApplicable: boolean;
}

export interface ExitRenewBody {
  quoteGroupId: string;
  exitDate: string;
  /** @minItems 1 */
  renewItems: ExitRenewItem[];
  newCycleMode?: string | null;
  durationMonths?: number | null;
  newStartDate: string;
  dropMemberChargeIds?: number[] | null;
}

export interface ExitRenewResult {
  newQuoteGroupId: string;
  newMembershipIds: number[];
  droppedChargeIds: number[];
}

export interface RegenerateCreditNotePdfResult {
  creditNoteId: number;
  creditNoteNumber: string;
  pdfUrl?: string | null;
  uploaded: boolean;
}

export type TaskType = (typeof TaskType)[keyof typeof TaskType];

export const TaskType = {
  operational: "operational",
  complaint: "complaint",
  request: "request",
  maintenance: "maintenance",
  feedback_followup: "feedback_followup",
  assignment: "assignment",
} as const;

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

export const TaskStatus = {
  open: "open",
  assigned: "assigned",
  in_progress: "in_progress",
  on_hold: "on_hold",
  awaiting_validation: "awaiting_validation",
  resolved: "resolved",
  closed: "closed",
  cancelled: "cancelled",
  missed: "missed",
} as const;

export type TaskPriority = (typeof TaskPriority)[keyof typeof TaskPriority];

export const TaskPriority = {
  P1: "P1",
  P2: "P2",
  P3: "P3",
  P4: "P4",
} as const;

export type TaskChannel = (typeof TaskChannel)[keyof typeof TaskChannel];

export const TaskChannel = {
  whatsapp_priya: "whatsapp_priya",
  voice_riya: "voice_riya",
  walk_in: "walk_in",
  member_app: "member_app",
  qr_code: "qr_code",
  staff: "staff",
  email: "email",
  system_recurring: "system_recurring",
} as const;

export type TaskCancelReason =
  (typeof TaskCancelReason)[keyof typeof TaskCancelReason];

export const TaskCancelReason = {
  duplicate: "duplicate",
  member_withdrew: "member_withdrew",
  not_reproducible: "not_reproducible",
  out_of_scope: "out_of_scope",
  other: "other",
} as const;

export type TaskActor = (typeof TaskActor)[keyof typeof TaskActor];

export const TaskActor = {
  user: "user",
  priya: "priya",
  riya: "riya",
  system: "system",
} as const;

export type ChecklistProofType =
  (typeof ChecklistProofType)[keyof typeof ChecklistProofType];

export const ChecklistProofType = {
  none: "none",
  photo: "photo",
  note: "note",
  signature: "signature",
} as const;

export type TaskActivityEventType =
  (typeof TaskActivityEventType)[keyof typeof TaskActivityEventType];

export const TaskActivityEventType = {
  created: "created",
  status_change: "status_change",
  comment: "comment",
  assignment: "assignment",
  priority_override: "priority_override",
  checklist_tick: "checklist_tick",
  checklist_validate: "checklist_validate",
  cancelled: "cancelled",
  sla_nudge: "sla_nudge",
  sla_breach: "sla_breach",
  escalation: "escalation",
  checklist_reject: "checklist_reject",
} as const;

export interface Task {
  id: number;
  spaceId: number;
  /** e.g. NJF-T-00147 */
  taskNumber: string;
  seq: number;
  type: TaskType;
  categoryId?: number | null;
  title: string;
  description?: string | null;
  accountId?: number | null;
  reportedByContactId?: number | null;
  zoneResourceId?: number | null;
  zoneLabel: string;
  channel: TaskChannel;
  priority: TaskPriority;
  status: TaskStatus;
  assigneeId?: number | null;
  assignedRole?: string | null;
  vendorName?: string | null;
  vendorExpectedAt?: string | null;
  cancelReason?: TaskCancelReason | null;
  cancelNote?: string | null;
  holdReason?: string | null;
  parentTaskId?: number | null;
  relatedTaskId?: number | null;
  templateId?: number | null;
  createdByUserId?: number | null;
  createdByActor: TaskActor;
  slaRespondBy?: string | null;
  slaResolveBy?: string | null;
  dueAt?: string | null;
  heldSince?: string | null;
  validatedBy?: number | null;
  validatedAt?: string | null;
  reopenCount: number;
  billable: boolean;
  billingMemberChargeId?: number | null;
  creditNoteId?: number | null;
  compensationPending: boolean;
  firstResponseAt?: string | null;
  resolvedAt?: string | null;
  closedAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type TaskActivityMetadata = { [key: string]: unknown } | null;

export interface TaskActivity {
  id: number;
  spaceId: number;
  taskId: number;
  eventType: TaskActivityEventType;
  actor: TaskActor;
  actorUserId?: number | null;
  metadata?: TaskActivityMetadata;
  createdAt: string;
}

export interface TaskChecklistItem {
  id: number;
  spaceId: number;
  taskId: number;
  seq: number;
  label: string;
  required: boolean;
  doneByUserId?: number | null;
  doneAt?: string | null;
  naReason?: string | null;
  /** Phase 44 — TCHK-06/07 */
  validatedByUserId?: number | null;
  /** Phase 44 — TCHK-06/07 */
  validatedAt?: string | null;
  /** 0-based index within this item's atTimes[] fan-out; 0 for a non-fanned-out item */
  occurrenceSeq: number;
  /** 'HH:MM' this occurrence was spawned for — copied from task_template_item.atTimes[occurrenceSeq] */
  occurrenceAtTime?: string | null;
  /** Doer's clock — freezes at the doer's tick */
  doerDueAt?: string | null;
  doerNudgedAt?: string | null;
  /** Sweep idempotency stamp ONLY — never read this to render breach state; use doerBreached below */
  doerBreachedAt?: string | null;
  /** The validator's OWN separate bounded window, starting at the doer's tick — a stalled validator escalates against the validator, never the doer */
  validationDueAt?: string | null;
  validationNudgedAt?: string | null;
  /** Sweep idempotency stamp ONLY — never read this to render breach state; use validationBreached below */
  validationBreachedAt?: string | null;
  /** Copied from the template item at spawn (TREC-07 discipline) — never live-joined back to the template */
  proofType?: ChecklistProofType | null;
  completeWithinMinutes?: number | null;
  validatorRole?: string | null;
  validatorUserId?: number | null;
  /**
   * TPRF-02 — up to 5 photo URLs
   * @maxItems 5
   */
  proofUrls?: string[] | null;
  proofNote?: string | null;
  signatureUrl?: string | null;
  /** TPRF-03 — the CLIENT's name, not the staff member's */
  signerName?: string | null;
  /** Server-stamped at tick time — never accepted from the client */
  signedAt?: string | null;
  rejectReason?: string | null;
  rejectedByUserId?: number | null;
  rejectedAt?: string | null;
  /** Computed on read (now > doerDueAt AND doneAt IS NULL AND naReason IS NULL) — NOT the doerBreachedAt column, which exists only for sweep idempotency. Never stale between sweeps. */
  readonly doerBreached?: boolean;
  /** Computed on read, same discipline as doerBreached above, against validationDueAt/validatedAt. */
  readonly validationBreached?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TaskWatcher {
  id: number;
  spaceId: number;
  taskId: number;
  userId: number;
  createdAt: string;
}

export interface TaskAttachment {
  id: number;
  spaceId: number;
  taskId: number;
  url: string;
  uploadedByUserId?: number | null;
  createdAt: string;
}

/**
 * Task + its full append-only activity log, attachments, watchers, checklist items (TASK-05/06/10)
 */
export type TaskDetail = Task & {
  activity: TaskActivity[];
  attachments: TaskAttachment[];
  watchers: TaskWatcher[];
  checklistItems: TaskChecklistItem[];
};

export interface CreateTaskBody {
  type: TaskType;
  /** Admin-only override; non-admins are always forced to their own space */
  spaceId?: number | null;
  categoryId?: number | null;
  /** @minLength 1 */
  title: string;
  description?: string | null;
  accountId?: number | null;
  reportedByContactId?: number | null;
  zoneResourceId?: number | null;
  /** @minLength 1 */
  zoneLabel: string;
  channel: TaskChannel;
  priority: TaskPriority;
  assigneeId?: number | null;
  /** TPRM-08 role-pool assignment before a person claims */
  assignedRole?: string | null;
  vendorName?: string | null;
  vendorExpectedAt?: string | null;
  parentTaskId?: number | null;
  relatedTaskId?: number | null;
}

export interface AssignTaskBody {
  assigneeId?: number | null;
  assignedRole?: string | null;
}

export interface ReassignTaskBody {
  assigneeId?: number | null;
  assignedRole?: string | null;
}

export interface HoldTaskBody {
  /** @minLength 1 */
  holdReason: string;
}

export interface CancelTaskBody {
  cancelReason: TaskCancelReason;
  /** @minLength 10 */
  cancelNote: string;
}

export interface OverrideTaskPriorityBody {
  priority: TaskPriority;
  /** @minLength 10 */
  note: string;
}

export interface AddTaskAttachmentBody {
  /** @minLength 1 */
  url: string;
}

export interface AddTaskWatcherBody {
  userId: number;
}

export type TaskStaleTransitionResponseError =
  (typeof TaskStaleTransitionResponseError)[keyof typeof TaskStaleTransitionResponseError];

export const TaskStaleTransitionResponseError = {
  stale_transition: "stale_transition",
} as const;

export interface TaskStaleTransitionResponse {
  error: TaskStaleTransitionResponseError;
  /** e.g. Already resolved by Khushi at 3:15 PM */
  message: string;
}

export type TaskIllegalTransitionResponseError =
  (typeof TaskIllegalTransitionResponseError)[keyof typeof TaskIllegalTransitionResponseError];

export const TaskIllegalTransitionResponseError = {
  illegal_transition: "illegal_transition",
} as const;

export interface TaskIllegalTransitionResponse {
  error: TaskIllegalTransitionResponseError;
  from: string;
  to: string;
  legal: string[];
}

export interface TaskCategory {
  id: number;
  spaceId: number | null;
  /** complaint | request | maintenance | operational | assignment */
  type: string;
  name: string;
  defaultPriority: TaskPriority;
  slaPolicyId?: number | null;
  routingRuleId?: number | null;
  sort: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTaskCategoryBody {
  /** Admin-only override; non-admins are always forced to their own space */
  spaceId?: number | null;
  /** @minLength 1 */
  type: string;
  /** @minLength 1 */
  name: string;
  defaultPriority: TaskPriority;
  slaPolicyId?: number | null;
  routingRuleId?: number | null;
  sort?: number | null;
}

export interface UpdateTaskCategoryBody {
  /** @minLength 1 */
  name?: string;
  defaultPriority?: TaskPriority;
  slaPolicyId?: number | null;
  routingRuleId?: number | null;
  sort?: number;
  active?: boolean;
}

export interface SlaPolicy {
  id: number;
  spaceId: number | null;
  /** Free-text priority key (P1..P4 in seed data; not enum-constrained at the DB level) */
  priority: string;
  /** Relative duration — the absolute freeze onto a task row happens at task-creation time (Phase 42), never here */
  respondMinutes: number;
  resolveMinutes: number;
  name?: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSlaPolicyBody {
  spaceId?: number | null;
  /** @minLength 1 */
  priority: string;
  /** @minimum 1 */
  respondMinutes: number;
  /** @minimum 1 */
  resolveMinutes: number;
  name?: string | null;
}

export interface UpdateSlaPolicyBody {
  /** @minimum 1 */
  respondMinutes?: number;
  /** @minimum 1 */
  resolveMinutes?: number;
  name?: string | null;
  active?: boolean;
}

export interface RoutingRule {
  id: number;
  spaceId: number | null;
  sortOrder: number;
  /** task.type this row routes for */
  matchType: string;
  /** NULL = wildcard/fallback for matchType; may be a comma-separated list */
  matchCategory?: string | null;
  matchCondition?: string | null;
  assignToRole: string;
  defaultPriority: TaskPriority;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRoutingRuleBody {
  spaceId?: number | null;
  /** Defaults to end-of-list (max sortOrder + 1) for the target space when omitted */
  sortOrder?: number | null;
  /** @minLength 1 */
  matchType: string;
  matchCategory?: string | null;
  matchCondition?: string | null;
  /** @minLength 1 */
  assignToRole: string;
  defaultPriority: TaskPriority;
}

export interface UpdateRoutingRuleBody {
  /** @minLength 1 */
  matchType?: string;
  matchCategory?: string | null;
  matchCondition?: string | null;
  /** @minLength 1 */
  assignToRole?: string;
  defaultPriority?: TaskPriority;
  active?: boolean;
}

export type ReorderRoutingRuleBodyDirection =
  (typeof ReorderRoutingRuleBodyDirection)[keyof typeof ReorderRoutingRuleBodyDirection];

export const ReorderRoutingRuleBodyDirection = {
  up: "up",
  down: "down",
} as const;

export interface ReorderRoutingRuleBody {
  direction: ReorderRoutingRuleBodyDirection;
}

export interface EscalationRule {
  id: number;
  spaceId: number | null;
  /** sla_50 | sla_breach | p1_created | p1_breach | reopen_ge_2 */
  triggerType: string;
  action: string;
  /** Comma-separated role list; NULL for actions targeting the task's assignee directly */
  notifyRole?: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEscalationRuleBody {
  spaceId?: number | null;
  /** @minLength 1 */
  triggerType: string;
  /** @minLength 1 */
  action: string;
  notifyRole?: string | null;
}

export interface UpdateEscalationRuleBody {
  /** @minLength 1 */
  triggerType?: string;
  /** @minLength 1 */
  action?: string;
  notifyRole?: string | null;
  active?: boolean;
}

export interface BusinessHours {
  spaceId: number;
  /** HH:MM, 24h */
  businessHoursStart: string | null;
  /** HH:MM, 24h */
  businessHoursEnd: string | null;
  /**
   * Phase 42 (TBLD-05, migration 0116) — the ONE space-wide validator window; null ⇒ code default 240 (4h). Explicitly NOT per-item and NOT per-template.
   * @minimum 1
   */
  taskValidationWindowMinutes?: number | null;
}

export interface UpdateBusinessHoursBody {
  /** Admin-only override; non-admins are always forced to their own space */
  spaceId?: number | null;
  businessHoursStart?: string | null;
  businessHoursEnd?: string | null;
  /**
   * Phase 42 (TBLD-05) — the ONE space-wide validator window; null ⇒ code default 240 (4h).
   * @minimum 1
   */
  taskValidationWindowMinutes?: number | null;
}

export interface CopyTaskConfigBody {
  fromSpaceId: number;
  toSpaceId: number;
}

export interface CopyTaskConfigResponse {
  success: boolean;
  categoriesCopied: number;
  slaPoliciesCopied: number;
  routingRulesCopied: number;
  escalationRulesCopied: number;
}

export type TaskTemplateFreq =
  (typeof TaskTemplateFreq)[keyof typeof TaskTemplateFreq];

export const TaskTemplateFreq = {
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
} as const;

export type TaskTemplateKind =
  (typeof TaskTemplateKind)[keyof typeof TaskTemplateKind];

export const TaskTemplateKind = {
  checklist: "checklist",
  form: "form",
  plain: "plain",
} as const;

export type TaskTemplateTrigger =
  (typeof TaskTemplateTrigger)[keyof typeof TaskTemplateTrigger];

export const TaskTemplateTrigger = {
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
  onboarding: "onboarding",
  exit: "exit",
} as const;

export interface TaskTemplate {
  id: number;
  spaceId: number;
  name: string;
  kind: TaskTemplateKind;
  categoryId?: number | null;
  priority: TaskPriority;
  trigger?: TaskTemplateTrigger;
  /** day_pass | workstation | private_cabin | team_cabin | visitor | conference_new | conference_existing | meeting (onboarding); workstation | private_cabin (exit). Phase 42 (TBLD-04) adds week_pass, client_onboarding (onboarding-trigger) and client_exit (exit-trigger) — all three manual-start-only (Start procedure) since their backing booking flows don't exist yet, exactly like team_cabin/visitor above. No server enum CHECK — Zod-validated only; taxonomy still settling (49-CONTEXT Open Q2/Q3). */
  eventBookingType?: string | null;
  freq: TaskTemplateFreq;
  interval: number;
  /** 'MO'..'SU' */
  byweekday?: string | null;
  /** 1 = '1st'; only meaningful with byweekday + freq=monthly */
  nth?: number | null;
  /** e.g. 1 for '1st of month' (no byweekday) */
  byMonthDay?: number | null;
  /** 'HH:MM' IST reset time — outside the RRULE */
  atTime: string;
  /** dtstart for the RRULE — set once, at template creation (IST) */
  anchorDate: string;
  /** TREC-08 — suppresses spawning on named dates */
  pauseDates: string[];
  /** TREC-10 — false stops future spawns only; live instances stay untouched */
  active: boolean;
  /** TREC-07 — bumped on every template/item edit; stamped onto task.templateVersion at spawn */
  version: number;
  createdAt: string;
  updatedAt: string;
}

export interface TaskTemplateItem {
  id: number;
  templateId: number;
  seq: number;
  label: string;
  required: boolean;
  assignedRole: UserRole;
  /** Phase 49 (TASN-01/02) — nullable person-pin override alongside assignedRole; when set, canActOnItem prefers this over the role fallback. */
  assignedUserId?: number | null;
  zoneResourceId?: number | null;
  zoneLabel: string;
  /** Group-checklist UI (migration 0120) — free-text collapsible-section label rendered as '{zoneLabel} — {groupLabel}' (e.g. 'Reception — Dusting'). Null keeps the item in the ungrouped-by-zone bucket; never dropped. */
  groupLabel?: string | null;
  /** Explicit HH:MM per occurrence; N entries ⇒ N independently tickable task_checklist_item rows spawned. The sole source of truth for 'times performed' — see timesPerformed below. */
  atTimes?: string[] | null;
  /**
   * The SLA window; the doer's clock starts at the occurrence's atTime
   * @minimum 0
   */
  completeWithinMinutes?: number | null;
  /** Proof required to close the item */
  proofType?: ChecklistProofType | null;
  /** Explicit validator role; blank on BOTH this and validatorUserId falls back to the doer's manager_id (Phase 44's auto rule). doer ≠ validator stays enforced. */
  validatorRole?: string | null;
  /** Explicit validator person; see validatorRole for the fallback rule */
  validatorUserId?: number | null;
  /** DERIVED = atTimes.length. Never accepted on write — the times array is the source of truth. Response-only, never on a request body. */
  readonly timesPerformed?: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * A checklist template + its items, ordered by seq
 */
export type TaskTemplateDetail = TaskTemplate & {
  items: TaskTemplateItem[];
  /** Hotfix — count of task rows ever spawned from this template (past +
present). Populated on GET /task-templates (the list read) ONLY, so
the Settings templates table can show honest "N past rounds will be
kept" counts before a permanent delete; other TaskTemplateDetail
responses (create/get-one/patch) omit this field — treat it as
absent/unknown outside the list read, not as a guaranteed 0.
 */
  readonly spawnedRoundCount?: number;
};

/**
 * Hotfix — the outcome of DELETE /task-templates/{id}/permanent. Both
counts are captured immediately before the delete, inside the same
transaction, so the caller can render an honest confirmation of what
was actually affected.

 */
export interface DeleteTaskTemplatePermanentResult {
  /** Count of task_template_item rows removed (CASCADE, SQL migration 0118). */
  deletedItems: number;
  /** Count of historical task rows that had template_id set to NULL (ON DELETE SET NULL) — these rows, and their task_checklist_item/task_activity children, were KEPT, never deleted. */
  unlinkedRounds: number;
}

export type SyncTodayResultAction =
  (typeof SyncTodayResultAction)[keyof typeof SyncTodayResultAction];

export const SyncTodayResultAction = {
  spawned: "spawned",
  regenerated: "regenerated",
} as const;

/**
 * Hotfix (2026-07-18) — the outcome of POST /task-templates/{id}/sync-today.
`action` distinguishes "there was no round yet, so one was spawned" from
"a round already existed with zero progress, so its items were regenerated
from the current template items" — the task row itself (same id either way
for `regenerated`) is always returned so the caller can refresh in place.

 */
export interface SyncTodayResult {
  action: SyncTodayResultAction;
  task: Task;
}

/**
 * Hotfix follow-up (2026-07-18, "force resync") — optional. `force:true`
makes POST /task-templates/{id}/sync-today regenerate today's round
from the CURRENT template items even when it already has real
doer/validator progress, DISCARDING that progress, instead of the
default 409 `round_has_progress`. Ignored (no effect either way) when
there is no round yet for today (always spawns) or the existing round
already has zero progress (always regenerates regardless of `force`).

 */
export interface SyncTodayBody {
  force?: boolean;
}

export interface CreateTaskTemplateBody {
  /** Admin-only override; non-admins are always forced to their own space */
  spaceId?: number | null;
  /** @minLength 1 */
  name: string;
  kind?: TaskTemplateKind;
  categoryId?: number | null;
  priority?: TaskPriority;
  trigger?: TaskTemplateTrigger;
  /** Set only for onboarding/exit-trigger templates; no server enum CHECK — Zod-validated only. Phase 42 (TBLD-04) adds week_pass, client_onboarding, client_exit — all three manual-start-only (Start procedure) since their backing booking flows don't exist yet. */
  eventBookingType?: string | null;
  freq: TaskTemplateFreq;
  /** @minimum 1 */
  interval?: number;
  byweekday?: string | null;
  nth?: number | null;
  byMonthDay?: number | null;
  /**
   * 'HH:MM' IST
   * @minLength 1
   */
  atTime: string;
  pauseDates?: string[];
}

export interface UpdateTaskTemplateBody {
  /** @minLength 1 */
  name?: string;
  kind?: TaskTemplateKind;
  categoryId?: number | null;
  priority?: TaskPriority;
  trigger?: TaskTemplateTrigger;
  /** Set only for onboarding/exit-trigger templates; no server enum CHECK — Zod-validated only. Phase 42 (TBLD-04) adds week_pass, client_onboarding, client_exit — all three manual-start-only (Start procedure) since their backing booking flows don't exist yet. */
  eventBookingType?: string | null;
  freq?: TaskTemplateFreq;
  /** @minimum 1 */
  interval?: number;
  byweekday?: string | null;
  nth?: number | null;
  byMonthDay?: number | null;
  /** @minLength 1 */
  atTime?: string;
  pauseDates?: string[];
  /** TREC-10 — the deactivation toggle */
  active?: boolean;
}

export interface CreateTaskTemplateItemBody {
  /** Defaults to end-of-list (max seq + 1) within the template when omitted */
  seq?: number | null;
  /** @minLength 1 */
  label: string;
  required?: boolean | null;
  assignedRole: UserRole;
  /** Phase 49 (TASN-01/02) — nullable person-pin override; assignedRole stays required as the fallback. */
  assignedUserId?: number | null;
  zoneResourceId?: number | null;
  /** @minLength 1 */
  zoneLabel: string;
  /** Group-checklist UI (migration 0120) — see TaskTemplateItem.groupLabel */
  groupLabel?: string | null;
  /** Explicit HH:MM per occurrence; N entries ⇒ N independently tickable rows spawned. */
  atTimes?: string[] | null;
  /** @minimum 0 */
  completeWithinMinutes?: number | null;
  proofType?: ChecklistProofType | null;
  /** Blank on BOTH this and validatorUserId falls back to the doer's manager_id */
  validatorRole?: string | null;
  validatorUserId?: number | null;
}

export interface UpdateTaskTemplateItemBody {
  /** @minLength 1 */
  label?: string;
  required?: boolean;
  assignedRole?: UserRole;
  /** Phase 49 (TASN-01/02) — nullable person-pin override; assignedRole stays required as the fallback. */
  assignedUserId?: number | null;
  zoneResourceId?: number | null;
  /** @minLength 1 */
  zoneLabel?: string;
  /** Group-checklist UI (migration 0120) — see TaskTemplateItem.groupLabel */
  groupLabel?: string | null;
  atTimes?: string[] | null;
  /** @minimum 0 */
  completeWithinMinutes?: number | null;
  proofType?: ChecklistProofType | null;
  validatorRole?: string | null;
  validatorUserId?: number | null;
}

export type ReorderTaskTemplateItemBodyDirection =
  (typeof ReorderTaskTemplateItemBodyDirection)[keyof typeof ReorderTaskTemplateItemBodyDirection];

export const ReorderTaskTemplateItemBodyDirection = {
  up: "up",
  down: "down",
} as const;

export interface ReorderTaskTemplateItemBody {
  direction: ReorderTaskTemplateItemBodyDirection;
}

/**
 * Phase 44 — TCHK-03: marking an item N/A requires a note (min length mirrors CancelTaskBody.cancelNote's convention)
 */
export interface MarkChecklistItemNaBody {
  /** @minLength 10 */
  naReason: string;
}

/**
 * Phase 42 (TPRF-01/02/03) — optional proof payload for the tick. All fields optional at the spec level; cross-field requiredness (proofType photo/note/signature ⇒ the matching field is mandatory, 422 proof_required otherwise) is enforced in the route's Zod superRefine, not here.
 */
export interface MarkChecklistItemDoneBody {
  /**
   * TPRF-02 — up to 5 photo URLs (from POST /uploads/checklist-proof)
   * @maxItems 5
   */
  proofUrls?: string[] | null;
  proofNote?: string | null;
  /** TPRF-03 — from POST /uploads/checklist-proof */
  signatureUrl?: string | null;
  /** TPRF-03 — the CLIENT's name, not the staff member's */
  signerName?: string | null;
}

/**
 * Phase 42 (TPRF-04) — mandatory reject reason, mirrors MarkChecklistItemNaBody's mandatory naReason
 */
export interface RejectTaskChecklistItemBody {
  /** @minLength 1 */
  rejectReason: string;
}

/**
 * Multipart form-data fields for checklist proof upload (Phase 42, TPRF-01/02)
 */
export interface UploadChecklistProofBody {
  /** Binary file content (multipart/form-data upload) */
  file: string;
}

export interface ChecklistProofUploadResult {
  url: string;
  path: string;
}

/**
 * A copied task_checklist_item row (never the live task_template_item — TREC-07)
 */
export interface DailyChecklistItem {
  id: number;
  label: string;
  zoneLabel: string;
  zoneResourceId?: number | null;
  /** Group-checklist UI (migration 0120) — resolved space_resources.label for zoneResourceId (e.g. 'Suite 03'), so the client never needs a second fetch. Null when zoneResourceId is null or the linked resource no longer exists. */
  zoneResourceLabel?: string | null;
  /** Group-checklist UI (migration 0120) — copied at spawn from task_template_item.groupLabel (TREC-07 discipline); null on any round spawned before this migration, or on a non-grouped item — the client buckets these by zoneLabel alone, never dropping them. */
  groupLabel?: string | null;
  assignedRole: UserRole;
  /** Phase 49 (TASN-01/02) — nullable person-pin override so the render path can resolve a person avatar instead of the role fallback. */
  assignedUserId?: number | null;
  doneByUserId?: number | null;
  doneAt?: string | null;
  /** Phase 44 — TCHK-03 */
  naReason?: string | null;
  required: boolean;
  /** Phase 44 — TCHK-06/07 */
  validatedByUserId?: number | null;
  /** Phase 44 — TCHK-06/07 */
  validatedAt?: string | null;
  /** 0-based index within this item's atTimes[] fan-out; 0 for a non-fanned-out item */
  occurrenceSeq: number;
  /** 'HH:MM' this occurrence was spawned for */
  occurrenceAtTime?: string | null;
  doerDueAt?: string | null;
  doerNudgedAt?: string | null;
  /** Sweep idempotency stamp ONLY — never read this to render breach state; use doerBreached below */
  doerBreachedAt?: string | null;
  validationDueAt?: string | null;
  validationNudgedAt?: string | null;
  /** Sweep idempotency stamp ONLY — never read this to render breach state; use validationBreached below */
  validationBreachedAt?: string | null;
  proofType?: ChecklistProofType | null;
  completeWithinMinutes?: number | null;
  validatorRole?: string | null;
  validatorUserId?: number | null;
  /** @maxItems 5 */
  proofUrls?: string[] | null;
  proofNote?: string | null;
  signatureUrl?: string | null;
  /** TPRF-03 — the CLIENT's name, not the staff member's */
  signerName?: string | null;
  signedAt?: string | null;
  rejectReason?: string | null;
  rejectedByUserId?: number | null;
  rejectedAt?: string | null;
  /** Computed on read — drive overdue/missed badges off THIS, never doerBreachedAt (TSLA-12) */
  readonly doerBreached?: boolean;
  /** Computed on read — drive the validation-overdue badge off THIS, never validationBreachedAt */
  readonly validationBreached?: boolean;
  /** Phase 44 — server-computed per-item hint (GET /users is admin-only, so front_desk/HK can't compute validator eligibility client-side); always present on every item, evaluated against req.user via canValidateItem */
  canIValidate?: boolean;
}

/**
 * One template's today-spawned round + its copied items, grouped (43-RESEARCH Pattern 11)
 */
export interface DailyChecklistEntry {
  templateId: number;
  templateName: string;
  /** 'HH:MM' IST reset time */
  atTime: string;
  taskId: number;
  serviceDate: string;
  status: TaskStatus;
  items: DailyChecklistItem[];
}

/**
 * One spawned event task under its owning template (49-RESEARCH Pattern 11 variant — an event template can have N of these open concurrently, unlike DailyChecklistEntry's 1:1 shape)
 */
export interface EventChecklistInstance {
  taskId: number;
  /** The account this procedure concerns (e.g. the member checking in); null for a manually-started procedure with no account context */
  accountId: number | null;
  accountName: string | null;
  /** 'resource_assignment' | 'member_charge' | 'membership' — mirrors task.eventSourceType; null for a context-free manual start */
  eventSourceType: string | null;
  eventSourceId: number | null;
  items: DailyChecklistItem[];
}

/**
 * One onboarding/exit template + all its currently open spawned instances, grouped (49-RESEARCH Pattern 11 variant)
 */
export interface EventChecklistEntry {
  templateId: number;
  templateName: string;
  /** Phase 42 (TBLD-04) adds week_pass, client_onboarding, client_exit alongside the existing day_pass/workstation/private_cabin/team_cabin/visitor/conference_*\/meeting values — week_pass/client_onboarding/client_exit are manual-start-only (Start procedure). */
  eventBookingType: string | null;
  instances: EventChecklistInstance[];
}

/**
 * TEVT-06 — manual Start-procedure for Team-Cabin/Visitor (no backing booking schema this phase, so they never auto-trigger via the seat-assign/scheduler hooks); reuses the same idempotent spawnInstanceTx as the auto-trigger paths.
 */
export interface StartProcedureBody {
  /** Must be a trigger=onboarding|exit template */
  templateId: number;
  accountId?: number | null;
  /** Omit for a context-free manual start (e.g. Visitor with no booking row) */
  eventSourceType?: string | null;
  eventSourceId?: number | null;
}

/**
 * A6 — non-null on an account means it is selectable as a payment funding source.
 */
export type PaymentSourceKind =
  (typeof PaymentSourceKind)[keyof typeof PaymentSourceKind];

export const PaymentSourceKind = {
  bank: "bank",
  cash: "cash",
  petty_cash: "petty_cash",
  partner: "partner",
} as const;

export type TaxTreatment = (typeof TaxTreatment)[keyof typeof TaxTreatment];

export const TaxTreatment = {
  registered: "registered",
  unregistered: "unregistered",
  rcm: "rcm",
  itc_blocked: "itc_blocked",
} as const;

export type VendorBillStatus =
  (typeof VendorBillStatus)[keyof typeof VendorBillStatus];

export const VendorBillStatus = {
  draft: "draft",
  pending_approval: "pending_approval",
  approved: "approved",
  partially_paid: "partially_paid",
  paid: "paid",
  rejected: "rejected",
  void: "void",
} as const;

export type VendorBillScheduleFrequency =
  (typeof VendorBillScheduleFrequency)[keyof typeof VendorBillScheduleFrequency];

export const VendorBillScheduleFrequency = {
  Monthly: "Monthly",
  Weekly: "Weekly",
  Quarterly: "Quarterly",
  Yearly: "Yearly",
} as const;

export type VendorBillScheduleCostType =
  (typeof VendorBillScheduleCostType)[keyof typeof VendorBillScheduleCostType];

export const VendorBillScheduleCostType = {
  Fixed: "Fixed",
  Variable: "Variable",
} as const;

export type PnlGroupBy = (typeof PnlGroupBy)[keyof typeof PnlGroupBy];

export const PnlGroupBy = {
  cost_centre: "cost_centre",
  location: "location",
  account: "account",
} as const;

export interface VendorBillLine {
  id: number;
  billId: number;
  seq: number;
  description: string;
  /** 5-digit ledger account code, e.g. 50100 */
  expenseAccountCode: string;
  expenseAccountName: string;
  costCentreId: number;
  costCentreName: string;
  taxableAmount: number;
  gstRate: number;
  gstAmount: number;
}

export interface VendorBill {
  id: number;
  spaceId: number;
  /** The VENDOR's own invoice number, operator-entered — never generated. */
  billNumber: string;
  vendorId: number;
  vendorName: string;
  /** NULL for a one-off bill; set for a schedule-generated bill. */
  scheduleId: number | null;
  periodLabel: string | null;
  billDate: string;
  dueDate: string | null;
  taxTreatment: TaxTreatment;
  /** A3 — operator-settable, best-effort default computed server-side; never silently trusted. */
  isInterState: boolean;
  isPrepaid: boolean;
  prepaidMonths: number | null;
  prepaidStartMonth: string | null;
  taxableTotal: number;
  gstTotal: number;
  grossTotal: number;
  status: VendorBillStatus;
  /** NULL = not yet posted. A2: settled pre-cutover bills stay NULL forever. */
  journalEntryId: number | null;
  isPreCutover: boolean;
  /** A2 — true for a migrated OPEN bill not yet pushed through postEvent(). */
  awaitingPosting: boolean;
  invoiceUrl: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface BillPayment {
  id: number;
  spaceId: number;
  billId: number;
  paidAt: string;
  paymentDate: string;
  /** The AP debit. */
  grossAmount: number;
  /** Credited to TDS Payable. */
  tdsAmount: number;
  /** gross_amount - tds_amount, derived by subtraction. Credited to the CHOSEN funding account, which may be a cash tin or a partner's pocket, not literally a bank. */
  bankAmount: number;
  tdsRate: number | null;
  /** Free text — no TDS section-number enum. */
  tdsCategory: string | null;
  /** A6 — the operator's chosen funding source. No default, no fallback. */
  paymentAccountId: number;
  paymentAccountName: string;
  paidBy: string | null;
  paymentMethod: string | null;
  paymentAccountDetail: string | null;
  paymentReference: string | null;
  paymentProofUrl: string | null;
  journalEntryId: number | null;
  isPreCutover: boolean;
  createdBy: number | null;
  createdAt: string;
}

export interface LedgerLine {
  id: number;
  journalEntryId: number;
  accountCode: string;
  accountName: string;
  debit: number;
  credit: number;
  locationId: number;
  costCentreId: number;
  costCentreName: string;
  gstinId: number;
  /** vendor | member | NULL */
  partyType: string | null;
  partyId: number | null;
  lineNarration: string | null;
}

export interface LedgerEntry {
  id: number;
  /** JE-######## sequence */
  entryNo: string;
  entryDate: string;
  /** 'YYYY-MM' */
  period: string;
  sourceModule: string;
  sourceEventType: string;
  sourceEventId: number | null;
  postingRuleId: number | null;
  narration: string | null;
  locationId: number;
  createdBy: number | null;
  createdAt: string;
  /** FR-03 — self-FK to the entry this one reverses. */
  reversesEntryId: number | null;
  isManual: boolean;
  approvedBy: number | null;
  approvalReason: string | null;
  lines: LedgerLine[];
}

export type VendorBillDetail = VendorBill & {
  lines: VendorBillLine[];
  payments: BillPayment[];
  journalEntry: LedgerEntry | null;
};

export interface VendorBillListResponse {
  items: VendorBill[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateVendorBillLineBody {
  description: string;
  expenseAccountCode: string;
  costCentreId: number;
  taxableAmount: number;
  gstRate: number;
}

export interface CreateVendorBillBody {
  vendorId: number;
  billNumber: string;
  billDate: string;
  dueDate?: string | null;
  taxTreatment: TaxTreatment;
  /** A3 — optional on the wire; when omitted the route computes a best-effort default and returns it. Never silently authoritative. */
  isInterState?: boolean | null;
  isPrepaid?: boolean | null;
  prepaidMonths?: number | null;
  prepaidStartMonth?: string | null;
  invoiceUrl?: string | null;
  notes?: string | null;
  /** @minItems 1 */
  lines: CreateVendorBillLineBody[];
}

/**
 * Draft-only — every field optional.
 */
export interface UpdateVendorBillBody {
  billNumber?: string;
  billDate?: string;
  dueDate?: string | null;
  taxTreatment?: TaxTreatment;
  isInterState?: boolean;
  isPrepaid?: boolean;
  prepaidMonths?: number | null;
  prepaidStartMonth?: string | null;
  invoiceUrl?: string | null;
  notes?: string | null;
  lines?: CreateVendorBillLineBody[];
}

export interface ApproveVendorBillBody {
  note?: string | null;
}

export interface RejectVendorBillBody {
  reason: string;
}

export interface ReverseVendorBillBody {
  reason: string;
}

export type VendorBillScheduleStatus =
  (typeof VendorBillScheduleStatus)[keyof typeof VendorBillScheduleStatus];

export const VendorBillScheduleStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface VendorBillSchedule {
  id: number;
  spaceId: number;
  name: string;
  vendorId: number | null;
  costType: VendorBillScheduleCostType;
  frequency: VendorBillScheduleFrequency;
  defaultTaxableAmount: number | null;
  gstRate: number | null;
  taxTreatment: TaxTreatment;
  defaultExpenseAccountCode: string | null;
  defaultCostCentreId: number | null;
  isPrepaid: boolean;
  prepaidMonths: number | null;
  dueDayOfMonth: number | null;
  startDate: string;
  status: VendorBillScheduleStatus;
  invoiceUrl: string | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateVendorBillScheduleBody {
  name: string;
  vendorId?: number | null;
  costType: VendorBillScheduleCostType;
  frequency: VendorBillScheduleFrequency;
  defaultTaxableAmount?: number | null;
  gstRate?: number | null;
  taxTreatment: TaxTreatment;
  defaultExpenseAccountCode?: string | null;
  defaultCostCentreId?: number | null;
  isPrepaid?: boolean | null;
  prepaidMonths?: number | null;
  dueDayOfMonth?: number | null;
  startDate: string;
  invoiceUrl?: string | null;
  notes?: string | null;
}

export type UpdateVendorBillScheduleBodyStatus =
  (typeof UpdateVendorBillScheduleBodyStatus)[keyof typeof UpdateVendorBillScheduleBodyStatus];

export const UpdateVendorBillScheduleBodyStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export interface UpdateVendorBillScheduleBody {
  name?: string;
  vendorId?: number | null;
  costType?: VendorBillScheduleCostType;
  frequency?: VendorBillScheduleFrequency;
  defaultTaxableAmount?: number | null;
  gstRate?: number | null;
  taxTreatment?: TaxTreatment;
  defaultExpenseAccountCode?: string | null;
  defaultCostCentreId?: number | null;
  isPrepaid?: boolean;
  prepaidMonths?: number | null;
  dueDayOfMonth?: number | null;
  startDate?: string;
  status?: UpdateVendorBillScheduleBodyStatus;
  invoiceUrl?: string | null;
  notes?: string | null;
}

export interface GenerateVendorBillsResult {
  created: number;
  skipped: number;
}

export interface CreateBillPaymentBody {
  paymentDate: string;
  grossAmount: number;
  tdsAmount?: number | null;
  tdsRate?: number | null;
  tdsCategory?: string | null;
  /** A6 — REQUIRED. An account id, not a code. No default and no fallback to a generic Bank. */
  paymentAccountId: number;
  paidBy?: string | null;
  paymentMethod?: string | null;
  paymentAccountDetail?: string | null;
  paymentReference?: string | null;
  paymentProofUrl?: string | null;
}

export interface CreatePartnerReimbursementBody {
  amount: number;
  paymentDate: string;
  paymentAccountId: number;
  narration?: string | null;
}

export interface CreateRcmDischargeBody {
  amount: number;
  paymentDate: string;
  paymentAccountId: number;
  narration?: string | null;
}

export interface CreateTdsDepositBody {
  amount: number;
  paymentDate: string;
  paymentAccountId: number;
  narration?: string | null;
}

export interface IssuePettyCashBody {
  amount: number;
  paymentDate: string;
  paymentAccountId: number;
  narration?: string | null;
}

export interface PettyCashSpendLine {
  expenseAccountCode: string;
  costCentreId: number;
  amount: number;
  description: string;
}

export interface SpendPettyCashBody {
  paymentDate: string;
  /** @minItems 1 */
  lines: PettyCashSpendLine[];
}

export type TrialBalanceRowType =
  (typeof TrialBalanceRowType)[keyof typeof TrialBalanceRowType];

export const TrialBalanceRowType = {
  asset: "asset",
  liability: "liability",
  equity: "equity",
  income: "income",
  expense: "expense",
} as const;

export interface TrialBalanceRow {
  accountCode: string;
  accountName: string;
  type: TrialBalanceRowType;
  debit: number;
  credit: number;
  balance: number;
}

export interface TrialBalanceResponse {
  rows: TrialBalanceRow[];
  totalDebit: number;
  totalCredit: number;
}

export interface ApVendorRow {
  vendorId: number;
  vendorName: string;
  billed: number;
  paid: number;
  outstanding: number;
}

export interface PnlRow {
  /** Cost-centre id, location id, or account code as a string, depending on groupBy. */
  groupKey: string;
  groupLabel: string;
  income: number;
  expense: number;
  net: number;
}

export interface PnlResponse {
  rows: PnlRow[];
  totalIncome: number;
  totalExpense: number;
  net: number;
}

export type CreateManualJournalLineBodyPartyType =
  | (typeof CreateManualJournalLineBodyPartyType)[keyof typeof CreateManualJournalLineBodyPartyType]
  | null;

export const CreateManualJournalLineBodyPartyType = {
  vendor: "vendor",
  member: "member",
} as const;

export interface CreateManualJournalLineBody {
  accountCode: string;
  debit: number;
  credit: number;
  costCentreId: number;
  partyType?: CreateManualJournalLineBodyPartyType;
  partyId?: number | null;
  lineNarration?: string | null;
}

/**
 * FR-04 — reason is REQUIRED.
 */
export interface CreateManualJournalBody {
  entryDate: string;
  reason: string;
  narration: string;
  /** @minItems 2 */
  lines: CreateManualJournalLineBody[];
}

export type PostingExceptionPayload = { [key: string]: unknown };

export interface PostingException {
  id: number;
  spaceId: number;
  eventType: string;
  sourceModule: string;
  sourceEventId: number | null;
  payload: PostingExceptionPayload;
  reason: string;
  createdAt: string;
  resolvedAt: string | null;
  resolvedBy: number | null;
  resolutionNote: string | null;
  resolvedJournalEntryId: number | null;
}

export interface ResolvePostingExceptionBody {
  note: string;
}

/**
 * A6 — the funding sources the payment screen lists.
 */
export interface PaymentAccount {
  id: number;
  code: string;
  name: string;
  paymentSourceKind: PaymentSourceKind;
}

export type LedgerAccountType =
  (typeof LedgerAccountType)[keyof typeof LedgerAccountType];

export const LedgerAccountType = {
  asset: "asset",
  liability: "liability",
  equity: "equity",
  income: "income",
  expense: "expense",
} as const;

export type LedgerAccountNormalBalance =
  (typeof LedgerAccountNormalBalance)[keyof typeof LedgerAccountNormalBalance];

export const LedgerAccountNormalBalance = {
  debit: "debit",
  credit: "credit",
} as const;

export type LedgerAccountSubLedger =
  (typeof LedgerAccountSubLedger)[keyof typeof LedgerAccountSubLedger];

export const LedgerAccountSubLedger = {
  ar: "ar",
  ap: "ap",
  inventory: "inventory",
  fixed_asset: "fixed_asset",
  none: "none",
} as const;

export interface LedgerAccount {
  id: number;
  code: string;
  name: string;
  type: LedgerAccountType;
  normalBalance: LedgerAccountNormalBalance;
  parentId: number | null;
  isControlAccount: boolean;
  subLedger: LedgerAccountSubLedger;
  active: boolean;
  paymentSourceKind: PaymentSourceKind | null;
  createdAt: string;
}

export type CreateLedgerAccountBodyType =
  (typeof CreateLedgerAccountBodyType)[keyof typeof CreateLedgerAccountBodyType];

export const CreateLedgerAccountBodyType = {
  asset: "asset",
  liability: "liability",
  equity: "equity",
  income: "income",
  expense: "expense",
} as const;

export type CreateLedgerAccountBodyNormalBalance =
  (typeof CreateLedgerAccountBodyNormalBalance)[keyof typeof CreateLedgerAccountBodyNormalBalance];

export const CreateLedgerAccountBodyNormalBalance = {
  debit: "debit",
  credit: "credit",
} as const;

export type CreateLedgerAccountBodySubLedger =
  | (typeof CreateLedgerAccountBodySubLedger)[keyof typeof CreateLedgerAccountBodySubLedger]
  | null;

export const CreateLedgerAccountBodySubLedger = {
  ar: "ar",
  ap: "ap",
  inventory: "inventory",
  fixed_asset: "fixed_asset",
  none: "none",
} as const;

export interface CreateLedgerAccountBody {
  code: string;
  name: string;
  type: CreateLedgerAccountBodyType;
  normalBalance: CreateLedgerAccountBodyNormalBalance;
  parentId?: number | null;
  subLedger?: CreateLedgerAccountBodySubLedger;
  paymentSourceKind?: PaymentSourceKind | null;
}

/**
 * Accounts are deactivatable, never deletable.
 */
export interface UpdateLedgerAccountBody {
  name?: string;
  active?: boolean;
  paymentSourceKind?: PaymentSourceKind | null;
}

export interface CostCentre {
  id: number;
  spaceId: number;
  code: string;
  name: string;
  /** true ONLY for the seeded UNALLOC centre. */
  isBalanceSheet: boolean;
  active: boolean;
  createdAt: string;
}

export interface CreateCostCentreBody {
  code: string;
  name: string;
}

/**
 * Deactivatable, never deletable.
 */
export interface UpdateCostCentreBody {
  name?: string;
  active?: boolean;
}

export interface LedgerConfig {
  /** D9 — space-level default. Null means no threshold gate is configured yet. */
  billApprovalThreshold: number | null;
}

export interface UpdateLedgerConfigBody {
  billApprovalThreshold: number | null;
}

/**
 * A2 — a migrated OPEN bill awaiting posting through postEvent().
 */
export interface BackfillQueueRow {
  id: number;
  billNumber: string;
  vendorId: number;
  vendorName: string;
  billDate: string;
  grossTotal: number;
  /** true when the expense account is still the 51100 placeholder and the schedule has no mapping. */
  needsMapping: boolean;
  lines: VendorBillLine[];
}

export interface UpdateBackfillMappingLine {
  id: number;
  expenseAccountId: number;
  costCentreId: number;
}

export interface UpdateBackfillMappingBody {
  /** @minItems 1 */
  lines: UpdateBackfillMappingLine[];
}

export interface BackfillRunResult {
  posted: number;
  skipped: number;
  needsMapping: number;
  quarantined: number;
}

export interface PrepaidSchedulePeriod {
  id: number;
  scheduleId: number;
  seq: number;
  periodMonth: string;
  amount: number;
  recognisedAt: string | null;
  journalEntryId: number | null;
}

export type PrepaidScheduleStatus =
  (typeof PrepaidScheduleStatus)[keyof typeof PrepaidScheduleStatus];

export const PrepaidScheduleStatus = {
  active: "active",
  completed: "completed",
  cancelled: "cancelled",
} as const;

/**
 * FR-14 — the canonical case is a ₹9,000 quarterly ISP bill split into ₹3,000/month for three months.
 */
export interface PrepaidSchedule {
  id: number;
  spaceId: number;
  billId: number;
  expenseAccountCode: string;
  costCentreId: number;
  totalAmount: number;
  months: number;
  startMonth: string;
  status: PrepaidScheduleStatus;
  periods: PrepaidSchedulePeriod[];
}

export interface RecognisePrepaidBody {
  upTo?: string | null;
}

export interface PrepaidRecogniseResult {
  recognised: number;
  skipped: number;
}

/**
 * Derived, unstored annotation — whether openQty came from the nearest prior closed day's count for this exact pair, or (day one) from the live inventory_item_location_balances reading.
 */
export type StockDayPositionLineOpenBasis =
  (typeof StockDayPositionLineOpenBasis)[keyof typeof StockDayPositionLineOpenBasis];

export const StockDayPositionLineOpenBasis = {
  prior_close: "prior_close",
  balance_fallback: "balance_fallback",
} as const;

/**
 * One (item, location) count line. openQty is always derived (prior close, or the live balance on day one) — never typed. countedCloseQty is the ONLY figure a human ever enters; null until counted.
 */
export interface StockDayPositionLine {
  id: number;
  itemId: number;
  itemName: string;
  locationId: number;
  locationName: string;
  openQty: number;
  stockInQty: number;
  /** Every physical stock_out type (sales, Wastage, Staff_Use, Damaged, Expired, Transfer_Out) plus stock_out_components decrements. Drives expectedCloseQty. */
  recordedMovementQty: number;
  /** Only BILLABLE_CHARGING_DECISIONS types. The sheet's 'Consumption (Qty)' column. Drives Txn Amount / Profit. */
  billableConsumptionQty: number;
  expectedCloseQty: number;
  countedCloseQty?: number | null;
  /** counted - expected. Computed, never operator-entered — this is Overflow/Underflow. */
  varianceQty?: number | null;
  varianceFlagged: boolean;
  txnAmount: number;
  unitCostSnapshot?: number | null;
  profit: number;
  countedAt?: string | null;
  /** Derived, unstored annotation — whether openQty came from the nearest prior closed day's count for this exact pair, or (day one) from the live inventory_item_location_balances reading. */
  openBasis?: StockDayPositionLineOpenBasis;
}

/**
 * Item-level sheet-parity rollup, computed fresh from the (item, location) lines on every request — never stored, so it can't drift. Also used for the pinned TOTAL (ALL ITEMS) row (itemId=0, itemName='TOTAL').
 */
export interface StockDayItemRollup {
  itemId: number;
  itemName: string;
  openQty: number;
  stockInQty: number;
  recordedMovementQty: number;
  billableConsumptionQty: number;
  expectedCloseQty: number;
  /** null when at least one of this item's location lines has not been counted yet — a partial sum would be misleading. */
  countedCloseQty?: number | null;
  varianceQty?: number | null;
  varianceFlagged: boolean;
  txnAmount: number;
  profit: number;
}

export type StockDayCloseSheetStatus =
  (typeof StockDayCloseSheetStatus)[keyof typeof StockDayCloseSheetStatus];

export const StockDayCloseSheetStatus = {
  open: "open",
  closed: "closed",
} as const;

export interface StockDayCloseSheet {
  businessDate: string;
  status: StockDayCloseSheetStatus;
  /** Whether this business day runs the periodic full count (reserve locations like Store Room join the sale-facing daily set). */
  isFullCount: boolean;
  closedAt?: string | null;
  closedBy?: number | null;
  reopenedAt?: string | null;
  reopenedBy?: number | null;
  reopenReason?: string | null;
  lines: StockDayPositionLine[];
  rollup: StockDayItemRollup[];
  total: StockDayItemRollup;
}

export interface StockDayCloseOverdueEntry {
  businessDate: string;
  /** true when an actual open day-position row exists for this date; false for a gap-filled calendar date with no row at all. */
  hasRow: boolean;
}

export interface StockDayCloseOverdueResponse {
  today: string;
  overdue: StockDayCloseOverdueEntry[];
}

export interface SaveStockDayCountsLine {
  itemId: number;
  locationId: number;
  countedCloseQty: number;
}

export interface SaveStockDayCountsBody {
  spaceId?: number | null;
  /** @minItems 1 */
  counts: SaveStockDayCountsLine[];
}

export interface CloseStockDayBody {
  spaceId?: number | null;
}

export interface ReopenStockDayBody {
  spaceId?: number | null;
  /**
   * Reopen is reason-gated — 400 without one.
   * @minLength 1
   */
  reason: string;
}

export type StockDayPositionStatus =
  (typeof StockDayPositionStatus)[keyof typeof StockDayPositionStatus];

export const StockDayPositionStatus = {
  open: "open",
  closed: "closed",
} as const;

/**
 * The raw inventory_stock_day_positions header row, returned by POST /reopen. Fetch GET /stock-day-close/:date afterward for the full per-location sheet.
 */
export interface StockDayPosition {
  id: number;
  spaceId: number;
  businessDate: string;
  status: StockDayPositionStatus;
  isFullCount: boolean;
  /** Drizzle numeric — string-encoded. Snapshotted at close time. */
  varianceFlagQtySnapshot?: string | null;
  varianceFlagValueSnapshot?: string | null;
  closedAt?: string | null;
  closedBy?: number | null;
  reopenedAt?: string | null;
  reopenedBy?: number | null;
  reopenReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

export type StockLocationKind =
  (typeof StockLocationKind)[keyof typeof StockLocationKind];

export const StockLocationKind = {
  sale_facing: "sale_facing",
  reserve: "reserve",
  unassigned: "unassigned",
} as const;

/**
 * 'daily' locations (Fridge, Pantry) are counted every day; 'full_count' locations (Store Room etc.) only on the periodic full-count cycle.
 */
export type StockLocationCountCadence =
  (typeof StockLocationCountCadence)[keyof typeof StockLocationCountCadence];

export const StockLocationCountCadence = {
  daily: "daily",
  full_count: "full_count",
} as const;

export interface StockLocation {
  id: number;
  spaceId: number;
  name: string;
  kind: StockLocationKind;
  /** 'daily' locations (Fridge, Pantry) are counted every day; 'full_count' locations (Store Room etc.) only on the periodic full-count cycle. */
  countCadence: StockLocationCountCadence;
  /** At most one true per space — the first-class, drainable landing bucket for stock not yet placed. */
  isUnassignedBucket: boolean;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export type CreateStockLocationBodyKind =
  (typeof CreateStockLocationBodyKind)[keyof typeof CreateStockLocationBodyKind];

export const CreateStockLocationBodyKind = {
  sale_facing: "sale_facing",
  reserve: "reserve",
  unassigned: "unassigned",
} as const;

export type CreateStockLocationBodyCountCadence =
  (typeof CreateStockLocationBodyCountCadence)[keyof typeof CreateStockLocationBodyCountCadence];

export const CreateStockLocationBodyCountCadence = {
  daily: "daily",
  full_count: "full_count",
} as const;

export interface CreateStockLocationBody {
  spaceId?: number | null;
  /** @minLength 1 */
  name: string;
  kind?: CreateStockLocationBodyKind;
  countCadence?: CreateStockLocationBodyCountCadence;
  isUnassignedBucket?: boolean;
  isActive?: boolean;
  sortOrder?: number;
}

export type UpdateStockLocationBodyKind =
  (typeof UpdateStockLocationBodyKind)[keyof typeof UpdateStockLocationBodyKind];

export const UpdateStockLocationBodyKind = {
  sale_facing: "sale_facing",
  reserve: "reserve",
  unassigned: "unassigned",
} as const;

export type UpdateStockLocationBodyCountCadence =
  (typeof UpdateStockLocationBodyCountCadence)[keyof typeof UpdateStockLocationBodyCountCadence];

export const UpdateStockLocationBodyCountCadence = {
  daily: "daily",
  full_count: "full_count",
} as const;

export interface UpdateStockLocationBody {
  /** @minLength 1 */
  name?: string;
  kind?: UpdateStockLocationBodyKind;
  countCadence?: UpdateStockLocationBodyCountCadence;
  isActive?: boolean;
  sortOrder?: number;
}

export interface StockLocationBalanceLine {
  locationId: number;
  locationName: string;
  quantityOnHand: number;
}

export interface StockLocationBalances {
  itemId: number;
  locations: StockLocationBalanceLine[];
  /** Equals inventory_items.currentStock — the sum invariant, surfaced. */
  total: number;
}

export interface StockLocationUnplacedItem {
  itemId: number;
  itemName: string;
  quantity: number;
  /** Moving Average Cost. 0 when the item has no receipt history yet. */
  averageCost: number;
  value: number;
}

export interface StockLocationsUnplaced {
  items: StockLocationUnplacedItem[];
  totalQuantity: number;
  totalValue: number;
}

export interface CreateStockLocationTransferBody {
  spaceId?: number | null;
  itemId: number;
  fromLocationId: number;
  toLocationId: number;
  /** @exclusiveMinimum 0 */
  quantity: number;
  note?: string | null;
}

export interface StockLocationTransferCreateResponse {
  id: number;
}

export interface StockLocationTransfer {
  id: number;
  spaceId: number;
  itemId: number;
  fromLocationId: number;
  toLocationId: number;
  quantity: number;
  transferredAt: string;
  actorUserId?: number | null;
  note?: string | null;
  createdAt: string;
}

export interface StockLocationTransferListResponse {
  items: StockLocationTransfer[];
  total: number;
  page: number;
  pageSize: number;
}

/**
 * Bad request
 */
export type BadRequestResponse = ErrorResponse;

/**
 * Unauthorized
 */
export type UnauthorizedResponse = ErrorResponse;

/**
 * Not found
 */
export type NotFoundResponse = ErrorResponse;

/**
 * Forbidden — task-permissions predicate rejected the action
 */
export type ForbiddenResponse = ErrorResponse;

export type ListAuthEventsParams = {
  /**
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * @minimum 1
   * @maximum 720
   */
  sinceHours?: number;
};

export type ListLeadsParams = {
  stage?: LeadStage;
  source?: LeadSource;
  callStatus?: CallStatus;
  spaceType?: SpaceType;
  urgency?: Urgency;
  spaceId?: number;
  leadStatus?: string;
  search?: string;
  from?: string;
  to?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type GetLeadsSummaryParams = {
  from?: string;
  to?: string;
  stage?: LeadStage;
  source?: LeadSource;
  callStatus?: CallStatus;
  spaceType?: SpaceType;
  urgency?: Urgency;
  spaceId?: number;
  leadStatus?: string;
  search?: string;
};

export type GetMyTodayParams = {
  /**
   * Range start (ISO 8601). Defaults to today 00:00 in server local time.
   */
  from?: string;
  /**
   * Range end (ISO 8601). Defaults to today 23:59:59.999 in server local time.
   */
  to?: string;
};

export type GetInventorySpendKpiParams = {
  /**
   * this-month | quarter | ytd | custom (default: this-month)
   */
  period?: string;
  /**
   * Custom-period start date (YYYY-MM-DD, required when period=custom)
   */
  from?: string;
  /**
   * Custom-period end date (YYYY-MM-DD, required when period=custom)
   */
  to?: string;
};

export type ListInventoryCategoriesParams = {
  spaceId?: number;
};

export type ListInventoryVendorsParams = {
  spaceId?: number;
  status?: VendorStatus;
  vendorType?: VendorType;
  search?: string;
};

export type ListInventoryItemsParams = {
  spaceId?: number;
  categoryId?: number;
  chargingModel?: ChargingModel;
  status?: ItemStatus;
  search?: string;
  /**
   * YYYY-MM-DD — restrict to items with at least one stock-in receipt whose transaction_date is on or after this date. Used by Internal Refill picker.
   */
  stockedInSince?: string;
  /**
   * true — omit recipe items from the result. Used by Stock-In line-item pickers and the Internal Refill picker (RECIPE-DISPLAY-02/03); recipe items are cooked to order, not stocked.
   */
  excludeRecipe?: boolean;
};

export type CreateInventoryItem201 = InventoryItem & {
  /** Soft-validation warning (e.g. sellingPrice > mrp). Item was created; no action required. */
  warning?: string | null;
};

export type ListAttributeKeysParams = {
  spaceId?: number;
  status?: ListAttributeKeysStatus;
};

export type ListAttributeKeysStatus =
  (typeof ListAttributeKeysStatus)[keyof typeof ListAttributeKeysStatus];

export const ListAttributeKeysStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListHsnCodesParams = {
  spaceId?: number;
  status?: ListHsnCodesStatus;
};

export type ListHsnCodesStatus =
  (typeof ListHsnCodesStatus)[keyof typeof ListHsnCodesStatus];

export const ListHsnCodesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListChargeTypesParams = {
  spaceId?: number;
  status?: ListChargeTypesStatus;
};

export type ListChargeTypesStatus =
  (typeof ListChargeTypesStatus)[keyof typeof ListChargeTypesStatus];

export const ListChargeTypesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListExpenseTemplatesParams = {
  status?: ListExpenseTemplatesStatus;
};

export type ListExpenseTemplatesStatus =
  (typeof ListExpenseTemplatesStatus)[keyof typeof ListExpenseTemplatesStatus];

export const ListExpenseTemplatesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type GenerateExpenseDues200 = {
  created: number;
};

export type ListExpenseEntriesParams = {
  status?: ListExpenseEntriesStatus;
  templateId?: number;
};

export type ListExpenseEntriesStatus =
  (typeof ListExpenseEntriesStatus)[keyof typeof ListExpenseEntriesStatus];

export const ListExpenseEntriesStatus = {
  Due: "Due",
  Paid: "Paid",
} as const;

export type ListAttributeValuesParams = {
  spaceId?: number;
  attributeKeyId?: number;
  status?: ListAttributeValuesStatus;
};

export type ListAttributeValuesStatus =
  (typeof ListAttributeValuesStatus)[keyof typeof ListAttributeValuesStatus];

export const ListAttributeValuesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListItemVariantsParams = {
  status?: ListItemVariantsStatus;
};

export type ListItemVariantsStatus =
  (typeof ListItemVariantsStatus)[keyof typeof ListItemVariantsStatus];

export const ListItemVariantsStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

export type ListItemModifiersParams = {
  status?: ListItemModifiersStatus;
};

export type ListItemModifiersStatus =
  (typeof ListItemModifiersStatus)[keyof typeof ListItemModifiersStatus];

export const ListItemModifiersStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListVendorItemPricingParams = {
  itemId?: number;
  vendorId?: number;
  spaceId?: number;
  status?: ListVendorItemPricingStatus;
};

export type ListVendorItemPricingStatus =
  (typeof ListVendorItemPricingStatus)[keyof typeof ListVendorItemPricingStatus];

export const ListVendorItemPricingStatus = {
  Active: "Active",
  Expired: "Expired",
  Discontinued: "Discontinued",
} as const;

export type ListVendorItemPricingHistoryParams = {
  itemId: number;
};

export type ListInventoryPlansParams = {
  spaceId?: number;
  status?: ListInventoryPlansStatus;
};

export type ListInventoryPlansStatus =
  (typeof ListInventoryPlansStatus)[keyof typeof ListInventoryPlansStatus];

export const ListInventoryPlansStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListInventoryPlanPeriodsParams = {
  /**
   * When true, include status='Archived' rows. Default returns only Active rows.
   */
  includeArchived?: boolean;
};

export type LookupInventoryPlanPeriodParams = {
  /**
   * @minimum 1
   */
  periodValue: number;
  periodUnit: LookupInventoryPlanPeriodPeriodUnit;
  /**
   * @minimum 1
   */
  seats: number;
};

export type LookupInventoryPlanPeriodPeriodUnit =
  (typeof LookupInventoryPlanPeriodPeriodUnit)[keyof typeof LookupInventoryPlanPeriodPeriodUnit];

export const LookupInventoryPlanPeriodPeriodUnit = {
  Hour: "Hour",
  Day: "Day",
  Month: "Month",
} as const;

export type ToggleMembershipSundayAccessBody = {
  enabled: boolean;
};

export type ListPlanEntitlementsParams = {
  spaceId?: number;
  planId?: number;
  itemId?: number;
};

export type ListAccountsParams = {
  kind?: ListAccountsKind;
  status?: ListAccountsStatus;
  /**
   * Search by legalName or billingPhone
   */
  q?: string;
  /**
   * Optional filter to accounts in a specific space (AND-composed with the caller's space scope; non-admins passing another space's id get 0 rows).
   * @minimum 1
   */
  spaceId?: number;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListAccountsKind =
  (typeof ListAccountsKind)[keyof typeof ListAccountsKind];

export const ListAccountsKind = {
  member: "member",
  walk_in: "walk_in",
} as const;

export type ListAccountsStatus =
  (typeof ListAccountsStatus)[keyof typeof ListAccountsStatus];

export const ListAccountsStatus = {
  active: "active",
  merged: "merged",
} as const;

export type ListContactsParams = {
  /**
   * Search by contact fullName, phone, or account legalName
   */
  q?: string;
  accountId?: number;
  planId?: number;
  /**
   * Derived from EXISTS(memberships WHERE status='active'), NOT contacts.status
   */
  active?: ListContactsActive;
  /**
   * True = has an attendance session in the default ~30-day window
   */
  hasAttendance?: boolean;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListContactsActive =
  (typeof ListContactsActive)[keyof typeof ListContactsActive];

export const ListContactsActive = {
  active: "active",
  inactive: "inactive",
} as const;

export type DeleteAccountMembership200 = {
  ok?: boolean;
};

export type ReanchorAccountMembershipBody = {
  /**
   * New billing anchor. 1..31 — short months collapse to the month's last day (e.g. 31 in April → 30, 29 in Feb non-leap → 28).
   * @minimum 1
   * @maximum 31
   */
  billingCycleDay: number;
};

export type ReanchorAccountMembership200 = {
  ok?: boolean;
  billingCycleDay?: number;
  deletedPeriodCount?: number;
};

export type UpdatePeriodAmountBody = {
  /** @minimum 0 */
  amount: number;
};

export type UpdatePeriodAmount422 = {
  error?: string;
};

export type GenerateBundleInvoice422 = {
  code?: string;
  unpaidPeriodIds?: number[];
};

export type GetAccountDepositsParams = {
  /**
   * Return all deposits regardless of status. Default false (Held only).
   */
  includeAll?: boolean;
};

export type ListAccountCommunicationsParams = {
  channel?: ListAccountCommunicationsChannel;
  page?: number;
  pageSize?: number;
};

export type ListAccountCommunicationsChannel =
  (typeof ListAccountCommunicationsChannel)[keyof typeof ListAccountCommunicationsChannel];

export const ListAccountCommunicationsChannel = {
  whatsapp: "whatsapp",
  email: "email",
  sms: "sms",
} as const;

export type DeleteAccount409 = {
  code: string;
  blockers?: string[];
};

export type ListInventoryAuditLogParams = {
  spaceId?: number;
  tableName?: string;
  /**
   * Filter to a single record's history (pair with tableName).
   */
  recordId?: number;
  action?: AuditAction;
  actorUserId?: number;
  from?: string;
  to?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 500
   */
  pageSize?: number;
};

export type ListStockInParams = {
  spaceId?: number;
  /**
   * exact STK-IN id (receipt number)
   */
  id?: number;
  /**
   * derived lifecycle filter: Stocked = meets Save Stock-In gate; Draft = otherwise
   */
  stockStatus?: ListStockInStockStatus;
  vendorId?: number;
  /**
   * receipts whose line items include this item
   */
  itemId?: number;
  /**
   * receipts whose line items include an item in this category
   */
  categoryId?: number;
  transactionType?: StockInTransactionType;
  /**
   * receipts = all non-daily types; daily = Daily_Purchase only
   */
  group?: ListStockInGroup;
  /**
   * derived: completed = PDF uploaded; partial = number/date entered, no PDF; pending = nothing
   */
  invoiceStatus?: ListStockInInvoiceStatus;
  /**
   * transaction date >=
   */
  dateFrom?: string;
  /**
   * transaction date <=
   */
  dateTo?: string;
  /**
   * created_at >=
   */
  createdFrom?: string;
  /**
   * created_at <=
   */
  createdTo?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListStockInStockStatus =
  (typeof ListStockInStockStatus)[keyof typeof ListStockInStockStatus];

export const ListStockInStockStatus = {
  Stocked: "Stocked",
  Draft: "Draft",
} as const;

export type ListStockInGroup =
  (typeof ListStockInGroup)[keyof typeof ListStockInGroup];

export const ListStockInGroup = {
  receipts: "receipts",
  daily: "daily",
} as const;

export type ListStockInInvoiceStatus =
  (typeof ListStockInInvoiceStatus)[keyof typeof ListStockInInvoiceStatus];

export const ListStockInInvoiceStatus = {
  pending: "pending",
  partial: "partial",
  completed: "completed",
} as const;

export type GetStockInSummaryParams = {
  /**
   * ISO datetime — period start
   */
  dateFrom: string;
  /**
   * ISO datetime — period end (inclusive)
   */
  dateTo: string;
  spaceId?: number;
};

export type ListStockInOrdersParams = {
  spaceId?: number;
  status?: StockInOrderStatus;
  vendorId?: number;
  /**
   * Orders whose cart lines include this item
   */
  itemId?: number;
  /**
   * Derived: Not_Paid | Partial | Paid (from prepaid vs order total, ±1 INR slack)
   */
  paymentStatus?: ListStockInOrdersPaymentStatus;
  /**
   * Online (Quick_Commerce/Online_Marketplace) | Offline (Regular/One_Time) | Service
   */
  vendorNature?: ListStockInOrdersVendorNature;
  /**
   * created_at >=
   */
  dateFrom?: string;
  /**
   * created_at <=
   */
  dateTo?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListStockInOrdersPaymentStatus =
  (typeof ListStockInOrdersPaymentStatus)[keyof typeof ListStockInOrdersPaymentStatus];

export const ListStockInOrdersPaymentStatus = {
  Not_Paid: "Not_Paid",
  Partial: "Partial",
  Paid: "Paid",
} as const;

export type ListStockInOrdersVendorNature =
  (typeof ListStockInOrdersVendorNature)[keyof typeof ListStockInOrdersVendorNature];

export const ListStockInOrdersVendorNature = {
  Online: "Online",
  Offline: "Offline",
  Service: "Service",
} as const;

export type ListStockOutParams = {
  spaceId?: number;
  itemId?: number;
  /**
   * filter by the item's category
   */
  categoryId?: number;
  /**
   * Deprecated alias for accountId. Either is accepted.
   */
  memberId?: number;
  accountId?: number;
  contactId?: number;
  consumptionType?: StockOutConsumptionType;
  /**
   * comma-separated consumption types (general/refills groups)
   */
  consumptionTypes?: string;
  /**
   * comma-separated item charging models (with-limit/pay-per-use groups)
   */
  chargingModels?: string;
  /**
   * transaction date >=
   */
  dateFrom?: string;
  /**
   * transaction date <=
   */
  dateTo?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type DeleteStockOut200 = {
  deleted: boolean;
  id: number;
};

export type MarkStockOutBulkPaidBody = UpdateStockOutBody & {
  /**
   * Stock_Out row ids to settle. De-duplicated server-side; space-scoped.
   * @minItems 1
   */
  stockOutIds: number[];
};

export type MarkStockOutBulkPaid200 = {
  /** Rows updated */
  updated: number;
  /** The stock_out ids that were actually updated */
  ids: number[];
};

export type MarkStockOutCartPaid200 = {
  /** Count of rows updated. */
  updated: number;
};

export type ListDailyOrderScheduleParams = {
  spaceId?: number;
  itemId?: number;
  status?: string;
};

export type GetDailyOrdersTodayParams = {
  spaceId?: number;
};

export type GetOperationsAlertsParams = {
  spaceId?: number;
  tier?: AlertTier;
};

export type GetOperationsQcBudgetParams = {
  spaceId?: number;
};

export type ListMemberEntitlementsParams = {
  spaceId?: number;
  memberId?: number;
  itemId?: number;
  status?: string;
  activeOnly?: boolean;
};

export type ListMemberChargesParams = {
  spaceId?: number;
  memberId?: number;
  status?: MemberChargeStatus;
  billingCycle?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListAttendanceSessionsParams = {
  spaceId?: number;
  accountId?: number;
  contactId?: number;
  status?: AttendanceSessionStatus;
  dateFrom?: string;
  dateTo?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListAttendanceDevicesParams = {
  spaceId?: number;
};

export type GetAttendancePunchLogParams = {
  dateFrom?: string;
  dateTo?: string;
  spaceId?: number;
};

export type GetAttendanceRosterParams = {
  date?: string;
  spaceId?: number;
};

export type GetStaffAttendanceDayParams = {
  date?: string;
  spaceId?: number;
};

export type ListBillingTodayParams = {
  spaceId?: number;
};

export type ListInvoicesParams = {
  spaceId?: number;
  memberId?: number;
  status?: InvoiceStatus;
  dateFrom?: string;
  dateTo?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListOrderReceiptsParams = {
  status?: ListOrderReceiptsStatus;
  /**
   * Not-fully-paid receipts whose reminder/period start is in the past
   */
  overdue?: boolean;
  /**
   * Scope to receipts whose billing cycle STARTS in this IST calendar month (YYYY-MM), plus any overdue receipt regardless of start month. Omit for all months.
   * @pattern ^\d{4}-\d{2}$
   */
  month?: string;
  /**
   * Search by account name or receipt number
   */
  q?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListOrderReceiptsStatus =
  (typeof ListOrderReceiptsStatus)[keyof typeof ListOrderReceiptsStatus];

export const ListOrderReceiptsStatus = {
  Unpaid: "Unpaid",
  Partial: "Partial",
  Paid: "Paid",
} as const;

export type GetPlanCoverageGapsParams = {
  spaceId?: number;
};

export type ListResourcePricingParams = {
  planId?: number;
  cadence?: ResourcePricingCadence;
  status?: ResourcePricingStatus;
};

export type CreateBooking201 = {
  data: MemberCharge;
  conflicts: BookingConflict[];
};

export type ListInfraCategoriesParams = {
  status?: ListInfraCategoriesStatus;
};

export type ListInfraCategoriesStatus =
  (typeof ListInfraCategoriesStatus)[keyof typeof ListInfraCategoriesStatus];

export const ListInfraCategoriesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListInfraItemsParams = {
  status?: ListInfraItemsStatus;
  pricingModel?: ListInfraItemsPricingModel;
};

export type ListInfraItemsStatus =
  (typeof ListInfraItemsStatus)[keyof typeof ListInfraItemsStatus];

export const ListInfraItemsStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListInfraItemsPricingModel =
  (typeof ListInfraItemsPricingModel)[keyof typeof ListInfraItemsPricingModel];

export const ListInfraItemsPricingModel = {
  Unit: "Unit",
  Measurement: "Measurement",
  Setup_Work: "Setup_Work",
} as const;

export type ListInfraWarrantyParams = {
  view?: ListInfraWarrantyView;
};

export type ListInfraWarrantyView =
  (typeof ListInfraWarrantyView)[keyof typeof ListInfraWarrantyView];

export const ListInfraWarrantyView = {
  expiring_soon: "expiring_soon",
  expired: "expired",
  all: "all",
} as const;

export type ListInfraAcquisitionsParams = {
  itemId?: number;
  paymentStatus?: ListInfraAcquisitionsPaymentStatus;
};

export type ListInfraAcquisitionsPaymentStatus =
  (typeof ListInfraAcquisitionsPaymentStatus)[keyof typeof ListInfraAcquisitionsPaymentStatus];

export const ListInfraAcquisitionsPaymentStatus = {
  Paid: "Paid",
  Partially_Paid: "Partially_Paid",
  Pending: "Pending",
} as const;

export type ListInfraAttributeKeysParams = {
  status?: ListInfraAttributeKeysStatus;
};

export type ListInfraAttributeKeysStatus =
  (typeof ListInfraAttributeKeysStatus)[keyof typeof ListInfraAttributeKeysStatus];

export const ListInfraAttributeKeysStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListInfraAttributeValuesParams = {
  attributeKeyId?: number;
  status?: ListInfraAttributeValuesStatus;
};

export type ListInfraAttributeValuesStatus =
  (typeof ListInfraAttributeValuesStatus)[keyof typeof ListInfraAttributeValuesStatus];

export const ListInfraAttributeValuesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type ListInfraItemVariantsParams = {
  status?: ListInfraItemVariantsStatus;
};

export type ListInfraItemVariantsStatus =
  (typeof ListInfraItemVariantsStatus)[keyof typeof ListInfraItemVariantsStatus];

export const ListInfraItemVariantsStatus = {
  Active: "Active",
  Discontinued: "Discontinued",
} as const;

/**
 * Optional projection payload (clusters + resources). Client should send whatever computeProjection() returned for the current scene.
 */
export type ApproveSpaceFloorDesignBodyProjection = { [key: string]: unknown };

export type ApproveSpaceFloorDesignBody = {
  /** Optional projection payload (clusters + resources). Client should send whatever computeProjection() returned for the current scene. */
  projection?: ApproveSpaceFloorDesignBodyProjection;
};

export type DiscardSpaceFloorDesign200 = {
  ok: boolean;
};

export type ListSpaceResourcesParams = {
  floorId?: number;
  resourceType?: ListSpaceResourcesResourceType;
  unitKind?: ListSpaceResourcesUnitKind;
};

export type ListSpaceResourcesResourceType =
  (typeof ListSpaceResourcesResourceType)[keyof typeof ListSpaceResourcesResourceType];

export const ListSpaceResourcesResourceType = {
  Workstation: "Workstation",
  Private_Cabin: "Private_Cabin",
  Meeting_Room: "Meeting_Room",
  Conference_Room: "Conference_Room",
  Bay: "Bay",
  Cafeteria: "Cafeteria",
  Reception: "Reception",
  Washroom_Female: "Washroom_Female",
  Washroom_Male: "Washroom_Male",
  Store_Room: "Store_Room",
  Washbasin: "Washbasin",
  Pantry: "Pantry",
} as const;

export type ListSpaceResourcesUnitKind =
  (typeof ListSpaceResourcesUnitKind)[keyof typeof ListSpaceResourcesUnitKind];

export const ListSpaceResourcesUnitKind = {
  assignable: "assignable",
  amenity: "amenity",
  bookable: "bookable",
} as const;

export type UpdateSpaceWorkstationCluster200 = {
  cluster: SpaceWorkstationCluster;
  dx: number;
  dy: number;
};

export type ListSpaceWorkstationClustersParams = {
  floorId: number;
};

export type ListResourceAssignmentsParams = {
  resourceId?: number;
  date?: string;
};

export type GetSpaceOccupancyParams = {
  floorId: number;
  /**
   * ISO date (YYYY-MM-DD); defaults to today
   */
  date?: string;
  /**
   * Point-in-time for room slot occupancy; defaults to now
   */
  at?: string;
};

export type ListPublicPlansParams = {
  spaceId: number;
};

export type ListPublicPlans200 = {
  plans: PublicPlan[];
};

export type ListTasksParams = {
  /**
   * Exact task_number (NJF-T-00147) or a bare seq (147)
   */
  number: string;
};

export type ListTaskCategoriesParams = {
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type ListSlaPoliciesParams = {
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type ListRoutingRulesParams = {
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type ListEscalationRulesParams = {
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type GetBusinessHoursParams = {
  /**
   * Admin-only override; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type ListTaskTemplatesParams = {
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type GetDailyChecklistParams = {
  /**
   * YYYY-MM-DD; defaults to today IST
   */
  date?: string;
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type GetEventChecklistParams = {
  /**
   * Which event tab is requesting its feed
   */
  trigger: GetEventChecklistTrigger;
  /**
   * Admin-only filter; non-admins are always scoped to their own space
   */
  spaceId?: number;
};

export type GetEventChecklistTrigger =
  (typeof GetEventChecklistTrigger)[keyof typeof GetEventChecklistTrigger];

export const GetEventChecklistTrigger = {
  onboarding: "onboarding",
  exit: "exit",
} as const;

export type ListVendorBillsParams = {
  status?: VendorBillStatus;
  vendorId?: number;
  /**
   * bill date >=
   */
  from?: string;
  /**
   * bill date <=
   */
  to?: string;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  pageSize?: number;
};

export type ListVendorBillSchedulesParams = {
  status?: ListVendorBillSchedulesStatus;
};

export type ListVendorBillSchedulesStatus =
  (typeof ListVendorBillSchedulesStatus)[keyof typeof ListVendorBillSchedulesStatus];

export const ListVendorBillSchedulesStatus = {
  Active: "Active",
  Archived: "Archived",
} as const;

export type GetLedgerTrialBalanceParams = {
  from: string;
  to: string;
  locationId?: number;
  costCentreId?: number;
};

export type GetLedgerAccountEntriesParams = {
  from?: string;
  to?: string;
};

export type GetLedgerApByVendorParams = {
  asOf?: string;
};

export type GetLedgerPnlParams = {
  from: string;
  to: string;
  groupBy: PnlGroupBy;
};

export type ListPostingExceptionsParams = {
  resolved?: boolean;
};

export type ListLedgerAccountsParams = {
  type?: ListLedgerAccountsType;
  active?: boolean;
};

export type ListLedgerAccountsType =
  (typeof ListLedgerAccountsType)[keyof typeof ListLedgerAccountsType];

export const ListLedgerAccountsType = {
  asset: "asset",
  liability: "liability",
  equity: "equity",
  income: "income",
  expense: "expense",
} as const;

export type ListPrepaidSchedulesParams = {
  status?: ListPrepaidSchedulesStatus;
};

export type ListPrepaidSchedulesStatus =
  (typeof ListPrepaidSchedulesStatus)[keyof typeof ListPrepaidSchedulesStatus];

export const ListPrepaidSchedulesStatus = {
  active: "active",
  completed: "completed",
  cancelled: "cancelled",
} as const;

export type GetStockDayCloseOverdueParams = {
  spaceId?: number;
};

export type GetStockDayCloseParams = {
  spaceId?: number;
};

export type ListStockLocationsParams = {
  spaceId?: number;
};

export type GetStockLocationBalancesParams = {
  itemId: number;
};

export type ListStockLocationTransfersParams = {
  itemId?: number;
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 500
   */
  pageSize?: number;
};
